// Generated by js_of_ocaml
//# buildInfo:effects=disabled, kind=exe, use-js-string=true, version=6.2.0
(function(a){typeof
globalThis!=="object"&&(this?b():(a.defineProperty(a.prototype,"_T_",{configurable:true,get:b}),_T_));function
b(){var
b=this||self;b.globalThis=b;delete
a.prototype._T_}}(Object));(function(a){require("@event-calendar/core/index.css")}(globalThis));(function(d){"use strict";var
nd="ENFILE",a="web2/vendor/lwd/lib/lwd/lwd.ml",mu="number",c=248,ba=24029,lO=12520,X=0xff,lN="Expected ",nc="ENOSYS",nb=858694086,na="Match_failure",em="name",k9="EMLINK",mt="EINPROGRESS",lM="volunteers",ms="write",m$="%ni",au=244,k8="EDESTADDRREQ",gr=0x7ff00000,lL="ENOEXEC",gy=", characters ",k7=" doesn't exist",mr=365,d9=0x7c00,k6="@<0>",b7="+",d8="<v1>",lK=238,gI=">",gq="member ",mq="end",m_="float",W=246,mp=0x3f,gp=512,lJ="start",k5="EACCES",V=0xffffff,bF="id",$="web2/vendor/lwd/lib/lwd/lwd_seq.pp.ml",gH="nan",lI=534093354,mo="Not_found",mn=-12,el="EEXIST",gx="open",lH="ECONNABORTED",k4="ENOTTY",lG="Division_by_zero",k3="js_of_ocaml",go="e",ml="@{",mm="EDEADLK",gG="jsError",mk="EDOM",lF=104,cS="invalid argument",lE="ENOTSOCK",k2="ENOLCK",lD="ECONNREFUSED",eh="Unix.Unix_error",m9="\\t",d7=254,mj=2440587.5,a1=".",m8=0x80000000,lA="input",lB="Undefined_recursive_module",lC="EHOSTDOWN",gn="mkdir",m7=" but found ",lz="EAFNOSUPPORT",b8=153,ef="ESPIPE",ly="EIO",mi="class",b5="@,",gm=103,b4=127,mh="Sys_error",cR=100,gw="all",mg=65504,m6="ENOMEM",m5="ENETDOWN",k1=1582,mf="OCAMLRUNPARAM",m4="ENOSPC",d6=86400.,gl="ENOTEMPTY",cQ="ENOTDIR",md="ENOTCONN",me="EPIPE",m3="E2BIG",a0="-",at=250,lx="src/ISO8601_lexer.mll",kZ="Pervasives.do_at_exit",k0=0x7f800000,cX="node:fs",cZ=128,d5="lseek",gk="ignore",kY="EMFILE",az="<v>",lw="%u",mc="EPFNOSUPPORT",kX="%Li",ek="Map.bal",lv="object",mb="Sys_blocked_io",m2="EFAULT",K="camlinternalFormat.ml",gj="%a",lu="null",ma="%02i:%02i",gA="src/jsont.ml",kW=3268,lt=2147483647,cU="Int64.of_string",m0="\\r",m1=0x000000,l$=0.0009765625,kV=-529517673,ee="int_of_string",mZ=32082,am="0",ls="EWOULDBLOCK",l_="ETIMEDOUT",mY="file already exists",kU="append",mX="Lwd_seq.rank: node is marked",l8="value",gz="int64",l9="error",kT="p",ed="no such file or directory",lr="ECHILD",cY=": ",bD=1024,gi=255,lq=0xfc00,ei='File "',ej=1900,kS="ESHUTDOWN",lp=116,kQ="ENETRESET",kR="ENODEV",mW=0.5,mV="EFBIG",ar=0xffff,mU="ERANGE",ec='"',mT="EPROTOTYPE",d4="lwd-to-remove",gF="Fatal error: exception ",l7="EADDRNOTAVAIL",aH=0x8000,bC="EBADF",mS='", ',eb=1461,cT="bad file descriptor",l6="_",cW=3600,mR="illegal seek",lo="ENAMETOOLONG",ln="0x",l5="([^/]+)",aq=1000,gu="rmdir",gv="compare: functional value",ea="%d",kP="EROFS",kO="@;",b6=3850876,mQ=122,gh="OCaml int",l4="string",lm="ENETUNREACH",ll="illegal operation on a directory",l3="EINTR",kN=4096,gt="@ ",aR=0x100,li=-65,lj="lexing: empty token",lk="readdir",kM="ENXIO",d$=146097,mP="EADDRINUSE",mN="web2/vendor/lwd/lib/brr-lwd/elwd.ml",mO="ELOOP",bB=", ",lh="EALREADY",l2="\\\\",mL=86400,mM="style",bE="EINVAL",lg="ESRCH",kL="EXDEV",kK="%li",lf="Obj.extension_constructor",d_="EISDIR",l1="\\n",mK="EOVERFLOW",mJ="%Y-%M-%DT%h:%m:%s",d3="_bigarr02",mI="@[%a@]",mH="Assert_failure",kJ="src/time_Zone.ml",kH=" range",kI="EAGAIN",gE="title",le=120,ld=" of",kG="^",mG="EOPNOTSUPP",kF="EBUSY",kE=0x0400,kD="Expected %a but found %a",l0="b",mF=3600.,kC=2147483647.,lX="text",lY="Stack_overflow",lZ="Invalid_argument",mE="@[",kB="ECONNRESET",lc=0x7fffffff,lW="End_of_file",kA="read",kz=" not in ",mD="ENOPROTOOPT",gD="index out of bounds",b3="ENOENT",cV=252,gC="Failure",d2=-97,gs="win32",ky=86400000,aQ="/",mC="ESOCKTNOSUPPORT",kx="EISCONN",lV="Out_of_memory",aP=256,eg=-48,lU="EHOSTUNREACH",as=" ",gB=1255,lb="EMSGSIZE",mB="ENOBUFS",la=-2147483648.,kw="Printexc.handle_uncaught_exception",mA="truncate",k$="user",lT="EPERM",mz="/static/",my="infinity",k_="fd ",mx="Fatal error: exception %s\n",lS="not a directory",mw="EPROTONOSUPPORT",lR=32044,lQ="%i",e="",lP="zero",mv="ETOOMANYREFS";function
zj(a,b,c,d,e){if(d<=b)for(var
f=1;f<=e;f++)c[d+f]=a[b+f];else
for(var
f=e;f>=1;f--)c[d+f]=a[b+f];return 0}var
nY={};function
nZ(a){if(nY[a])return nY[a];var
b=d.process;if(b&&b.env&&b.env[a]!==undefined)return b.env[a];if(d.jsoo_env&&typeof
d.jsoo_env[a]==="string")return d.jsoo_env[a]}var
eF=0;(function(){var
c=nZ(mf);if(c!==undefined){var
b=c.split(",");for(var
a=0;a<b.length;a++)if(b[a]===l0){eF=1;break}else if(b[a].startsWith("b="))eF=+b[a].slice(2);else
continue}}());var
Am=eF,N=[0];function
zA(a,b){if(!a.js_error||b||a[0]===c)a.js_error=new
d.Error("Js exception containing backtrace");return a}function
h(a,b){return eF&&Am?zA(a,b):a}function
nP(a,b){throw h([0,a,b])}function
a4(a){return a}function
nR(a,b){nP(a,a4(b))}function
H(a){nR(N.Invalid_argument,a)}function
c0(){H(gD)}function
aI(a,b){if(a>>>0>=(lc/4|0))c0();var
a=a+1|0,c=new
Array(a);c[0]=0;for(var
d=1;d<a;d++)c[d]=b;return c}function
zk(a,b,c){var
d=new
Array(c+1);d[0]=0;for(var
e=1,f=b+1;e<=c;e++,f++)d[e]=a[f];return d}function
eo(a,b,c){if(a[1]===b){a[1]=c;return 1}return 0}function
zl(a,b){var
c=a[1];a[1]+=b;return c}function
bc(a){return a[1]}function
nm(a){switch(a){case
7:case
10:case
11:return 2;default:return 1}}function
nk(a,b){var
c;switch(a){case
0:c=Float32Array;break;case
1:c=Float64Array;break;case
2:c=Int8Array;break;case
3:c=Uint8Array;break;case
4:c=Int16Array;break;case
5:c=Uint16Array;break;case
6:c=Int32Array;break;case
7:c=Int32Array;break;case
8:c=Int32Array;break;case
9:c=Int32Array;break;case
10:c=Float32Array;break;case
11:c=Float64Array;break;case
12:c=Uint8Array;break;case
13:c=Uint16Array;break}if(!c)H("Bigarray.create: unsupported kind");var
d=new
c(b*nm(a));return d}function
ep(a){var
d=a.length,c=1;for(var
b=0;b<d;b++){if(a[b]<0)H("Bigarray.create: negative dimension");c=c*a[b]}return c}var
nM=function(){const
d=1/Number.EPSILON;function
k(a){return a+d-d}const
g=6.103515625e-5,j=mg,a=l$,f=a*g,i=a*d;function
l(a){const
b=+a;if(!Number.isFinite(b)||b===0)return b;const
e=b>0?1:-1,c=Math.abs(b);if(c<g)return e*k(c/f)*f;const
h=(1+i)*c,d=h-(h-c);if(d>j||Number.isNaN(d))return e*Number.POSITIVE_INFINITY;return e*d}const
b=new
Uint16Array(gp),c=new
Uint8Array(gp);for(let
a=0;a<aP;++a){const
d=a-b4;if(d<-24){b[a]=0x0000;b[a|aR]=aH;c[a]=24;c[a|aR]=24}else if(d<-14){b[a]=kE>>-d-14;b[a|aR]=kE>>-d-14|aH;c[a]=-d-1;c[a|aR]=-d-1}else if(d<=15){b[a]=d+15<<10;b[a|aR]=d+15<<10|aH;c[a]=13;c[a|aR]=13}else if(d<cZ){b[a]=d9;b[a|aR]=lq;c[a]=24;c[a|aR]=24}else{b[a]=d9;b[a|aR]=lq;c[a]=13;c[a|aR]=13}}const
e=new
ArrayBuffer(4),h=new
Float32Array(e),m=new
Uint32Array(e);return function(a){h[0]=l(a);const
e=m[0],d=e>>23&0x1ff;return b[d]+((e&0x007fffff)>>c[d])}}(),g_=function(){var
h=Math.pow,e=31,i=1023,f=h(2,-24),g=l$;return function(a){var
d=a>>>15,c=a>>>10&e,b=a&i;if(c===e)return b===0?d===0?Number.POSITIVE_INFINITY:Number.NEGATIVE_INFINITY:Number.NaN;if(c===0)return b*(d===0?f:-f);var
j=h(2,c-15)*(d===0?1+b*g:-1-b*g);return j}}(),c6=Math.pow(2,-24);function
nO(a){throw a}function
nS(){nO(N.Division_by_zero)}class
q{constructor(a,b,c){this.lo=a&V;this.mi=b&V;this.hi=c&ar;this.caml_custom="_j"}static
UNSIGNED_MAX=new
q(V,V,ar);static
SIGNED_MAX=new
q(V,V,0x7fff);static
SIGNED_MIN=new
q(m1,m1,aH);slice(){return new
q(this.lo,this.mi,this.hi)}ucompare(a){if(this.hi>a.hi)return 1;if(this.hi<a.hi)return-1;if(this.mi>a.mi)return 1;if(this.mi<a.mi)return-1;if(this.lo>a.lo)return 1;if(this.lo<a.lo)return-1;return 0}compare(a){var
b=this.hi<<16,c=a.hi<<16;if(b>c)return 1;if(b<c)return-1;if(this.mi>a.mi)return 1;if(this.mi<a.mi)return-1;if(this.lo>a.lo)return 1;if(this.lo<a.lo)return-1;return 0}neg(){var
a=-this.lo,b=-this.mi+(a>>24),c=-this.hi+(b>>24);return new
q(a,b,c)}add(a){var
b=this.lo+a.lo,c=this.mi+a.mi+(b>>24),d=this.hi+a.hi+(c>>24);return new
q(b,c,d)}sub(a){var
b=this.lo-a.lo,c=this.mi-a.mi+(b>>24),d=this.hi-a.hi+(c>>24);return new
q(b,c,d)}mul(a){var
b=this.lo*a.lo,c=(b*c6|0)+this.mi*a.lo+this.lo*a.mi,d=(c*c6|0)+this.hi*a.lo+this.mi*a.mi+this.lo*a.hi;return new
q(b,c,d)}isZero(){return(this.lo|this.mi|this.hi)===0}isNeg(){return this.hi<<16<0}and(a){return new
q(this.lo&a.lo,this.mi&a.mi,this.hi&a.hi)}or(a){return new
q(this.lo|a.lo,this.mi|a.mi,this.hi|a.hi)}xor(a){return new
q(this.lo^a.lo,this.mi^a.mi,this.hi^a.hi)}shift_left(a){a=a&63;if(a===0)return this;if(a<24)return new
q(this.lo<<a,this.mi<<a|this.lo>>24-a,this.hi<<a|this.mi>>24-a);if(a<48)return new
q(0,this.lo<<a-24,this.mi<<a-24|this.lo>>48-a);return new
q(0,0,this.lo<<a-48)}shift_right_unsigned(a){a=a&63;if(a===0)return this;if(a<24)return new
q(this.lo>>a|this.mi<<24-a,this.mi>>a|this.hi<<24-a,this.hi>>a);if(a<48)return new
q(this.mi>>a-24|this.hi<<48-a,this.hi>>a-24,0);return new
q(this.hi>>a-48,0,0)}shift_right(a){a=a&63;if(a===0)return this;var
c=this.hi<<16>>16;if(a<24)return new
q(this.lo>>a|this.mi<<24-a,this.mi>>a|c<<24-a,this.hi<<16>>a>>>16);var
b=this.hi<<16>>31;if(a<48)return new
q(this.mi>>a-24|this.hi<<48-a,this.hi<<16>>a-24>>16,b&ar);return new
q(this.hi<<16>>a-32,b,b)}lsl1(){this.hi=this.hi<<1|this.mi>>23;this.mi=(this.mi<<1|this.lo>>23)&V;this.lo=this.lo<<1&V}lsr1(){this.lo=(this.lo>>>1|this.mi<<23)&V;this.mi=(this.mi>>>1|this.hi<<23)&V;this.hi=this.hi>>>1}udivmod(a){var
d=0,c=this.slice(),b=a.slice(),e=new
q(0,0,0);while(c.ucompare(b)>0){d++;b.lsl1()}while(d>=0){d--;e.lsl1();if(c.ucompare(b)>=0){e.lo++;c=c.sub(b)}b.lsr1()}return{quotient:e,modulus:c}}div(a){var
b=this;if(a.isZero())nS();var
d=b.hi^a.hi;if(b.hi&aH)b=b.neg();if(a.hi&aH)a=a.neg();var
c=b.udivmod(a).quotient;if(d&aH)c=c.neg();return c}mod(a){var
b=this;if(a.isZero())nS();var
d=b.hi;if(b.hi&aH)b=b.neg();if(a.hi&aH)a=a.neg();var
c=b.udivmod(a).modulus;if(d&aH)c=c.neg();return c}toInt(){return this.lo|this.mi<<24}toFloat(){return(this.hi<<16)*Math.pow(2,32)+this.mi*Math.pow(2,24)+this.lo}toArray(){return[this.hi>>8,this.hi&X,this.mi>>16,this.mi>>8&X,this.mi&X,this.lo>>16,this.lo>>8&X,this.lo&X]}lo32(){return this.lo|(this.mi&X)<<24}hi32(){return this.mi>>>8&ar|this.hi<<16}}function
zO(a,b){return new
q(a&V,a>>>24&X|(b&ar)<<8,b>>>16&ar)}function
gT(a){return a.hi32()}function
gU(a){return a.lo32()}var
zn=d3;class
ni{constructor(a,b,c,d){this.kind=a;this.layout=b;this.dims=c;this.data=d;this.caml_custom=zn}offset(a){var
c=0;if(typeof
a==="number")a=[a];if(!Array.isArray(a))H("bigarray.js: invalid offset");if(this.dims.length!==a.length)H("Bigarray.get/set: bad number of dimensions");if(this.layout===0)for(var
b=0;b<this.dims.length;b++){if(a[b]<0||a[b]>=this.dims[b])c0();c=c*this.dims[b]+a[b]}else
for(var
b=this.dims.length-1;b>=0;b--){if(a[b]<1||a[b]>this.dims[b])c0();c=c*this.dims[b]+(a[b]-1)}return c}get(a){switch(this.kind){case
7:var
d=this.data[a*2+0],b=this.data[a*2+1];return zO(d,b);case
10:case
11:var
e=this.data[a*2+0],c=this.data[a*2+1];return[d7,e,c];case
13:return g_(this.data[a]);default:return this.data[a]}}set(a,b){switch(this.kind){case
7:this.data[a*2+0]=gU(b);this.data[a*2+1]=gT(b);break;case
10:case
11:this.data[a*2+0]=b[1];this.data[a*2+1]=b[2];break;case
13:this.data[a]=nM(b);break;default:this.data[a]=b;break}return 0}fill(a){switch(this.kind){case
7:var
c=gU(a),e=gT(a);if(c===e)this.data.fill(c);else
for(var
b=0;b<this.data.length;b++)this.data[b]=b%2===0?c:e;break;case
10:case
11:var
d=a[1],f=a[2];if(d===f)this.data.fill(d);else
for(var
b=0;b<this.data.length;b++)this.data[b]=b%2===0?d:f;break;case
13:this.data.fill(nM(a));break;default:this.data.fill(a);break}}compare(a,b){if(this.layout!==a.layout||this.kind!==a.kind){var
h=this.kind|this.layout<<8,i=a.kind|a.layout<<8;return i-h}if(this.dims.length!==a.dims.length)return a.dims.length-this.dims.length;for(var
c=0;c<this.dims.length;c++)if(this.dims[c]!==a.dims[c])return this.dims[c]<a.dims[c]?-1:1;switch(this.kind){case
0:case
1:case
10:case
11:var
d,e;for(var
c=0;c<this.data.length;c++){d=this.data[c];e=a.data[c];if(d<e)return-1;if(d>e)return 1;if(d!==e){if(!b)return Number.NaN;if(!Number.isNaN(d))return 1;if(!Number.isNaN(e))return-1}}break;case
7:for(var
c=0;c<this.data.length;c+=2){if(this.data[c+1]<a.data[c+1])return-1;if(this.data[c+1]>a.data[c+1])return 1;if(this.data[c]>>>0<a.data[c]>>>0)return-1;if(this.data[c]>>>0>a.data[c]>>>0)return 1}break;case
13:for(var
c=0;c<this.data.length;c++){var
f=g_(this.data[c]),g=g_(a.data[c]);if(f<g)return-1;if(f>g)return 1}break;case
2:case
3:case
4:case
5:case
6:case
8:case
9:case
12:for(var
c=0;c<this.data.length;c++){if(this.data[c]<a.data[c])return-1;if(this.data[c]>a.data[c])return 1}break}return 0}}class
zf
extends
ni{offset(a){if(typeof
a!=="number")if(Array.isArray(a)&&a.length===1)a=a[0];else
H("Ml_Bigarray_c_1_1.offset");if(a<0||a>=this.dims[0])c0();return a}get(a){return this.data[a]}set(a,b){this.data[a]=b;return 0}fill(a){this.data.fill(a);return 0}}function
gK(a,b,c,d){var
e=nm(a);if(ep(c)*e!==d.length)H("length doesn't match dims");if(b===0&&c.length===1&&e===1&&a!==13)return new
zf(a,b,c,d);return new
ni(a,b,c,d)}function
nG(a){return a.slice(1)}function
zm(a,b,c){var
d=nG(c),e=nk(a,ep(d));return gK(a,b,d,e)}function
c1(a,b,c){a.set(a.offset(b),c);return 0}function
c8(a,b,c){var
d=String.fromCharCode;if(b===0&&c<=kN&&c===a.length)return d.apply(null,a);var
f=e;for(;0<c;b+=bD,c-=bD)f+=d.apply(null,a.subarray(b,b+Math.min(c,bD)));return f}function
et(a){var
c=new
Uint8Array(a.l),e=a.c,d=e.length,b=0;for(;b<d;b++)c[b]=e.charCodeAt(b);for(d=a.l;b<d;b++)c[b]=0;a.c=c;a.t=4;return c}function
a2(a,b,c,d,e){if(e===0)return 0;if(d===0&&(e>=c.l||c.t===2&&e>=c.c.length)){c.c=a.t===4?c8(a.c,b,e):b===0&&a.c.length===e?a.c:a.c.slice(b,b+e);c.t=c.c.length===c.l?0:2}else if(c.t===2&&d===c.c.length){c.c+=a.t===4?c8(a.c,b,e):b===0&&a.c.length===e?a.c:a.c.slice(b,b+e);c.t=c.c.length===c.l?0:2}else{if(c.t!==4)et(c);var
g=a.c,h=c.c;if(a.t===4)if(d<=b)for(var
f=0;f<e;f++)h[d+f]=g[b+f];else
for(var
f=e-1;f>=0;f--)h[d+f]=g[b+f];else{var
i=Math.min(e,g.length-b);for(var
f=0;f<i;f++)h[d+f]=g.charCodeAt(b+f);for(;f<e;f++)h[d+f]=0}}return 0}var
n0=new
TextDecoder();function
eI(a){if(a.t!==4)et(a);return a.c}function
bf(a,b){return b.repeat(a)}function
c2(a){if(a.t===2)a.c+=bf(a.l-a.c.length,"\0");else
a.c=c8(a.c,0,a.c.length);a.t=0}function
ha(a){if(a.length<24){for(var
b=0;b<a.length;b++)if(a.charCodeAt(b)>b4)return false;return true}else
return!/[^\x00-\x7f]/.test(a)}class
bG{constructor(a,b,c){this.t=a;this.c=b;this.l=c}toString(){switch(this.t){case
9:case
8:return this.c;case
4:case
2:c2(this);case
0:if(ha(this.c))this.t=9;else
this.t=8;return this.c}}toUtf16(){if(this.t===9)return this.c;var
a=eI(this);return n0.decode(a)}slice(){var
a=this.t===4?this.c.slice():this.c;return new
bG(this.t,a,this.l)}}function
np(a){return new
bG(0,a,a.length)}function
aS(a){return a}function
aJ(a){return np(aS(a))}function
bH(a,b,c,d,e){a2(aJ(a),b,c,d,e);return 0}function
eq(){H(gD)}function
bd(a,b){switch(a.t&6){case
0:return a.c.charCodeAt(b);case
2:if(b>=a.c.length)return 0;return a.c.charCodeAt(b);case
4:return a.c[b]}}function
zr(a,b){if(b>>>0>=a.l)eq();return bd(a,b)}function
b9(a){return new
q(a[7]<<0|a[6]<<8|a[5]<<16,a[4]<<0|a[3]<<8|a[2]<<16,a[1]<<0|a[0]<<8)}function
zs(a,b){if(b>>>0>=a.l-7)eq();var
d=new
Array(8);for(var
c=0;c<8;c++)d[7-c]=bd(a,b+c);return b9(d)}function
w(a,b,c){c&=X;if(a.t!==4){if(b===a.c.length){a.c+=String.fromCharCode(c);if(b+1===a.l)a.t=0;return 0}et(a)}a.c[b]=c;return 0}function
aA(a,b,c){if(b>>>0>=a.l)eq();return w(a,b,c)}function
b_(a){return a.toArray()}function
zu(a,b,c){if(b>>>0>=a.l-7)eq();var
e=b_(c);for(var
d=0;d<8;d++)w(a,b+7-d,e[d]);return 0}function
aK(d,e){var
f=d.l>=0?d.l:d.l=d.length,c=e.length,b=f-c;if(b===0)return d(...e);else if(b<0){var
a=d(...e.slice(0,f));if(typeof
a!=="function")return a;return aK(a,e.slice(f))}else{switch(b){case
1:{var
a=function(a){var
f=new
Array(c+1);for(var
b=0;b<c;b++)f[b]=e[b];f[c]=a;return d(...f)};break}case
2:{var
a=function(a,b){var
g=new
Array(c+2);for(var
f=0;f<c;f++)g[f]=e[f];g[c]=a;g[c+1]=b;return d(...g)};break}default:var
a=function(...a){if(a.length===0)a=[undefined];return aK(d,e.concat(a))}}a.l=b;return a}}function
f(a,b){if(b>>>0>=a.length-1)c0();return a}function
zv(a){if(Number.isFinite(a)){if(Math.abs(a)>=2.2250738585072014e-308)return 0;if(a!==0)return 1;return 2}return Number.isNaN(a)?4:3}function
zw(){return[0]}function
F(a){if(a<0)H("Bytes.create");return new
bG(a?2:9,e,a)}var
eu=[0];function
zy(a,b){if(eu!==a)return 0;eu=b;return 1}function
nt(a){return eu}function
zz(a){eu=a}function
nF(a){return a===245?1:0}var
aT=new
DataView(new
ArrayBuffer(8));function
ew(a){aT.setFloat32(0,a,true);return aT.getUint32(0,true)|0}function
aB(a,b,c){return new
q(a,b,c)}function
ex(a){aT.setFloat64(0,a,true);var
c=aT.getUint32(0,true),b=aT.getUint32(4,true),d=c&V,e=c>>>24|b<<8&V,f=b>>>16&ar;return aB(d,e,f)}function
no(a,b,c){a.write(32,b.dims.length);a.write(32,b.kind|b.layout<<8);if(b.caml_custom===d3)for(var
d=0;d<b.dims.length;d++)if(b.dims[d]<ar)a.write(16,b.dims[d]);else{a.write(16,ar);a.write(32,0);a.write(32,b.dims[d])}else
for(var
d=0;d<b.dims.length;d++)a.write(32,b.dims[d]);switch(b.kind){case
2:case
3:case
12:for(var
d=0;d<b.data.length;d++)a.write(8,b.data[d]);break;case
4:case
5:for(var
d=0;d<b.data.length;d++)a.write(16,b.data[d]);break;case
6:for(var
d=0;d<b.data.length;d++)a.write(32,b.data[d]);break;case
8:case
9:a.write(8,0);for(var
d=0;d<b.data.length;d++)a.write(32,b.data[d]);break;case
7:for(var
d=0;d<b.data.length/2;d++){var
f=b_(b.get(d));for(var
e=0;e<8;e++)a.write(8,f[e])}break;case
1:for(var
d=0;d<b.data.length;d++){var
f=b_(ex(b.get(d)));for(var
e=0;e<8;e++)a.write(8,f[e])}break;case
13:for(var
d=0;d<b.data.length;d++)a.write(16,b.data[d]);break;case
0:for(var
d=0;d<b.data.length;d++){var
f=ew(b.get(d));a.write(32,f)}break;case
10:for(var
d=0;d<b.data.length/2;d++){var
e=b.get(d);a.write(32,ew(e[1]));a.write(32,ew(e[2]))}break;case
11:for(var
d=0;d<b.data.length/2;d++){var
g=b.get(d),f=b_(ex(g[1]));for(var
e=0;e<8;e++)a.write(8,f[e]);var
f=b_(ex(g[2]));for(var
e=0;e<8;e++)a.write(8,f[e])}break}c[0]=(4+b.dims.length)*4;c[1]=(4+b.dims.length)*8}function
gQ(a){aT.setUint32(0,a,true);return aT.getFloat32(0,true)}function
gS(a){var
d=a.lo,b=a.mi,c=a.hi;aT.setUint32(0,d|b<<24,true);aT.setUint32(4,b>>>8|c<<16,true);return aT.getFloat64(0,true)}function
M(a){if(!N.Failure)N.Failure=[c,a4(gC),-3];nR(N.Failure,a)}function
nl(a,b,c){var
k=a.read32s();if(k<0||k>16)M("input_value: wrong number of bigarray dimensions");var
r=a.read32s(),l=r&X,q=r>>8&1,j=[];if(c===d3)for(var
d=0;d<k;d++){var
p=a.read16u();if(p===ar){var
u=a.read32u(),v=a.read32u();if(u!==0)M("input_value: bigarray dimension overflow in 32bit");p=v}j.push(p)}else
for(var
d=0;d<k;d++)j.push(a.read32u());var
f=ep(j),h=nk(l,f),i=gK(l,q,j,h);switch(l){case
2:for(var
d=0;d<f;d++)h[d]=a.read8s();break;case
3:case
12:for(var
d=0;d<f;d++)h[d]=a.read8u();break;case
4:for(var
d=0;d<f;d++)h[d]=a.read16s();break;case
5:for(var
d=0;d<f;d++)h[d]=a.read16u();break;case
6:for(var
d=0;d<f;d++)h[d]=a.read32s();break;case
8:case
9:var
t=a.read8u();if(t)M("input_value: cannot read bigarray with 64-bit OCaml ints");for(var
d=0;d<f;d++)h[d]=a.read32s();break;case
7:var
g=new
Array(8);for(var
d=0;d<f;d++){for(var
e=0;e<8;e++)g[e]=a.read8u();var
s=b9(g);i.set(d,s)}break;case
1:var
g=new
Array(8);for(var
d=0;d<f;d++){for(var
e=0;e<8;e++)g[e]=a.read8u();var
m=gS(b9(g));i.set(d,m)}break;case
13:for(var
d=0;d<f;d++)h[d]=a.read16u();break;case
0:for(var
d=0;d<f;d++){var
m=gQ(a.read32s());i.set(d,m)}break;case
10:for(var
d=0;d<f;d++){var
o=gQ(a.read32s()),n=gQ(a.read32s());i.set(d,[d7,o,n])}break;case
11:var
g=new
Array(8);for(var
d=0;d<f;d++){for(var
e=0;e<8;e++)g[e]=a.read8u();var
o=gS(b9(g));for(var
e=0;e<8;e++)g[e]=a.read8u();var
n=gS(b9(g));i.set(d,[d7,o,n])}break}b[0]=(4+k)*4;return gK(l,q,j,h)}function
nj(a,b,c){return a.compare(b,c)}function
eD(a,b){return Math.imul(a,b)}function
O(a,b){b=eD(b,0xcc9e2d51|0);b=b<<15|b>>>32-15;b=eD(b,0x1b873593);a^=b;a=a<<13|a>>>32-13;return(a+(a<<2)|0)+(0xe6546b64|0)|0}function
zJ(a,b){if((b&d9)===d9&&(b&0x03ff)!==0)b=0x7c01;else if(b===aH)b=0;return O(a,b)}function
zK(a,b){var
c=ew(b);if((c&k0)===k0&&(c&0x7fffff)!==0)c=0x7f800001;else if(c===(m8|0))c=0;a=O(a,c);return a}function
nx(a,b){var
e=ex(b),d=gU(e),c=gT(e);if((c&gr)===gr&&(d|c&0xfffff)!==0){c=gr;d=0x00000001}else if(c===(m8|0)&&d===0)c=0;a=O(a,d);a=O(a,c);return a}function
nn(a){var
c=ep(a.dims),d=0;switch(a.kind){case
2:case
3:case
12:if(c>aP)c=aP;var
e=0,b=0;for(b=0;b+4<=c;b+=4){e=a.data[b+0]&X|(a.data[b+1]&X)<<8|(a.data[b+2]&X)<<16|a.data[b+3]<<24;d=O(d,e)}e=0;switch(c&3){case
3:e=a.data[b+2]<<16;case
2:e|=a.data[b+1]<<8;case
1:e|=a.data[b+0];d=O(d,e)}break;case
4:case
5:if(c>cZ)c=cZ;var
e=0,b=0;for(b=0;b+2<=c;b+=2){e=a.data[b+0]&ar|a.data[b+1]<<16;d=O(d,e)}if((c&1)!==0)d=O(d,a.data[b]);break;case
6:if(c>64)c=64;for(var
b=0;b<c;b++)d=O(d,a.data[b]);break;case
8:case
9:if(c>64)c=64;for(var
b=0;b<c;b++)d=O(d,a.data[b]);break;case
7:if(c>32)c=32;c*=2;for(var
b=0;b<c;b++)d=O(d,a.data[b]);break;case
10:c*=2;case
0:if(c>64)c=64;for(var
b=0;b<c;b++)d=zK(d,a.data[b]);break;case
11:c*=2;case
1:if(c>32)c=32;for(var
b=0;b<c;b++)d=nx(d,a.data[b]);break;case
13:if(c>cZ)c=cZ;for(var
b=0;b<c;b++)d=zJ(d,a.data[b]);break}return d}function
zN(a,b){b[0]=4;return a.read32s()}function
Ah(a,b){switch(a.read8u()){case
1:b[0]=4;return a.read32s();case
2:M("input_value: native integer value too large");break;default:M("input_value: ill-formed native integer")}}function
zX(a,b){var
d=new
Array(8);for(var
c=0;c<8;c++)d[c]=a.read8u();b[0]=8;return b9(d)}function
zS(a,b,c){var
e=b_(b);for(var
d=0;d<8;d++)a.write(8,e[d]);c[0]=8;c[1]=8}function
gR(a,b,c){return a.compare(b)}function
zP(a){return a.lo32()^a.hi32()}var
c4={_j:{deserialize:zX,serialize:zS,fixed_length:8,compare:gR,hash:zP},_i:{deserialize:zN,fixed_length:4},_n:{deserialize:Ah,fixed_length:4},_bigarray:{deserialize:function(a,b){return nl(a,b,"_bigarray")},serialize:no,compare:nj,hash:nn},_bigarr02:{deserialize:function(a,b){return nl(a,b,d3)},serialize:no,compare:nj,hash:nn}};function
gL(a){return c4[a.caml_custom]&&c4[a.caml_custom].compare}function
nr(a,b,c,d){var
f=gL(b);if(f){var
e=c>0?f(b,a,d):f(a,b,d);if(d&&Number.isNaN(e))return c;if(Number.isNaN(+e))return+e;if((e|0)!==0)return e|0}return c}function
ez(a){return typeof
a==="string"&&!/[^\x00-\xff]/.test(a)}function
ey(a){return a
instanceof
bG}function
ns(a){if(typeof
a==="number")return aq;else if(ey(a))return cV;else if(ez(a))return 1252;else if(Array.isArray(a)&&a[0]===a[0]>>>0&&a[0]<=gi){var
b=a[0]|0;return b===d7?0:b}else if(a
instanceof
String)return lO;else if(typeof
a==="string")return lO;else if(a
instanceof
Number)return aq;else if(a?.caml_custom)return gB;else if(a?.compare)return 1256;else if(typeof
a==="function")return 1247;else if(typeof
a==="symbol")return 1251;return 1001}function
c7(a,b){if(a<b)return-1;if(a===b)return 0;return 1}function
Ap(a,b){return a<b?-1:a>b?1:0}function
zq(a,b){a.t&6&&c2(a);b.t&6&&c2(b);return a.c<b.c?-1:a.c>b.c?1:0}function
es(a,b,c){var
f=[];for(;;){if(!(c&&a===b)){var
e=ns(a);if(e===at){a=a[1];continue}var
g=ns(b);if(g===at){b=b[1];continue}if(e!==g){if(e===aq){if(g===gB)return nr(a,b,-1,c);return-1}if(g===aq){if(e===gB)return nr(b,a,1,c);return 1}return e<g?-1:1}switch(e){case
247:H(gv);break;case
248:var
d=c7(a[2],b[2])|0;if(d!==0)return d;break;case
249:H(gv);break;case
250:H("equal: got Forward_tag, should not happen");break;case
251:H("equal: abstract value");break;case
252:if(a!==b){var
d=zq(a,b)|0;if(d!==0)return d}break;case
253:H("equal: got Double_tag, should not happen");break;case
254:H("equal: got Double_array_tag, should not happen");break;case
255:H("equal: got Custom_tag, should not happen");break;case
1247:H(gv);break;case
1255:var
i=gL(a);if(i!==gL(b))return a.caml_custom<b.caml_custom?-1:1;if(!i)H("compare: abstract value");var
d=i(a,b,c);if(Number.isNaN(d))return c?-1:d;if(d!==(d|0))return-1;if(d!==0)return d|0;break;case
1256:var
d=a.compare(b,c);if(Number.isNaN(d))return c?-1:d;if(d!==(d|0))return-1;if(d!==0)return d|0;break;case
1000:a=+a;b=+b;if(a<b)return-1;if(a>b)return 1;if(a!==b){if(!c)return Number.NaN;if(!Number.isNaN(a))return 1;if(!Number.isNaN(b))return-1}break;case
1001:if(a<b)return-1;if(a>b)return 1;if(a!==b)return c?1:Number.NaN;break;case
1251:if(a!==b)return c?1:Number.NaN;break;case
1252:var
a=aS(a),b=aS(b);if(a!==b){if(a<b)return-1;if(a>b)return 1}break;case
12520:var
a=a.toString(),b=b.toString();if(a!==b){if(a<b)return-1;if(a>b)return 1}break;default:if(nF(e)){H("compare: continuation value");break}if(a.length!==b.length)return a.length<b.length?-1:1;if(a.length>1)f.push(a,b,1);break}}if(f.length===0)return 0;var
h=f.pop();b=f.pop();a=f.pop();if(h+1<a.length)f.push(a,b,h+1);a=a[h];b=b[h]}}function
a3(a,b){return+(es(a,b,false)===0)}function
zB(a,b,c,d){if(c>0)if(b===0&&(c>=a.l||a.t===2&&c>=a.c.length))if(d===0){a.c=e;a.t=2}else{a.c=bf(c,String.fromCharCode(d));a.t=c===a.l?0:2}else{if(a.t!==4)et(a);for(c+=b;b<c;b++)a.c[b]=d}return 0}function
nv(a){var
b,f=/^ *[-+]?(?:\d*\.?\d+|\d+\.?\d*)(?:[eE][-+]?\d+)?$/;a=aS(a);b=+a;if(!Number.isNaN(b)&&f.test(a))return b;a=a.replace(/_/g,e);b=+a;if(!Number.isNaN(b)&&f.test(a)||/^[+-]?nan$/i.test(a))return b;var
c=/^ *([+-]?)0x([0-9a-f]+)\.?([0-9a-f]*)(p([+-]?[0-9]+))?$/i.exec(a);if(c){var
d=c[3].replace(/0+$/,e),h=Number.parseInt(c[1]+c[2]+d,16),g=(+c[5]||0)-4*d.length;b=h*Math.pow(2,g);return b}if(/^\+?inf(inity)?$/i.test(a))return Number.POSITIVE_INFINITY;if(/^-inf(inity)?$/i.test(a))return Number.NEGATIVE_INFINITY;M("float_of_string")}function
g4(a){a=aS(a);var
e=a.length;if(e>31)H("format_int: format too long");var
b={justify:b7,signstyle:a0,filler:as,alternate:false,base:0,signedconv:false,width:0,uppercase:false,sign:1,prec:-1,conv:"f"};for(var
d=0;d<e;d++){var
c=a.charAt(d);switch(c){case"-":b.justify=a0;break;case"+":case" ":b.signstyle=c;break;case"0":b.filler=am;break;case"#":b.alternate=true;break;case"1":case"2":case"3":case"4":case"5":case"6":case"7":case"8":case"9":b.width=0;while(c=a.charCodeAt(d)-48,c>=0&&c<=9){b.width=b.width*10+c;d++}d--;break;case".":b.prec=0;d++;while(c=a.charCodeAt(d)-48,c>=0&&c<=9){b.prec=b.prec*10+c;d++}d--;break;case"d":case"i":b.signedconv=true;b.base=10;break;case"u":b.base=10;break;case"x":b.base=16;break;case"X":b.base=16;b.uppercase=true;break;case"o":b.base=8;break;case"e":case"f":case"g":b.signedconv=true;b.conv=c;break;case"E":case"F":case"G":b.signedconv=true;b.uppercase=true;b.conv=c.toLowerCase();break}}return b}function
gM(a,b){if(a.uppercase)b=b.toUpperCase();var
f=b.length;if(a.signedconv&&(a.sign<0||a.signstyle!==a0))f++;if(a.alternate){if(a.base===8)f+=1;if(a.base===16)f+=2}var
c=e;if(a.justify===b7&&a.filler===as)for(var
d=f;d<a.width;d++)c+=as;if(a.signedconv)if(a.sign<0)c+=a0;else if(a.signstyle!==a0)c+=a.signstyle;if(a.alternate&&a.base===8)c+=am;if(a.alternate&&a.base===16)c+=a.uppercase?"0X":ln;if(a.justify===b7&&a.filler===am)for(var
d=f;d<a.width;d++)c+=am;c+=b;if(a.justify===a0)for(var
d=f;d<a.width;d++)c+=as;return a4(c)}function
gN(a,b){function
j(a,b){if(Math.abs(a)<1.0)return a.toFixed(b);else{var
c=Number.parseInt(a.toString().split(b7)[1]);if(c>20){c-=20;a/=Math.pow(10,c);a+=bf(c,am);if(b>0)a=a+a1+bf(b,am);return a}else
return a.toFixed(b)}}var
c,f=g4(a),e=f.prec<0?6:f.prec;if(b<0||b===0&&1/b===Number.NEGATIVE_INFINITY){f.sign=-1;b=-b}if(Number.isNaN(b)){c=gH;f.filler=as}else if(!Number.isFinite(b)){c="inf";f.filler=as}else
switch(f.conv){case"e":var
c=b.toExponential(e),d=c.length;if(c.charAt(d-3)===go)c=c.slice(0,d-1)+am+c.slice(d-1);break;case"f":c=j(b,e);break;case"g":e=e?e:1;c=b.toExponential(e-1);var
i=c.indexOf(go),h=+c.slice(i+1);if(h<-4||b>=1e21||b.toFixed(0).length>e){var
d=i-1;while(c.charAt(d)===am)d--;if(c.charAt(d)===a1)d--;c=c.slice(0,d+1)+c.slice(i);d=c.length;if(c.charAt(d-3)===go)c=c.slice(0,d-1)+am+c.slice(d-1);break}else{var
g=e;if(h<0){g-=h+1;c=b.toFixed(g)}else
while(c=b.toFixed(g),c.length>e+1)g--;if(g){var
d=c.length-1;while(c.charAt(d)===am)d--;if(c.charAt(d)===a1)d--;c=c.slice(0,d+1)}}break}return gM(f,c)}function
ev(a,b){if(aS(a)===ea)return a4(e+b);var
c=g4(a);if(b<0)if(c.signedconv){c.sign=-1;b=-b}else
b>>>=0;var
d=b.toString(c.base);if(c.prec>=0){c.filler=as;var
f=c.prec-d.length;if(f>0)d=bf(f,am)+d}return gM(c,d)}var
Ak=0;function
an(){return Ak++}var
n1=new
ArrayBuffer(bD);function
r(a){if(ha(a))return a;var
c=a.length<=n1.length?new
Uint8Array(n1,0,a.length):new
Uint8Array(a.length);for(var
b=0;b<a.length;b++)c[b]=a.charCodeAt(b);return n0.decode(c)}function
c9(){return d.process?.versions?.node!==undefined}function
AF(){function
a(a){if(a.charAt(0)===aQ)return[e,a.slice(1)];return}function
b(a){var
h=/^([a-zA-Z]:|[\\/]{2}[^\\/]+[\\/]+[^\\/]+)?([\\/])?([\s\S]*?)$/,b=h.exec(a),c=b[1]||e,f=c.length>0&&c.charAt(1)!==":";if(b[2]||f){var
d=b[1]||e,g=b[2]||e;return[d,a.slice(d.length+g.length)]}return}return c9()&&d.process&&d.process.platform?d.process.platform===gs?b:a:a}var
hb=AF();function
nT(a){return a.slice(-1)!==aQ?a+aQ:a}if(c9()&&d.process&&d.process.cwd)var
c3=d.process.cwd().replace(/\\/g,aQ);else
var
c3="/static";c3=nT(c3);function
z9(a){a=r(a);if(!hb(a))a=c3+a;var
e=hb(a),d=e[1].split(/[/\\]/),b=[];for(var
c=0;c<d.length;c++)switch(d[c]){case"..":b.pop();break;case".":break;case"":break;default:b.push(d[c]);break}b.unshift(e[0]);b.orig=a;return b}var
AE=new
TextEncoder();function
As(a,b,c){var
d=String.fromCharCode;if(b===0&&c<=kN&&c===a.length)return d.apply(null,a);var
f=e;for(;0<c;b+=bD,c-=bD)f+=d.apply(null,a.slice(b,b+Math.min(c,bD)));return f}function
Aq(a){return a4(As(a,0,a.length))}function
B(a){if(ha(a))return a4(a);var
b=AE.encode(a);return Aq(b)}function
R(a){nP(N.Sys_error,B(a))}function
nQ(a,b){throw h([0,a].concat(b))}var
AG=[m3,k5,kI,bC,kF,lr,mm,mk,el,m2,mV,l3,bE,ly,d_,kY,k9,lo,nd,kR,b3,lL,k2,m6,m4,nc,cQ,gl,k4,kM,lT,me,mU,kP,ef,lg,kL,ls,mt,lh,lE,k8,lb,mT,mD,mw,mC,mG,mc,lz,mP,l7,m5,lm,kQ,lH,kB,mB,kx,md,kS,mv,l_,lD,lC,lU,mO,mK];function
n3(a,b,c,d){var
f=AG.indexOf(a);if(f<0){if(d==null)d=-9999;f=[0,-d]}var
g=[f,B(b||e),B(c||e)];return g}var
nL={};function
ca(a){return nL[a]}function
A(a,b,c,d,e){var
f=ca(eh);if(a&&f)nQ(f,n3(b,c,e));else{var
d=b+cY+d+bB+c;if(e!==undefined)d+=" '"+e+"'";R(d)}}function
zt(a){if(!(a
instanceof
Uint8Array))a=new
Uint8Array(a);return new
bG(4,a,a.length)}function
g5(a,b){A(b,b3,ed,a)}function
nq(a){return new
bG(4,a,a.length)}function
ah(a){return a.l}function
ng(){}class
bb
extends
ng{constructor(a){super();this.data=a}truncate(a){var
b=this.data;this.data=F(a|0);a2(b,0,this.data,0,a)}length(){return ah(this.data)}write(a,b,c,d){var
e=this.length();if(a+d>=e){var
f=F(a+d),g=this.data;this.data=f;a2(g,0,this.data,0,e)}a2(nq(b),c,this.data,a,d);return d}read(a,b,c,d){var
e=this.length();if(a+d>=e)d=e-a;if(d){var
f=F(d|0);a2(this.data,a,f,0,d);b.set(eI(f),c)}return d}}class
zc{constructor(a,b,c){this.file=b;this.name=a;this.flags=c;this.offset=0;this.seeked=false}err_closed(a,b){A(b,bC,a,cT)}length(){if(this.file)return this.file.length();this.err_closed("length")}truncate(a,b){if(this.file){if(!(this.flags.wronly||this.flags.rdwr))A(b,bE,mA,cS);return this.file.truncate(a)}this.err_closed(mA,b)}write(a,b,c,d){if(this.file&&(this.flags.wronly||this.flags.rdwr)){var
e=this.offset;c=this.file.write(e,a,b,c);this.offset+=c;return c}this.err_closed(ms,d)}read(a,b,c,d){if(this.file&&!this.flags.wronly){var
e=this.offset;c=this.file.read(e,a,b,c);this.offset+=c;return c}this.err_closed(kA,d)}seek(a,b,c){switch(b){case
0:break;case
1:a+=this.offset;break;case
2:a+=this.length();break}if(a<0)A(c,bE,d5,cS);this.offset=a;this.seeked=true}close(){if(!this.file)this.err_closed("close");this.file=undefined}check_stream_semantics(a){if(!this.file)return this.err_closed(a,1)}}class
nf{constructor(a,b){this.content={};this.root=a;this.lookupFun=b}nm(a){return this.root+a}create_dir_if_needed(a){var
d=a.split(aQ),c=e;for(var
b=0;b<d.length-1;b++){c+=d[b]+aQ;if(this.content[c])continue;this.content[c]=Symbol("directory")}}slash(a){return/\/$/.test(a)?a:a+aQ}lookup(a){if(!this.content[a]&&this.lookupFun){var
b=this.lookupFun(B(this.root),B(a));if(b!==0){this.create_dir_if_needed(a);this.content[a]=new
bb(aJ(b[1]))}}}exists(a,b){if(a===e)return 1;var
c=this.slash(a);if(this.content[c])return 1;if(!b)this.lookup(a);return this.content[a]?1:0}isFile(a){return this.exists(a)&&!this.is_dir(a)?1:0}rename_dir(a,b){if(this.exists(b)){if(!this.is_dir(b))R(this.nm(b)+" : file already exists and is not a directory");if(this.readdir(b).length>0)R(this.nm(b)+" : directory not empty")}var
d=this.slash(a),c=this.slash(b);this.create_dir_if_needed(c);for(const
b
of
this.readdir(a))this.rename(d+b,c+b);delete
this.content[d]}rename(a,b){if(!this.exists(a))R(this.nm(a)+" : no such file or directory");if(this.is_dir(a))this.rename_dir(a,b);else{if(this.exists(b)&&this.is_dir(b))R(this.nm(b)+" : file already exists and is a directory");this.content[b]=this.content[a];delete
this.content[a]}}mkdir(a,b,c){if(this.exists(a))A(c,el,gn,mY,this.nm(a));var
d=/^(.*)\/[^/]+/.exec(a);d=d?.[1]||e;if(!this.exists(d))A(c,b3,gn,ed,this.nm(a));if(!this.is_dir(d))A(c,cQ,gn,lS,this.nm(a));this.create_dir_if_needed(this.slash(a))}rmdir(a,b){var
c=a===e?e:this.slash(a),f=new
RegExp(kG+c+l5);if(!this.exists(a))A(b,b3,gu,ed,this.nm(a));if(!this.is_dir(a))A(b,cQ,gu,lS,this.nm(a));for(var
d
in
this.content)if(d.match(f))A(b,gl,gu,"directory not empty",this.nm(a));delete
this.content[c]}readdir(a){var
g=a===e?e:this.slash(a);if(!this.exists(a))R(a+": No such file or directory");if(!this.is_dir(a))R(a+": Not a directory");var
h=new
RegExp(kG+g+l5),d={},c=[];for(var
f
in
this.content){var
b=f.match(h);if(b&&!d[b[1]]){d[b[1]]=true;c.push(b[1])}}return c}opendir(a,b){var
c=this.readdir(a),d=false,e=0;return{readSync:function(){if(d)A(b,bC,lk,cT);if(e===c.length)return null;var
a=c[e];e++;return{name:a}},closeSync:function(){if(d)A(b,bC,lk,cT);d=true;c=[]}}}is_dir(a){if(a===e)return true;var
b=this.slash(a);return this.content[b]?1:0}unlink(a,b){if(!this.exists(a,true))A(b,b3,"unlink",ed,a);delete
this.content[a];return 0}access(a,b,c){this.lookup(a);if(this.content[a]){if(this.is_dir(a))A(c,"EACCESS","access","permission denied,",this.nm(a))}else
g5(this.nm(a),c);return 0}open(a,b,c,d){var
e;this.lookup(a);if(this.content[a]){if(this.is_dir(a))A(d,d_,gx,ll,this.nm(a));if(b.create&&b.excl)A(d,el,gx,mY,this.nm(a));e=this.content[a];if(b.truncate)e.truncate()}else if(b.create){this.create_dir_if_needed(a);this.content[a]=new
bb(F(0));e=this.content[a]}else
g5(this.nm(a),d);return new
zc(this.nm(a),e,b)}truncate(a,b,c){var
d;this.lookup(a);if(this.content[a]){if(this.is_dir(a))A(c,d_,gx,ll,this.nm(a));d=this.content[a];d.truncate(b)}else
g5(this.nm(a),c)}register(a,b){var
c;if(this.content[a])R(this.nm(a)+" : file already exists");if(ey(b))c=new
bb(b);if(ez(b))c=new
bb(aJ(b));else if(Array.isArray(b))c=new
bb(zt(b));else if(typeof
b==="string")c=new
bb(np(b));else if(b.toString){var
d=aJ(B(b.toString()));c=new
bb(d)}if(c){this.create_dir_if_needed(a);this.content[a]=c}else
R(this.nm(a)+" : registering file with invalid content type")}}function
x(a,b,c){var
d=ca(eh);if(b&&d){var
e=n3(a.code,c||a.syscall,a.path,a.errno);nQ(d,e)}else
R(a.toString())}function
nC(a){if(a<0)a=Math.ceil(a);return new
q(a&V,Math.floor(a*c6)&V,Math.floor(a*c6*c6)&ar)}function
g$(a,b){var
c;if(a.isFile())c=0;else if(a.isDirectory())c=1;else if(a.isCharacterDevice())c=2;else if(a.isBlockDevice())c=3;else if(a.isSymbolicLink())c=4;else if(a.isFIFO())c=5;else if(a.isSocket())c=6;return[0,a.dev,a.ino|0,c,a.mode,a.nlink,a.uid,a.gid,a.rdev,b?nC(a.size):a.size|0,a.atimeMs/aq,a.mtimeMs/aq,a.ctimeMs/aq]}function
k(a){return a.length}function
av(a,b){return a.charCodeAt(b)}function
AJ(a){var
d=k(a),c=new
Uint8Array(d),b=0;for(;b<d;b++)c[b]=av(a,b);return c}class
gJ
extends
ng{constructor(a,b){super();this.fs=require(cX);this.fd=a;this.flags=b;try{var
c=this.fs.fstatSync(a);b.noSeek=c.isCharacterDevice()||c.isFIFO()||c.isSocket()}catch(f){b.noSeek=true}this.offset=this.flags.append?c.size:0;this.seeked=false}truncate(a,b){try{this.fs.ftruncateSync(this.fd,a|0);if(this.offset>a)this.offset=a}catch(f){x(f,b)}}length(){try{return this.fs.fstatSync(this.fd).size}catch(f){R(f.toString())}}write(a,b,c,d){try{if(this.flags.noSeek||!this.seeked)var
e=this.fs.writeSync(this.fd,a,b,c);else
var
e=this.fs.writeSync(this.fd,a,b,c,this.offset);this.offset+=e}catch(f){x(f,d)}return e}read(a,b,c,d){try{if(this.flags.noSeek||!this.seeked)var
e=this.fs.readSync(this.fd,a,b,c);else
var
e=this.fs.readSync(this.fd,a,b,c,this.offset);this.offset+=e;return e}catch(f){x(f,d)}}seek(a,b,c){if(this.flags.noSeek)A(c,ef,d5,mR);switch(b){case
0:break;case
1:a+=this.offset;break;case
2:a+=this.length();break}if(a<0)A(c,bE,d5,cS);this.offset=a;this.seeked=true;return this.offset}stat(a){try{var
b=this.fs.fstatSync(this.fd);return g$(b,a)}catch(f){x(f,1)}}chmod(a){try{this.fs.fchmodSync(this.fd,a);return 0}catch(f){x(f,1)}}sync(){try{this.fs.fsyncSync(this.fd);return 0}catch(f){x(f,1)}}close(a){try{this.fs.closeSync(this.fd);return 0}catch(f){x(f,a)}}check_stream_semantics(a){try{var
b=this.fs.fstatSync(this.fd)}catch(f){x(f,1,a)}if(!(b.isFile()||b.isCharacterDevice()||b.isFIFO()||b.isSocket()))A(1,bE,a,cS)}}class
nh{constructor(a){this.fs=require(cX);this.root=a}nm(a){return this.root+a}exists(a){try{return this.fs.existsSync(this.nm(a))?1:0}catch(f){return 0}}isFile(a){try{return this.fs.statSync(this.nm(a)).isFile()?1:0}catch(f){R(f.toString())}}mkdir(a,b,c){try{this.fs.mkdirSync(this.nm(a),{mode:b});return 0}catch(f){x(f,c)}}rmdir(a,b){try{this.fs.rmdirSync(this.nm(a));return 0}catch(f){x(f,b)}}readdir(a,b){try{return this.fs.readdirSync(this.nm(a))}catch(f){x(f,b)}}is_dir(a){try{return this.fs.statSync(this.nm(a)).isDirectory()?1:0}catch(f){R(f.toString())}}unlink(a,b){try{this.fs.unlinkSync(this.nm(a));return 0}catch(f){x(f,b)}}utimes(a,b,c,d){try{if(b===0&&c===0){b=new
Date().getTime()/aq;c=b}this.fs.utimesSync(this.nm(a),b,c);return 0}catch(f){x(f,d)}}truncate(a,b,c){try{this.fs.truncateSync(this.nm(a),b|0);return 0}catch(f){x(f,c)}}access(a,b,c){var
e=require(cX).constants,f=0;for(var
g
in
b)switch(g){case"r":f|=e.R_OK;break;case"w":f|=e.W_OK;break;case"x":f|=d.process?.platform===gs?e.R_OK:e.X_OK;break;case"f":f|=e.F_OK;break}try{this.fs.accessSync(this.nm(a),f);return 0}catch(f){x(f,c)}}open(a,b,c,d){var
f=require(cX).constants,e=0;for(var
h
in
b)switch(h){case"rdonly":e|=f.O_RDONLY;break;case"wronly":e|=f.O_WRONLY;break;case"rdwr":e|=f.O_RDWR;break;case"append":e|=f.O_APPEND;break;case"create":e|=f.O_CREAT;break;case"truncate":e|=f.O_TRUNC;break;case"excl":e|=f.O_EXCL;break;case"binary":e|=f.O_BINARY;break;case"text":e|=f.O_TEXT;break;case"nonblock":e|=f.O_NONBLOCK;break;case"noctty":e|=f.O_NOCTTY;break;case"dsync":e|=f.O_DSYNC;break;case"sync":e|=f.O_SYNC;break}try{var
g=this.fs.openSync(this.nm(a),e,c);return new
gJ(g,b)}catch(f){x(f,d)}}slash(a){return/\/$/.test(a)?a:a+aQ}rename(a,b,c){if(d.process?.platform===gs)try{var
e=this.nm(b),g=this.nm(a),i,h;if((i=this.fs.statSync(e,{throwIfNoEntry:false}))&&(h=this.fs.statSync(g,{throwIfNoEntry:false}))&&h.isDirectory())if(i.isDirectory()){if(!this.slash(e).startsWith(this.slash(g)))try{this.fs.rmdirSync(e)}catch{}}else{var
f=new
Error(`ENOTDIR: not a directory, rename '${g}' -> '${e}'`);throw Object.assign(f,{errno:-20,code:cQ,syscall:"rename",path:e})}this.fs.renameSync(this.nm(a),this.nm(b))}catch(f){x(f,c)}else
try{this.fs.renameSync(this.nm(a),this.nm(b))}catch(f){x(f,c)}}stat(a,b,c){try{var
d=this.fs.statSync(this.nm(a));return g$(d,b)}catch(f){x(f,c)}}lstat(a,b,c){try{var
d=this.fs.lstatSync(this.nm(a));return g$(d,b)}catch(f){x(f,c)}}chmod(a,b,c){try{this.fs.chmodSync(this.nm(a),b);return 0}catch(f){x(f,c)}}link(a,b,c){try{this.fs.linkSync(this.nm(a),this.nm(b));return 0}catch(f){x(f,c)}}symlink(a,b,c,d){try{this.fs.symlinkSync(b,this.nm(c),a===0?null:a[1]?"dir":"file");return 0}catch(f){x(f,d)}}readlink(a,b){try{var
c=this.fs.readlinkSync(this.nm(a),"utf8");return B(c)}catch(f){x(f,b)}}opendir(a,b){try{return this.fs.opendirSync(this.nm(a))}catch(f){x(f,b)}}}function
nw(a){var
b=hb(a);if(!b)return;return b[0]+aQ}var
eG=nw(c3)||M("unable to compute caml_root"),cd=[];if(c9())cd.push({path:eG,device:new
nh(eG)});else
cd.push({path:eG,device:new
nf(eG)});cd.push({path:mz,device:new
nf(mz)});function
n4(a){var
g=z9(a),a=g.join(aQ),f=nT(a),c;for(var
d=0;d<cd.length;d++){var
b=cd[d];if(f.search(b.path)===0&&(!c||c.path.length<b.path.length))c={path:b.path,device:b.device,rest:a.slice(b.path.length,a.length)}}if(!c&&c9()){var
e=nw(a);if(e?.match(/^[a-zA-Z]:\/$/)){var
b={path:e,device:new
nh(e)};cd.push(b);c={path:b.path,device:b.device,rest:a.slice(b.path.length,a.length)}}}if(c)return c;R("no device found for "+f)}function
zx(a,b){var
c=n4(a);if(!c.device.register)M("cannot register file");c.device.register(c.rest,b);return 0}function
nX(a,b){var
a=B(a),b=a4(b);return zx(a,b)}function
zD(){var
b=d.jsoo_fs_tmp;if(b)for(var
a=0;a<b.length;a++)nX(b[a].name,b[a].content);d.jsoo_create_file=nX;d.jsoo_fs_tmp=[];return 0}function
zE(){return[0]}function
gO(a){return[0]}function
gP(a,b){var
e=b.length,c,d;for(c=0;c+4<=e;c+=4){d=b.charCodeAt(c)|b.charCodeAt(c+1)<<8|b.charCodeAt(c+2)<<16|b.charCodeAt(c+3)<<24;a=O(a,d)}d=0;switch(e&3){case
3:d=b.charCodeAt(c+2)<<16;case
2:d|=b.charCodeAt(c+1)<<8;case
1:d|=b.charCodeAt(c);a=O(a,d)}a^=e;return a}function
zL(a,b){return gP(a,aS(b))}function
zH(a,b){var
e=b.length,c,d;for(c=0;c+4<=e;c+=4){d=b[c]|b[c+1]<<8|b[c+2]<<16|b[c+3]<<24;a=O(a,d)}d=0;switch(e&3){case
3:d=b[c+2]<<16;case
2:d|=b[c+1]<<8;case
1:d|=b[c];a=O(a,d)}a^=e;return a}function
z$(a){switch(a.t&6){case
2:c2(a);return a.c;default:return a.c}}function
zG(a,b){var
c=z$(b);return typeof
c==="string"?gP(a,c):zH(a,c)}function
zI(a){a^=a>>>16;a=eD(a,0x85ebca6b|0);a^=a>>>13;a=eD(a,0xc2b2ae35|0);a^=a>>>16;return a}function
zF(a,b,c,d){var
j,k,l,h,g,f,e,i,m;h=b;if(h<0||h>aP)h=aP;g=a;f=c;j=[d];k=0;l=1;while(k<l&&g>0){e=j[k++];if(e?.caml_custom){if(c4[e.caml_custom]&&c4[e.caml_custom].hash){var
n=c4[e.caml_custom].hash(e);f=O(f,n);g--}}else if(Array.isArray(e)&&e[0]===(e[0]|0))switch(e[0]){case
248:f=O(f,e[2]);g--;break;case
250:j[--k]=e[1];break;default:if(nF(e[0]))break;var
o=e.length-1<<10|e[0];f=O(f,o);for(i=1,m=e.length;i<m;i++){if(l>=h)break;j[l++]=e[i]}break}else if(ey(e)){f=zG(f,e);g--}else if(ez(e)){f=zL(f,e);g--}else if(typeof
e==="string"){f=gP(f,e);g--}else if(e===(e|0)){f=O(f,e+e+1);g--}else if(typeof
e==="number"){f=nx(f,e);g--}}f=zI(f);return f&0x3fffffff}function
zM(a,b,c){if(!Number.isFinite(a)){if(Number.isNaN(a))return B(gH);return B(a>0?my:"-infinity")}var
k=a===0&&1/a===Number.NEGATIVE_INFINITY?1:a>=0?0:1;if(k)a=-a;var
f=0;if(a===0);else if(a<1)while(a<1&&f>-1022){a*=2;f--}else
while(a>=2){a/=2;f++}var
l=f<0?e:b7,g=e;if(k)g=a0;else
switch(c){case
43:g=b7;break;case
32:g=as;break;default:break}if(b>=0&&b<13){var
i=Math.pow(2,b*4);a=Math.round(a*i)/i}var
d=a.toString(16);if(b>=0){var
j=d.indexOf(a1);if(j<0)d+=a1+bf(b,am);else{var
h=j+1+b;if(d.length<h)d+=bf(h-d.length,am);else
d=d.slice(0,h)}}return B(g+ln+d+kT+l+f.toString(10))}function
zR(a){return+a.isZero()}function
c5(a){return new
q(a&V,a>>24&V,a>>31&ar)}function
zW(a){return a.toInt()}function
zQ(a){return+a.isNeg()}function
nB(a){return a.neg()}function
nz(a,b){var
c=g4(a);if(c.signedconv&&zQ(b)){c.sign=-1;b=nB(b)}var
d=e,i=c5(c.base),h="0123456789abcdef";do{var
g=b.udivmod(i);b=g.quotient;d=h.charAt(zW(g.modulus))+d}while(!zR(b));if(c.prec>=0){c.filler=as;var
f=c.prec-d.length;if(f>0)d=bf(f,am)+d}return gM(c,d)}function
ny(a,b){return a.add(b)}function
nA(a,b){return a.mul(b)}function
gW(a,b){return a.ucompare(b)<0}function
nN(a){var
b=0,f=k(a),d=10,e=1,c=1;if(f>0)switch(av(a,b)){case
45:b++;e=-1;break;case
43:b++;e=1;break}if(b+1<f&&av(a,b)===48)switch(av(a,b+1)){case
120:case
88:c=0;d=16;b+=2;break;case
111:case
79:c=0;d=8;b+=2;break;case
98:case
66:c=0;d=2;b+=2;break;case
117:case
85:c=0;b+=2;break}return[b,e,d,c]}function
eE(a){if(a>=48&&a<=57)return a-48;if(a>=65&&a<=90)return a-55;if(a>=97&&a<=mQ)return a-87;return-1}function
gV(a){var
f=nN(a),e=f[0],i=f[1],g=f[2],j=f[3],h=c5(g),l=q.UNSIGNED_MAX.udivmod(h).quotient,d=av(a,e),b=eE(d);if(b<0||b>=g)M(cU);var
c=c5(b);for(;;){e++;d=av(a,e);if(d===95)continue;b=eE(d);if(b<0||b>=g)break;if(gW(l,c))M(cU);b=c5(b);c=ny(nA(h,c),b);if(gW(c,b))M(cU)}if(e!==k(a))M(cU);if(j&&gW(i<0?q.SIGNED_MIN:q.SIGNED_MAX,c))M(cU);if(i<0)c=nB(c);return c}function
nD(a,b){return a.or(b)}function
zV(a){return a.toFloat()}function
aa(a){var
f=nN(a),d=f[0],i=f[1],g=f[2],j=f[3],h=k(a),l=-1>>>0,e=d<h?av(a,d):0,c=eE(e);if(c<0||c>=g)M(ee);var
b=c;for(d++;d<h;d++){e=av(a,d);if(e===95)continue;c=eE(e);if(c<0||c>=g)break;b=g*b+c;if(b>l)M(ee)}if(d!==h)M(ee);b=i*b;if(j&&(b|0)!==b)M(ee);return b|0}function
b$(a){return!!a}function
gX(a,b,c){return a[r(b)].apply(a,nG(c))}function
z0(a){var
c={};for(var
b=1;b<a.length;b++){var
d=a[b];c[r(d[1])]=d[2]}return c}function
z1(a){var
d=a.length,c=new
Array(d+1);c[0]=0;for(var
b=0;b<d;b++)c[b+1]=a[b];return c}var
er=aK;function
eA(c,b){return function(...a){a.length=c;return er(b,a)}}function
g3(a,b,c){if(a[0]===b){a[0]=c;return 1}return 0}function
z2(a){g3(a,au,W);return 0}function
z3(a){return Array.isArray(a)&&a[0]===a[0]>>>0&&g3(a,W,au)?0:1}function
z4(a){g3(a,au,at);return 0}function
gY(a,b){return+(es(a,b,false)<=0)}function
gZ(a,b){return+(es(a,b,false)<0)}function
ag(a){a=aS(a);var
d=a.length/2,c=new
Array(d);for(var
b=0;b<d;b++)c[b]=(a.charCodeAt(2*b)|a.charCodeAt(2*b+1)<<8)<<16>>16;return c}function
z5(a,b,c){var
o=2,p=3,s=5,e=6,i=7,h=8,k=9,n=1,m=2,r=3,t=4,q=5;if(!a.lex_default){a.lex_base=ag(a[n]);a.lex_backtrk=ag(a[m]);a.lex_check=ag(a[q]);a.lex_trans=ag(a[t]);a.lex_default=ag(a[r])}var
f,d=b,l=c[o];if(d>=0){c[i]=c[s]=c[e];c[h]=-1}else
d=-d-1;for(;;){var
g=a.lex_base[d];if(g<0)return-g-1;var
j=a.lex_backtrk[d];if(j>=0){c[i]=c[e];c[h]=j}if(c[e]>=c[p])if(c[k]===0)return-d-1;else
f=aP;else{f=bd(l,c[e]);c[e]++}if(a.lex_check[g+f]===d)d=a.lex_trans[g+f];else
d=a.lex_default[d];if(d<0){c[e]=c[i];if(c[h]===-1)M(lj);else
return c[h]}else if(f===aP)c[k]=0}}function
g0(a){var
b=[];for(;a!==0;a=a[2])b.push(a[1]);return b}var
z8=gV(B("0xdaba0b6eb09322e3")),z7=gV(B("0xd1342543de82ef95"));function
zo(a,b){return a.get(a.offset(b))}function
zY(a,b){return a.xor(b)}function
zU(a,b){return a.shift_right_unsigned(b)}function
zT(a,b){return a.shift_left(b)}function
eB(a){function
o(a,b){return zT(a,b)}function
h(a,b){return zU(a,b)}function
s(a,b){return nD(a,b)}function
f(a,b){return zY(a,b)}function
k(a,b){return ny(a,b)}function
i(a,b){return nA(a,b)}function
m(a,b){return s(o(a,b),h(a,64-b))}function
g(a,b){return zo(a,b)}function
j(a,b,c){return c1(a,b,c)}var
q=z7,l=z8,b,d,c,e=a,r=g(e,0),n=g(e,1),p=g(e,2),t=g(e,3);b=k(n,p);b=i(f(b,h(b,32)),l);b=i(f(b,h(b,32)),l);b=f(b,h(b,32));j(e,1,k(i(n,q),r));var
d=p,c=t;c=f(c,d);d=m(d,24);d=f(f(d,c),o(c,16));c=m(c,37);j(e,2,d);j(e,3,c);return b}function
zh(){var
a=new
ArrayBuffer(64),b=new
Uint32Array(a),c=new
Uint8Array(a);return{len:0,w:new
Uint32Array([0x67452301,0xefcdab89,0x98badcfe,0x10325476]),b32:b,b8:c}}var
en=function(){function
k(a,b){return a+b|0}function
l(a,b,c,d,e,f){b=k(k(b,a),k(d,f));return k(b<<e|b>>>32-e,c)}function
g(a,b,c,d,e,f,g){return l(b&c|~b&d,a,b,e,f,g)}function
h(a,b,c,d,e,f,g){return l(b&d|c&~d,a,b,e,f,g)}function
i(a,b,c,d,e,f,g){return l(b^c^d,a,b,e,f,g)}function
j(a,b,c,d,e,f,g){return l(c^(b|~d),a,b,e,f,g)}return function(a,b){var
c=a[0],d=a[1],e=a[2],f=a[3];c=g(c,d,e,f,b[0],7,0xd76aa478);f=g(f,c,d,e,b[1],12,0xe8c7b756);e=g(e,f,c,d,b[2],17,0x242070db);d=g(d,e,f,c,b[3],22,0xc1bdceee);c=g(c,d,e,f,b[4],7,0xf57c0faf);f=g(f,c,d,e,b[5],12,0x4787c62a);e=g(e,f,c,d,b[6],17,0xa8304613);d=g(d,e,f,c,b[7],22,0xfd469501);c=g(c,d,e,f,b[8],7,0x698098d8);f=g(f,c,d,e,b[9],12,0x8b44f7af);e=g(e,f,c,d,b[10],17,0xffff5bb1);d=g(d,e,f,c,b[11],22,0x895cd7be);c=g(c,d,e,f,b[12],7,0x6b901122);f=g(f,c,d,e,b[13],12,0xfd987193);e=g(e,f,c,d,b[14],17,0xa679438e);d=g(d,e,f,c,b[15],22,0x49b40821);c=h(c,d,e,f,b[1],5,0xf61e2562);f=h(f,c,d,e,b[6],9,0xc040b340);e=h(e,f,c,d,b[11],14,0x265e5a51);d=h(d,e,f,c,b[0],20,0xe9b6c7aa);c=h(c,d,e,f,b[5],5,0xd62f105d);f=h(f,c,d,e,b[10],9,0x02441453);e=h(e,f,c,d,b[15],14,0xd8a1e681);d=h(d,e,f,c,b[4],20,0xe7d3fbc8);c=h(c,d,e,f,b[9],5,0x21e1cde6);f=h(f,c,d,e,b[14],9,0xc33707d6);e=h(e,f,c,d,b[3],14,0xf4d50d87);d=h(d,e,f,c,b[8],20,0x455a14ed);c=h(c,d,e,f,b[13],5,0xa9e3e905);f=h(f,c,d,e,b[2],9,0xfcefa3f8);e=h(e,f,c,d,b[7],14,0x676f02d9);d=h(d,e,f,c,b[12],20,0x8d2a4c8a);c=i(c,d,e,f,b[5],4,0xfffa3942);f=i(f,c,d,e,b[8],11,0x8771f681);e=i(e,f,c,d,b[11],16,0x6d9d6122);d=i(d,e,f,c,b[14],23,0xfde5380c);c=i(c,d,e,f,b[1],4,0xa4beea44);f=i(f,c,d,e,b[4],11,0x4bdecfa9);e=i(e,f,c,d,b[7],16,0xf6bb4b60);d=i(d,e,f,c,b[10],23,0xbebfbc70);c=i(c,d,e,f,b[13],4,0x289b7ec6);f=i(f,c,d,e,b[0],11,0xeaa127fa);e=i(e,f,c,d,b[3],16,0xd4ef3085);d=i(d,e,f,c,b[6],23,0x04881d05);c=i(c,d,e,f,b[9],4,0xd9d4d039);f=i(f,c,d,e,b[12],11,0xe6db99e5);e=i(e,f,c,d,b[15],16,0x1fa27cf8);d=i(d,e,f,c,b[2],23,0xc4ac5665);c=j(c,d,e,f,b[0],6,0xf4292244);f=j(f,c,d,e,b[7],10,0x432aff97);e=j(e,f,c,d,b[14],15,0xab9423a7);d=j(d,e,f,c,b[5],21,0xfc93a039);c=j(c,d,e,f,b[12],6,0x655b59c3);f=j(f,c,d,e,b[3],10,0x8f0ccc92);e=j(e,f,c,d,b[10],15,0xffeff47d);d=j(d,e,f,c,b[1],21,0x85845dd1);c=j(c,d,e,f,b[8],6,0x6fa87e4f);f=j(f,c,d,e,b[15],10,0xfe2ce6e0);e=j(e,f,c,d,b[6],15,0xa3014314);d=j(d,e,f,c,b[13],21,0x4e0811a1);c=j(c,d,e,f,b[4],6,0xf7537e82);f=j(f,c,d,e,b[11],10,0xbd3af235);e=j(e,f,c,d,b[2],15,0x2ad7d2bb);d=j(d,e,f,c,b[9],21,0xeb86d391);a[0]=k(c,a[0]);a[1]=k(d,a[1]);a[2]=k(e,a[2]);a[3]=k(f,a[3])}}();function
zi(a,b,c){var
e=a.len&mp,d=0;a.len+=c;if(e){var
f=64-e;if(c<f){a.b8.set(b.subarray(0,c),e);return}a.b8.set(b.subarray(0,f),e);en(a.w,a.b32);c-=f;d+=f}while(c>=64){a.b8.set(b.subarray(d,d+64),0);en(a.w,a.b32);c-=64;d+=64}if(c)a.b8.set(b.subarray(d,d+c),0)}function
zg(a){var
c=a.len&mp;a.b8[c]=0x80;c++;if(c>56){for(var
b=c;b<64;b++)a.b8[b]=0;en(a.w,a.b32);for(var
b=0;b<56;b++)a.b8[b]=0}else
for(var
b=c;b<56;b++)a.b8[b]=0;a.b32[14]=a.len<<3;a.b32[15]=a.len>>29&0x1fffffff;en(a.w,a.b32);var
e=new
Uint8Array(16);for(var
d=0;d<4;d++)for(var
b=0;b<4;b++)e[d*4+b]=a.w[d]>>8*b&X;return e}function
Ar(a){return c8(a,0,a.length)}function
z_(a,b,c){var
d=zh(),e=eI(a);zi(d,e.subarray(b,b+c),c);return Ar(zg(d))}function
Ab(){return 0}function
ne(a){this.id=a}class
Aa{constructor(){this.map=new
d.WeakMap();this.opened=new
d.Set()}close(a){this.opened.delete(a)}get(a){return this.map.get(a)}set(a,b){if(b.opened)this.opened.add(a);return this.map.set(a,b)}all(){return this.opened.values()}}var
eC=new
Aa();function
g1(a){return eC.get(a)}function
aL(a){var
b=g1(a);if(!b.opened)R("Cannot flush a closed channel");if(!b.buffer||b.buffer_curr===0)return 0;if(b.output)b.output(c8(b.buffer,0,b.buffer_curr));else
for(var
c=0;c<b.buffer_curr;)c+=b.file.write(b.buffer,c,b.buffer_curr-c);b.offset+=b.buffer_curr;b.buffer_curr=0;return 0}class
ze{constructor(){this.locked=false}}function
Ac(a){return new
ze()}var
nE=65536;function
Au(a,b){if(b.altname)try{var
d=require(cX),c=d.openSync(b.altname,"rs");return new
gJ(c,b)}catch(f){}return new
gJ(a,b)}var
cb=new
Array(3);class
zd
extends
bb{constructor(a,b){super(F(0));this.log=function(a){return 0};if(a===1&&typeof
console.log==="function")this.log=console.log;else if(a===2&&typeof
console.error==="function")this.log=console.error;else if(typeof
console.log==="function")this.log=console.log;this.flags=b}length(){return 0}truncate(a,b){A(b,bE,"ftruncate",cS)}write(a,b,c,d){var
f=c;if(this.log){if(c>0&&b>=0&&b+c<=a.length&&a[b+c-1]===10)c--;var
e=F(c);a2(nq(a),b,e,0,c);this.log(e.toUtf16());return f}A(d,bC,ms,cT)}read(a,b,c,d){A(d,bC,kA,cT)}seek(a,b,c){A(c,ef,d5,mR)}close(){this.log=undefined}check_stream_semantics(a){}}function
eH(a,b){var
c;if(b===undefined){b=cb.length;c=new
ne(b)}else if(cb[b])c=cb[b].chanid;else
c=new
ne(b);cb[b]={file:a,chanid:c};return b|0}function
AI(a,b,c){var
d={};while(b){switch(b[1]){case
0:d.rdonly=1;break;case
1:d.wronly=1;break;case
2:d.append=1;d.writeonly=1;break;case
3:d.create=1;break;case
4:d.truncate=1;break;case
5:d.excl=1;break;case
6:d.binary=1;break;case
7:d.text=1;break;case
8:d.nonblock=1;break}b=b[2]}var
e=n4(a),f=e.device.open(e.rest,d,c);return eH(f,undefined)}(function(){var
c=c9();function
a(a,b){return c?Au(a,b):new
zd(a,b)}eH(a(0,{rdonly:1,altname:"/dev/stdin",isCharacterDevice:true}),0);eH(a(1,{buffered:c?1:2,wronly:1,isCharacterDevice:true}),1);eH(a(2,{buffered:c?1:2,wronly:1,isCharacterDevice:true}),2)}());function
Ad(a){var
b=cb[a];if(b===undefined)R(k_+a+k7);var
d=b.file,c=b.chanid,f=null,e={file:d,offset:d.offset,fd:a,opened:true,out:false,buffer_curr:0,buffer_max:0,buffer:new
Uint8Array(nE),refill:f};eC.set(c,e);return c}function
nI(a){var
c=cb[a];if(c===undefined)R(k_+a+k7);var
b=c.file,d=c.chanid,e=b.flags.buffered!==undefined?b.flags.buffered:1,f={file:b,offset:b.offset,fd:a,opened:true,out:true,buffer_curr:0,buffer:new
Uint8Array(nE),buffered:e};eC.set(d,f);return d}function
Ae(){var
a=0,d=eC.all();for(var
c
of
d){var
b=g1(c);if(b.opened&&b.out)a=[0,c,a]}return a}function
Ag(a,b,c,d){var
e=g1(a);if(!e.opened)R("Cannot output to a closed channel");b=b.subarray(c,c+d);if(e.buffer_curr+b.length>e.buffer.length){var
g=new
Uint8Array(e.buffer_curr+b.length);g.set(e.buffer);e.buffer=g}switch(e.buffered){case
0:e.buffer.set(b,e.buffer_curr);e.buffer_curr+=b.length;aL(a);break;case
1:e.buffer.set(b,e.buffer_curr);e.buffer_curr+=b.length;if(e.buffer_curr>=e.buffer.length)aL(a);break;case
2:var
f=b.lastIndexOf(10);if(f<0){e.buffer.set(b,e.buffer_curr);e.buffer_curr+=b.length;if(e.buffer_curr>=e.buffer.length)aL(a)}else{e.buffer.set(b.subarray(0,f+1),e.buffer_curr);e.buffer_curr+=f+1;aL(a);e.buffer.set(b.subarray(f+1),e.buffer_curr);e.buffer_curr+=b.length-f-1}break}return 0}function
Af(a,b,c,d){var
b=eI(b);return Ag(a,b,c,d)}function
g2(a,b,c,d){return Af(a,aJ(b),c,d)}function
nJ(a,b){var
c=a4(String.fromCharCode(b));g2(a,c,0,1);return 0}function
nK(a){if(Number.isFinite(a)){var
d=1/a<0;a=Math.abs(a);var
b=Math.floor(a),c=a-b;if(d){b=-b;c=-c}return[0,c,b]}if(Number.isNaN(a))return[0,Number.NaN,Number.NaN];return[0,1/a,a]}function
z6(a,b,c,d){for(;;){var
e=a.charCodeAt(b);b++;if(e===X)return;var
f=a.charCodeAt(b);b++;if(f===X)c[e+1]=d;else
c[e+1]=c[f+1]}}function
nH(a,b,c){for(;;){var
d=a.charCodeAt(b);b++;if(d===X)return;var
e=a.charCodeAt(b);b++;if(e===X)c[d+1]=-1;else
c[d+1]=c[e+1]}}function
Ai(a,b,c){var
u=2,v=3,B=5,g=6,j=7,i=8,o=9,k=10,s=1,q=2,z=3,C=4,w=5,t=6,r=7,A=8,D=9,x=10,y=11;if(!a.lex_default){a.lex_base=ag(a[s]);a.lex_backtrk=ag(a[q]);a.lex_check=ag(a[w]);a.lex_trans=ag(a[C]);a.lex_default=ag(a[z])}if(!a.lex_default_code){a.lex_base_code=ag(a[t]);a.lex_backtrk_code=ag(a[r]);a.lex_check_code=ag(a[x]);a.lex_trans_code=ag(a[D]);a.lex_default_code=ag(a[A])}if(a.lex_code==null)a.lex_code=aS(a[y]);var
f,d=b,p=c[u];if(d>=0){c[j]=c[B]=c[g];c[i]=-1}else
d=-d-1;for(;;){var
h=a.lex_base[d];if(h<0){var
e=a.lex_base_code[d];nH(a.lex_code,e,c[k]);return-h-1}var
m=a.lex_backtrk[d];if(m>=0){var
e=a.lex_backtrk_code[d];nH(a.lex_code,e,c[k]);c[j]=c[g];c[i]=m}if(c[g]>=c[v])if(c[o]===0)return-d-1;else
f=aP;else{f=bd(p,c[g]);c[g]++}var
l=d;if(a.lex_check[h+f]===d)d=a.lex_trans[h+f];else
d=a.lex_default[d];if(d<0){c[g]=c[j];if(c[i]===-1)M(lj);else
return c[i]}else{var
n=a.lex_base_code[l],e;if(a.lex_check_code[n+f]===l)e=a.lex_trans_code[n+f];else
e=a.lex_default_code[l];if(e>0)z6(a.lex_code,e,c[k],c[g]);if(f===aP)c[o]=0}}}function
be(a,b){return+(es(a,b,false)!==0)}function
Aj(a){return typeof
a==="number"?a:a.slice()}function
Y(a){if(Array.isArray(a)&&a[0]===a[0]>>>0)return a[0];else if(ey(a))return cV;else if(ez(a))return cV;else if(a
instanceof
Function||typeof
a==="function")return 247;else if(a?.caml_custom)return gi;else
return aq}var
n2=undefined;function
zp(a){var
d={},c=-1;if(a)for(var
b=1;b<a.length;b++){var
e=a[b][2];c=Math.max(c,e);d[r(a[b][1])]=e}d.next_idx=c+1;return d}function
aC(a,b,c){if(c){var
d=c;if(n2)a=er(n2,[d]);else if(N.symbols){if(!N.symidx)N.symidx=zp(N.symbols);var
e=N.symidx[d];if(e>=0)a=e;else{var
a=N.symidx.next_idx++;N.symidx[d]=a}}}N[a+1]=b;if(c)N[c]=b}function
g6(a,b){nL[aS(a)]=b;return 0}function
Ao(){H(gD)}function
t(a,b){if(b>>>0>=k(a))Ao();return av(a,b)}function
S(a){a.t&6&&c2(a);return a4(a.c)}function
At(){return lc/4|0}function
Al(){nO(N.Not_found)}function
g7(a){var
b=nZ(r(a));if(b===undefined)Al();return B(b)}function
Av(){if(d.crypto)if(d.crypto.getRandomValues){var
a=d.crypto.getRandomValues(new
Int32Array(4));return[0,a[0],a[1],a[2],a[3]]}else if(d.crypto.randomBytes){var
a=new
Int32Array(d.crypto.randomBytes(16).buffer);return[0,a[0],a[1],a[2],a[3]]}var
b=new
Date().getTime(),c=b^0xffffffff*Math.random();return[0,c]}function
g8(a){var
b=1;while(a?.joo_tramp){a=a.joo_tramp.apply(null,a.joo_args);b++}return a}function
bI(a,b,c){return{joo_tramp:a,joo_args:b,joo_direct:c}}function
g9(a){var
b=new
Date(a*aq),c=b.getTime(),e=new
Date(Date.UTC(b.getUTCFullYear(),0,1)).getTime(),d=Math.floor((c-e)/ky);return[0,b.getUTCSeconds(),b.getUTCMinutes(),b.getUTCHours(),b.getUTCDate(),b.getUTCMonth(),b.getUTCFullYear()-ej,b.getUTCDay(),d,false|0]}function
nU(a){var
b=new
Date(a*aq),c=b.getTime(),f=new
Date(b.getFullYear(),0,1).getTime(),d=Math.floor((c-f)/ky),e=new
Date(b.getFullYear(),0,1),g=new
Date(b.getFullYear(),6,1),h=Math.max(e.getTimezoneOffset(),g.getTimezoneOffset());return[0,b.getSeconds(),b.getMinutes(),b.getHours(),b.getDate(),b.getMonth(),b.getFullYear()-ej,b.getDay(),d,b.getTimezoneOffset()<h|0]}function
nV(a){var
c=new
Date(a[6]+ej,a[5],a[4],a[3],a[2],a[1]).getTime(),b=Math.floor(c/aq),d=nU(b);return[0,b,d]}function
Aw(){return new
Date().getTime()/aq}function
Ax(){return Math.floor(Aw())}function
cc(a,b){if(b.fun){a.fun=b.fun;return 0}if(typeof
b==="function"){a.fun=b;return 0}var
c=b.length;while(c--)a[c]=b[c];return 0}function
C(a){{if(Array.isArray(a))return a;var
b;if(d.RangeError&&a
instanceof
d.RangeError&&a.message&&a.message.match(/maximum call stack/i))b=N.Stack_overflow;else if(d.InternalError&&a
instanceof
d.InternalError&&a.message&&a.message.match(/too much recursion/i))b=N.Stack_overflow;else if(a
instanceof
d.Error&&ca(gG))b=[0,ca(gG),a];else
b=[0,N.Failure,B(String(a))];if(a
instanceof
d.Error)b.js_error=a;return b}}function
nW(){if(!window.r_calendar)window.r_calendar=require("@event-calendar/core");return window.r_calendar.default}function
Ay(){if(!window.r_calendar_day_grid)window.r_calendar_day_grid=require("@event-calendar/day-grid");return window.r_calendar_day_grid.default}function
Az(){if(!window.r_calendar_list)window.r_calendar_list=require("@event-calendar/list");return window.r_calendar_list.default}function
AA(){if(!window.r_calendar_resource_timegrid)window.r_calendar_resource_timegrid=require("@event-calendar/resource-time-grid");return window.r_calendar_resource_timegrid.default}function
AB(){if(!window.r_calendar_resource_timeline)window.r_calendar_resource_timeline=require("@event-calendar/resource-timeline");return window.r_calendar_resource_timeline.default}function
AC(){return require("../www/results.json")}function
AD(){if(!window.r_calendar_time_grid)window.r_calendar_time_grid=require("@event-calendar/time-grid");return window.r_calendar_time_grid.default}function
zZ(a){switch(a[2]){case-8:case-11:case-12:return 1;default:return 0}}function
zC(a){var
b=e;if(a[0]===0){b+=a[1][1];if(a.length===3&&a[2][0]===0&&zZ(a[1]))var
g=a[2],h=1;else
var
h=2,g=a;b+="(";for(var
f=h;f<g.length;f++){if(f>h)b+=bB;var
d=g[f];if(typeof
d==="number")b+=d.toString();else if(d
instanceof
bG)b+=ec+d.toString()+ec;else if(typeof
d==="string")b+=ec+d.toString()+ec;else
b+=l6}b+=")"}else if(a[0]===c)b+=a[1];return b}function
nu(a){if(Array.isArray(a)&&(a[0]===0||a[0]===c)){var
d=ca(kw);if(d)er(d,[a,false]);else{var
e=zC(a),b=ca(kZ);if(b)er(b,[0]);console.error(gF+e);if(a.js_error)throw a.js_error}}else
throw a}function
An(){var
c=d.process;if(c?.on)c.on("uncaughtException",function(a,b){nu(a);c.exit(2)});else if(d.addEventListener)d.addEventListener(l9,function(a){if(a.error)nu(a.error)})}An();function
g(a,b){return(a.l>=0?a.l:a.l=a.length)===1?a(b):aK(a,[b])}function
j(a,b,c){return(a.l>=0?a.l:a.l=a.length)===2?a(b,c):aK(a,[b,c])}function
_(a,b,c,d){return(a.l>=0?a.l:a.l=a.length)===3?a(b,c,d):aK(a,[b,c,d])}function
al(a,b,c,d,e){return(a.l>=0?a.l:a.l=a.length)===4?a(b,c,d,e):aK(a,[b,c,d,e])}function
d0(a,b,c,d,e,f){return(a.l>=0?a.l:a.l=a.length)===5?a(b,c,d,e,f):aK(a,[b,c,d,e,f])}function
d1(a,b,c,d,e,f,g){return(a.l>=0?a.l:a.l=a.length)===6?a(b,c,d,e,f,g):aK(a,[b,c,d,e,f,g])}function
zb(a,b,c,d,e,f,g,h){return(a.l>=0?a.l:a.l=a.length)===7?a(b,c,d,e,f,g,h):aK(a,[b,c,d,e,f,g,h])}function
kv(a,b,c,d,e,f,g,h,i){return(a.l>=0?a.l:a.l=a.length)===8?a(b,c,d,e,f,g,h,i):aK(a,[b,c,d,e,f,g,h,i])}var
AH=0;zD();var
eK=[c,lV,-1],hf=[c,mh,-2],bJ=[c,gC,-3],eJ=[c,lZ,-4],a5=[c,mo,-7],hd=[c,na,-8],he=[c,lY,-9],i=[c,mH,-11],hg=[c,lB,mn],hE=[0,e,0,0,-1],hH=[0,e,1,0,0],p6="%nd",p9=m$,qg="%nu",pT="%ld",pW=kK,p5="%lu",pG="%Ld",pJ=kX,pS="%Lu",pt=ea,pw=lQ,pF=lw,za=[4,0,0,0,[12,45,[4,0,0,0,0]]],e2=[0,[11,ei,[2,0,[11,'", line ',[4,0,0,0,[11,gy,[4,0,0,0,[12,45,[4,0,0,0,[11,cY,[2,0,0]]]]]]]]]],'File "%s", line %d, characters %d-%d: %s'],h2=[0,e,0,e],dJ=[0,"\0\0\n\0\x14\0\x1e\0(\x005\x009\0@\0J\0P\0]\0g\0k\0r\0|\0\x82\0\x8f\0\x9c\0\xfa\xff\xa6\x003\0\xaa\0\xfd\xff\xb4\0\xbe\0\xc2\0\xcc\0\x01\0\xd5\0\xfb\xff\xdd\0\xe4\0\xee\0Z\0\xf8\0\x02\x01\f\x01\x10\x01\x1a\x01#\x01+\x012\x01<\x01F\x01P\x01Z\x01\xff\xffd\x01g\x01l\x01z\x01\x85\x01\x8f\x01\x95\x01\xa3\x01\xaa\x01\x8c\0\xb4\x01{\x01\xbe\x01\xc8\x01\xd2\x01\xdc\x01\xea\x01\xe9\x01\x8d\0\xf5\x01\x84\x01\xff\x01\t\x02\x13\x02\xf5\x01 \x02\xff\xff#\x02(\x022\x02@\x02J\x02\xfe\xff-\x02\xff\xff","\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x03\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x05\0\x05\0\xff\xff\xff\xff\xff\xff\xff\xff\x03\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x02\0\xff\xff\xff\xff\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\0\0\xff\xff\0\0\x01\0\xff\xff\x01\0\xff\xff\xff\xff\xff\xff\0\0\xff\xff\0\0\x02\0\x03\0\xff\xff\xff\xff\xff\xff\xff\xff\x02\0\xff\xff\xff\xff\xff\xff\x01\0\xff\xff","\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\0\0","\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x01\0\0\0\x01\0\x1c\0\0\0\x02\0\x02\0\x02\0\x02\0\x02\0\x02\0\x02\0\x02\0\x02\0\x02\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\x05\0\v\0\x16\0\x16\0\n\0\t\0\x07\0\x06\0)\0)\0)\0)\0)\0)\0(\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0&\0%\0%\0%\0%\0$\0 \0 \0 \0#\0#\0#\0#\0#\0#\0#\0\x16\0\x16\0\b\0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0\x10\0\x0f\0\r\0\f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1e\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x1a\0\x19\0\x19\0\x19\0\x19\0\x18\0\x11\0\x11\0\x11\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0:\0C\0\x0e\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x13\0\0\0\0\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x15\0\x15\0\x15\0\x14\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1b\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\"\0\"\0\"\0!\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x16\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0'\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0\x12\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0.\0.\0.\0.\0.\0.\0.\0.\0.\0.\x001\x001\x000\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x002\x003\0;\x003\0;\x005\x005\x005\x005\x005\x005\0D\0\0\0D\0\0\x004\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0>\0>\0>\0>\0>\0>\x006\x006\x006\x006\x006\x006\x006\x006\x006\x006\x007\0\0\x007\0\0\x009\x009\x009\x009\x009\x009\x008\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0:\0:\0:\0:\0:\0:\0:\0:\0:\0:\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0?\0?\0?\0?\0?\0?\0?\0?\0?\0?\x007\0\0\x007\0B\0B\0B\0B\0B\0B\0A\0H\0\0\0H\0\0\0@\0C\0C\0C\0C\0C\0C\0C\0C\0C\0C\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0Q\0\0\0I\0K\0K\0J\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0L\0M\0M\0M\0M\0M\0M\0\0\0\0\0\0\0\0\0N\0\0\0\0\0I\0O\0O\0O\0O\0O\0O\0O\0O\0O\0O\0M\0M\0M\0M\0M\0M\0\0\0Q\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0Q\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0",'\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\0\0\xff\xff\0\0\x1b\0\xff\xff\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x01\0\x01\0\x01\0\x01\0\x01\0\x01\0\x01\0\x01\0\x01\0\x01\0\x02\0\x02\0\x02\0\x02\0\x02\0\x02\0\x02\0\x02\0\x02\0\x02\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x03\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x05\0\x14\0\x14\0\x05\0\x05\0\x05\0\x05\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x06\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\x07\0\b\0\b\0\b\0\b\0\b\0\b\0\t\0\t\0\t\0\t\0\t\0\t\0\t\0\t\0\t\0\t\0!\0!\0\x05\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\v\0\v\0\v\0\v\0\f\0\f\0\f\0\f\0\f\0\f\0\f\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\r\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0e\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\0\x0f\x008\0A\0\v\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x11\0\xff\xff\xff\xff\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x13\0\x13\0\x13\0\x13\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x18\0\x18\0\x18\0\x18\0\x19\0\x19\0\x19\0\x19\0\x19\0\x19\0\x19\0\x19\0\x19\0\x19\0\x1a\0\x1a\0\x1a\0\x1a\0\x1a\0\x1a\0\x1a\0\x1a\0\x1a\0\x1a\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1c\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0$\0$\0$\0$\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0\'\0\'\0\'\0\'\0\'\0\'\0\'\0(\0(\0(\0(\0(\0(\0(\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\0*\0*\0*\0*\0*\0*\0*\0*\0*\0*\0+\0+\0+\0+\0+\0+\0+\0+\0+\0+\0,\0,\0,\0,\0,\0,\0,\0,\0,\0,\0-\0-\0-\0-\0-\0-\0-\0-\0-\0-\0/\0/\0/\x000\x000\x000\x000\x000\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x002\0:\x002\0:\x002\x002\x002\x002\x002\x002\0C\0\xff\xffC\0\xff\xff2\x003\x003\x003\x003\x003\x003\x003\x003\x003\x003\x004\x004\x004\x004\x004\x004\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x006\0\xff\xff6\0\xff\xff6\x006\x006\x006\x006\x006\x006\x007\x007\x007\x007\x007\x007\x007\x007\x007\x007\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0=\0=\0=\0=\0=\0=\0=\0=\0=\0=\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0?\0\xff\xff?\0@\0@\0@\0@\0@\0@\0@\0G\0\xff\xffG\0\xff\xff?\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0F\0F\0F\0F\0F\0F\0F\0F\0F\0F\0P\0\xff\xffG\0H\0H\0H\0J\0J\0J\0J\0J\0K\0K\0K\0K\0K\0K\0K\0K\0K\0K\0L\0L\0L\0L\0L\0L\0\xff\xff\xff\xff\xff\xff\xff\xffL\0\xff\xff\xff\xffG\0M\0M\0M\0M\0M\0M\0M\0M\0M\0M\0N\0N\0N\0N\0N\0N\0\xff\xffP\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xffP\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff',"\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\n\0\r\0\x01\0\0\0\0\0\0\0\x17\0\x1a\0)\0+\0\0\0$\x003\x007\0=\0G\0K\0U\0\x01\0\0\0U\0_\0f\0p\0z\0|\0\x86\0\x90\0\x94\0\x9e\0\0\0\xa8\0\xaf\0\0\0\0\0\0\0\0\0\0\0\0\0\xb9\0\xbe\0\xbe\0\0\0\0\0\xc9\0\0\0\0\0\xd3\0\xd4\0\0\0\xde\0\xe8\0\0\0\xf2\0\xf2\0\0\0\xfd\0\xfe\0\0\0\b\x01\x12\x01\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0","\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0I\0\0\0\0\0\0\0\0\0\0\0+\0+\0\0\0\0\0\0\0\0\0I\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x7f\0\0\0\0\0\0\0\x89\0\0\0\x89\0\x7f\0\0\0\x7f\0\0\0\0\0\0\0\x89\0\0\0\x89\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0","\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0",'\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x0e\0R\0\0\0\x01\0\x01\0\x01\0\x01\0\x01\0\x01\0\x01\0\x01\0\x01\0\x01\0\x18\0\x18\0\x18\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0\x1d\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\x004\x004\0%\0\x13\0\x13\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\x004\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0`\0g\0g\0g\0g\0g\0g\0g\0g\0g\0g\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0(\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0n\0u\0z\0z\0z\0z\0z\0z\0z\0z\0z\0z\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9d\0\x9d\0\x9d\0\x9d\0\x9d\0\x9d\0\x9d\0\x9d\0\x9d\0\x9d\0\xa0\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x82\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\x9a\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0','\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\x05\0\x1b\0\xff\xff\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\x04\0\t\0\t\0\t\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\n\0\x0f\0\x0f\0\x0f\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x10\0\x14\0\x14\0\x11\0\x05\0\v\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x11\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x15\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x17\0\x18\0\x18\0\x18\0\x18\0\x19\0\x19\0\x19\0\x19\0\x19\0\x19\0\x19\0\x19\0\x19\0\x19\0\x1a\0\x1a\0\x1a\0\x1a\0\x1a\0\x1a\0\x1a\0\x1a\0\x1a\0\x1a\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1e\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0\x1f\0 \0 \0 \0 \0 \0 \0 \0 \0 \0 \0!\0!\0"\0"\0"\0"\0"\0"\0"\0"\0"\0"\0#\0#\0#\0#\0#\0#\0#\0#\0#\0#\0$\0$\0$\0$\0%\0%\0%\0%\0%\0%\0%\0%\0%\0%\0&\0&\0&\0&\0&\0&\0&\0&\0&\0&\0(\0(\0(\0(\0(\0(\0(\0)\0)\0)\0)\0)\0)\0)\0)\0)\0)\x000\x000\x000\x000\x000\x001\x001\x001\x001\x001\x001\x001\x001\x001\x001\x002\x005\x005\x005\x005\x005\x005\x005\x005\x005\x005\x008\x009\x009\x009\x009\x009\x009\x009\x009\x009\x009\0;\0;\0;\0;\0;\0;\0;\0;\0;\0;\0<\0<\0<\0<\0<\0<\0<\0<\0<\0<\0>\0>\0>\0>\0>\0>\0>\0>\0>\0>\0?\0A\0B\0B\0B\0B\0B\0B\0B\0B\0B\0B\0D\0D\0D\0D\0D\0D\0D\0D\0D\0D\0E\0E\0E\0E\0E\0E\0E\0E\0E\0E\0\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff\xff',"\xff\x0f\xff\x0e\xff\r\xff\f\xff\v\xff\n\xff\xff\x0e\xff\n\xff\xff\x11\xff\x10\xff\xff\x12\xff\x14\xff\xff\x14\xff\x12\xff\xff\x12\xff\xff\x14\xff\xff\x13\xff\xff\x03\t\x02\x0f\x01\x0e\0\x13\xff\x15\xff\xff\x05\x06\x04\v\x03\n\x02\x12\x01\x14\0\x15\xff\x17\xff\x16\xff\xff\x03\x07\x02\f\x01\x10\0\x16\xff\x18\xff\xff\x04\b\x03\r\x02\x11\x01\x17\0\x18\xff\x17\xff\x16\xff\x18\xff\xff\x18\xff\x17\xff\x16\xff\xff\v\xff\n\xff\t\xff\xff\v\xff\n\xff\xff\r\xff\f\xff\xff\0\v\xff\x10\xff\x0f\xff\x0e\xff\xff\x07\r\x06\x10\x05\n\x04\f\x03\b\x02\t\x01\x0f\0\x0e\xff\x0e\xff\xff\f\xff\xff\r\xff\xff"],dR="base map",jW=gk,f3=m_,j0=m_,dS="uint8",dT="uint16",dU="int8",dV="int16",f4="int32",j1=gz,j2=gz,j3=gh,j4=gh,j5="hex",j8=gk,j$=gk,cO=[0,"pouet",gw,0];aC(11,hg,lB);aC(10,i,mH);aC(9,[c,mb,-10],mb);aC(8,he,lY);aC(7,hd,na);aC(6,a5,mo);aC(5,[c,lG,-6],lG);aC(4,[c,lW,-5],lW);aC(3,eJ,lZ);aC(2,bJ,gC);aC(1,hf,mh);aC(0,eK,lV);function
y(a){if(typeof
a==="number")return 0;switch(a[0]){case
0:return[0,y(a[1])];case
1:return[1,y(a[1])];case
2:return[2,y(a[1])];case
3:return[3,y(a[1])];case
4:return[4,y(a[1])];case
5:return[5,y(a[1])];case
6:return[6,y(a[1])];case
7:return[7,y(a[1])];case
8:var
c=a[1];return[8,c,y(a[2])];case
9:var
b=a[1];return[9,b,b,y(a[3])];case
10:return[10,y(a[1])];case
11:return[11,y(a[1])];case
12:return[12,y(a[1])];case
13:return[13,y(a[1])];default:return[14,y(a[1])]}}function
Z(a,b){if(typeof
a==="number")return b;switch(a[0]){case
0:return[0,Z(a[1],b)];case
1:return[1,Z(a[1],b)];case
2:return[2,Z(a[1],b)];case
3:return[3,Z(a[1],b)];case
4:return[4,Z(a[1],b)];case
5:return[5,Z(a[1],b)];case
6:return[6,Z(a[1],b)];case
7:return[7,Z(a[1],b)];case
8:var
c=a[1];return[8,c,Z(a[2],b)];case
9:var
d=a[2],e=a[1];return[9,e,d,Z(a[3],b)];case
10:return[10,Z(a[1],b)];case
11:return[11,Z(a[1],b)];case
12:return[12,Z(a[1],b)];case
13:return[13,Z(a[1],b)];default:return[14,Z(a[1],b)]}}function
u(a,b){if(typeof
a==="number")return b;switch(a[0]){case
0:return[0,u(a[1],b)];case
1:return[1,u(a[1],b)];case
2:var
c=a[1];return[2,c,u(a[2],b)];case
3:var
d=a[1];return[3,d,u(a[2],b)];case
4:var
e=a[3],f=a[2],g=a[1];return[4,g,f,e,u(a[4],b)];case
5:var
h=a[3],i=a[2],j=a[1];return[5,j,i,h,u(a[4],b)];case
6:var
k=a[3],l=a[2],m=a[1];return[6,m,l,k,u(a[4],b)];case
7:var
n=a[3],o=a[2],p=a[1];return[7,p,o,n,u(a[4],b)];case
8:var
q=a[3],r=a[2],s=a[1];return[8,s,r,q,u(a[4],b)];case
9:var
t=a[1];return[9,t,u(a[2],b)];case
10:return[10,u(a[1],b)];case
11:var
v=a[1];return[11,v,u(a[2],b)];case
12:var
w=a[1];return[12,w,u(a[2],b)];case
13:var
x=a[2],y=a[1];return[13,y,x,u(a[3],b)];case
14:var
z=a[2],A=a[1];return[14,A,z,u(a[3],b)];case
15:return[15,u(a[1],b)];case
16:return[16,u(a[1],b)];case
17:var
B=a[1];return[17,B,u(a[2],b)];case
18:var
C=a[1];return[18,C,u(a[2],b)];case
19:return[19,u(a[1],b)];case
20:var
D=a[2],E=a[1];return[20,E,D,u(a[3],b)];case
21:var
F=a[1];return[21,F,u(a[2],b)];case
22:return[22,u(a[1],b)];case
23:var
G=a[1];return[23,G,u(a[2],b)];default:var
H=a[2],I=a[1];return[24,I,H,u(a[3],b)]}}function
ce(a){throw h([0,bJ,a],1)}function
n(a){throw h([0,eJ,a],1)}var
hc=[c,"Stdlib.Exit",an(0)];function
hh(a,b){return gY(a,b)?a:b}function
c_(a){return 0<=a?a:-a|0}var
hi=lt,n7="true",n8="false";function
hj(a){var
c=gN("%.12g",a),b=0,e=k(c);for(;;){if(e<=b)return c+a1;var
d=t(c,b);a:{if(48<=d){if(58<=d)break a}else if(45!==d)break a;b=b+1|0;continue}return c}}function
hk(a){try{var
c=[0,nv(a)];return c}catch(f){var
b=C(f);if(b[1]===bJ)return 0;throw h(b,0)}}Ad(0);var
hl=nI(1),ai=nI(2),n9="output_substring";function
cf(a,b){g2(a,b,0,k(b))}function
hm(a,b,c,d){if(0<=c&&0<=d&&(k(b)-d|0)>=c)return g2(a,b,c,d);return n(n9)}function
hn(a){cf(ai,a);nJ(ai,10);return aL(ai)}var
eL=[0,function(a){var
b=Ae(0);for(;;){if(!b)return 0;var
c=b[2],e=b[1];try{aL(e);b=c}catch(f){var
d=C(f);if(d[1]!==hf)throw h(d,0);b=c}}}],ho=[0,function(a){}];function
eM(a){g(ho[1],0);return g(bc(eL),0)}g6(kZ,eM);var
hp=At(0),cg=(4*hp|0)-1|0;function
hq(a){try{var
c=[0,g7(a)];return c}catch(f){var
b=C(f);if(b===a5)return 0;throw h(b,0)}}function
eN(a){return 1-(typeof
a==="number"?1:0)}var
od=[c,"CamlinternalLazy.Undefined",an(0)],oe="option is None",oh="Char.chr",oo="hd";function
aM(a){if(0!==z3(a))throw h(od,1);var
d=a[1];a[1]=0;try{var
c=g(d,0);a[1]=c;z4(a);return c}catch(f){var
b=C(f);a[1]=function(a){throw h(b,0)};z2(a);throw h(b,0)}}function
hr(a){return a?a[1]:n(oe)}function
hs(a){return a?1:0}function
ht(a){return 25<a+li>>>0?a:a+32|0}function
hu(a){return 25<a+d2>>>0?a:a-32|0}function
hv(a){return a?a[1]:ce(oo)}function
hw(a,b){var
c=a,d=b;for(;;){if(!c)return d;var
e=[0,c[1],d];c=c[2];d=e}}function
ab(a){return hw(a,0)}function
bg(a){if(!a)return 0;var
l=a[1],b=bg(a[2]);if(!l)return b;var
f=l[2],g=l[1];if(!f)return[0,g,b];var
h=f[2],m=f[1];if(!h)return[0,g,[0,m,b]];var
n=[0,h[1],ba],d=n,c=1,e=h[2];for(;;){if(e){var
i=e[2],j=e[1];if(i){var
k=i[2],o=i[1];if(k){var
p=[0,k[1],ba],q=k[2];d[c+1]=[0,j,[0,o,p]];d=p;c=1;e=q;continue}d[c+1]=[0,j,[0,o,b]]}else
d[c+1]=[0,j,b]}else
d[c+1]=b;return[0,g,[0,m,n]]}}function
aw(a,b){if(!b)return 0;var
f=b[2],i=b[1];if(!f)return[0,g(a,i),0];var
m=f[2],n=f[1],o=g(a,i),j=[0,g(a,n),ba],e=j,d=1,c=m;for(;;){if(c){var
h=c[2],k=c[1];if(h){var
p=h[2],q=h[1],r=g(a,k),l=[0,g(a,q),ba];e[d+1]=[0,r,l];e=l;d=1;c=p;continue}e[d+1]=[0,g(a,k),0]}else
e[d+1]=0;return[0,o,j]}}function
eO(a,b){var
d=b;for(;;){if(!d)return 0;var
h=d[2],i=g(a,d[1]);if(i)break;d=h}var
j=[0,i[1],ba],f=j,e=1,c=h;for(;;){if(!c){f[e+1]=0;return j}var
k=c[2],l=g(a,c[1]);if(l){var
m=[0,l[1],ba];f[e+1]=m;f=m;e=1;c=k}else
c=k}}var
ot="String.sub / Bytes.sub",ou="Bytes.blit",ov="String.blit / Bytes.blit_string",ow="String.concat",ox=e,oy="String.contains_from / Bytes.contains_from";function
bh(a,b){var
c=F(a);zB(c,0,a,b);return c}function
hx(a){var
b=ah(a),c=F(b);a2(a,0,c,0,b);return c}function
hy(a,b,c){if(0<=b&&0<=c&&(ah(a)-c|0)>=b){var
d=F(c);a2(a,b,d,0,c);return d}return n(ot)}function
c$(a,b,c){return S(hy(a,b,c))}function
hz(a,b,c,d,e){if(0<=e&&0<=b&&(ah(a)-e|0)>=b&&0<=d&&(ah(c)-e|0)>=d){a2(a,b,c,d,e);return}return n(ou)}function
aN(a,b,c,d,e){if(0<=e&&0<=b&&(k(a)-e|0)>=b&&0<=d&&(ah(c)-e|0)>=d){bH(a,b,c,d,e);return}return n(ov)}function
ch(a,b){return S(bh(a,b))}function
ci(a,b,c){return S(hy(aJ(a),b,c))}function
eP(a,b){if(!b)return ox;var
i=k(a);a:{var
d=0,c=b,q=0;for(;;){if(!c){var
o=d;break a}var
j=c[1];if(!c[2])break;var
l=c[2],m=(k(j)+i|0)+d|0;if(d<=m){d=m;c=l}else{d=n(ow);c=l}}var
o=k(j)+d|0}var
h=F(o),g=q,f=b;for(;;){if(f){var
e=f[1];if(f[2]){var
p=f[2];bH(e,0,h,g,k(e));bH(a,0,h,g+k(e)|0,i);g=(g+k(e)|0)+i|0;f=p;continue}bH(e,0,h,g,k(e))}return S(h)}}function
hA(a,b){var
d=[0,0],e=[0,k(b)],f=k(b)-1|0;if(f>=0){var
c=f;for(;;){if(av(b,c)===a){var
h=d[1];d[1]=[0,ci(b,c+1|0,(e[1]-c|0)-1|0),h];e[1]=c}var
i=c-1|0;if(0===c)break;c=i}}var
g=d[1];return[0,ci(b,0,e[1]),g]}var
hB=Ap,oC="Array.blit",oE=ek,oF=ek,oG=ek,oH=ek,oI="Map.remove_min_elt",oJ=[0,0,0,0];function
da(a,b){return zs(aJ(a),b)}function
hC(a,b,c,d,e){if(0<=e&&0<=b&&(a.length-1-e|0)>=b&&0<=d&&(c.length-1-e|0)>=d){zj(a,b,c,d,e);return}return n(oC)}function
hD(a){if(!a)return[0];var
d=0,c=a,g=a[2],h=a[1];for(;;){if(!c)break;d=d+1|0;c=c[2]}var
f=aI(d,h),e=1,b=g;for(;;){if(!b)return f;var
i=b[2];f[e+1]=b[1];e=e+1|0;b=i}}function
eQ(a){return a-a===0.?1:0}function
hF(a,b,c){var
e=z5(a,b,c),f=0<=e?1:0,g=f?c[12]!==hE?1:0:f;if(g){c[11]=c[12];var
d=c[12];c[12]=[0,d[1],d[2],d[3],c[4]+c[6]|0]}return e}function
hG(a,b,c){var
e=Ai(a,b,c),f=0<=e?1:0,g=f?c[12]!==hE?1:0:f;if(g){c[11]=c[12];var
d=c[12];c[12]=[0,d[1],d[2],d[3],c[4]+c[6]|0]}return e}function
z(a,b,c){return c$(a[2],b,c-b|0)}function
db(a,b){return zr(a[2],b)}function
eR(l){function
k(a){return a?a[5]:0}function
f(a,b,c,d){var
e=k(a),f=k(d),g=f<=e?e+1|0:f+1|0;return[0,a,b,c,d,g]}function
o(a,b){return[0,0,a,b,0,1]}function
e(a,b,c,d){var
h=a?a[5]:0,i=d?d[5]:0;if((i+2|0)<h){if(!a)return n(oF);var
e=a[4],m=a[3],o=a[2],j=a[1],r=k(e);if(r<=k(j))return f(j,o,m,f(e,b,c,d));if(!e)return n(oE);var
s=e[3],t=e[2],u=e[1],v=f(e[4],b,c,d);return f(f(j,o,m,u),t,s,v)}if((h+2|0)>=i){var
B=i<=h?h+1|0:i+1|0;return[0,a,b,c,d,B]}if(!d)return n(oH);var
l=d[4],p=d[3],q=d[2],g=d[1],w=k(g);if(w<=k(l))return f(f(a,b,c,g),q,p,l);if(!g)return n(oG);var
x=g[3],y=g[2],z=g[1],A=f(g[4],q,p,l);return f(f(a,b,c,z),y,x,A)}function
p(a,b,c){if(!c)return[0,0,a,b,0,1];var
d=c[4],g=c[3],h=c[2],f=c[1],n=c[5],i=j(l[1],a,h);if(0===i)return g===b?c:[0,f,a,b,d,n];if(0<=i){var
k=p(a,b,d);return d===k?c:e(f,h,g,k)}var
m=p(a,b,f);return f===m?c:e(m,h,g,d)}function
c(a){var
b=a;for(;;){if(!b)throw h(a5,1);var
c=b[1];if(!c)return[0,b[2],b[3]];b=c}}function
q(a){if(!a)return n(oI);var
b=a[1];if(!b)return a[4];var
c=a[4],d=a[3],f=a[2];return e(q(b),f,d,c)}function
u(a,b){if(!a)return b;if(!b)return a;var
d=c(b),f=d[2],g=d[1];return e(a,g,f,q(b))}function
r(a,b){if(!b)return 0;var
c=b[4],g=b[3],f=b[2],d=b[1],h=j(l[1],a,f);if(0===h)return u(d,c);if(0<=h){var
i=r(a,c);return c===i?b:e(d,f,g,i)}var
k=r(a,d);return d===k?b:e(k,f,g,c)}function
s(a,b,c){if(!c){var
q=g(b,0);return q?[0,0,a,q[1],0,1]:0}var
d=c[4],h=c[3],i=c[2],f=c[1],r=c[5],k=j(l[1],a,i);if(0===k){var
m=g(b,[0,h]);if(!m)return u(f,d);var
n=m[1];return h===n?c:[0,f,a,n,d,r]}if(0<=k){var
o=s(a,b,d);return d===o?c:e(f,i,h,o)}var
p=s(a,b,f);return f===p?c:e(p,i,h,d)}function
v(a,b,c){var
d=b,e=c;for(;;){if(!d)return e;var
f=d[4],g=d[3],h=d[2],i=_(a,h,g,v(a,d[1],e));d=f;e=i}}function
w(a,b,c){if(!c)return o(a,b);var
d=c[4],f=c[3],g=c[2];return e(w(a,b,c[1]),g,f,d)}function
x(a,b,c){if(!c)return o(a,b);var
d=c[3],f=c[2],g=c[1];return e(g,f,d,x(a,b,c[4]))}function
i(a,b,c,d){if(!a)return w(b,c,d);if(!d)return x(b,c,a);var
g=d[5],h=a[5],j=d[4],k=d[3],l=d[2],m=d[1],n=a[4],o=a[3],p=a[2],q=a[1];return(g+2|0)<h?e(q,p,o,i(n,b,c,d)):(h+2|0)<g?e(i(a,b,c,m),l,k,j):f(a,b,c,d)}function
y(a,b){if(!a)return b;if(!b)return a;var
d=c(b),e=d[2],f=d[1];return i(a,f,e,q(b))}function
z(a,b,c,d){return c?i(a,b,c[1],d):y(a,d)}function
m(a,b){if(!b)return oJ;var
c=b[4],d=b[3],e=b[2],f=b[1],k=j(l[1],a,e);if(0===k)return[0,f,[0,d],c];if(0<=k){var
g=m(a,c),n=g[3],o=g[2];return[0,i(f,e,d,g[1]),o,n]}var
h=m(a,f),p=h[2],q=h[1];return[0,q,p,i(h[3],e,d,c)]}function
d(a,b,c){if(b){if(c){var
j=c[3],e=c[2],k=b[3],f=b[2],t=c[4],u=c[1],v=b[4],w=b[1];if(c[5]<=b[5]){var
g=m(f,c),l=g[2],x=g[3],n=d(a,w,g[1]),o=d(a,v,x);return l?z(n,f,_(a,f,k,l[1]),o):i(n,f,k,o)}var
h=m(e,b),p=h[2],y=h[3],q=d(a,h[1],u),r=d(a,y,t);return p?z(q,e,_(a,e,p[1],j),r):i(q,e,j,r)}var
s=b}else
var
s=c;return s}function
t(a,b){if(!b)return 0;var
e=b[4],f=b[3],g=b[2],h=b[1],c=t(a,h),k=j(a,g,f),d=t(a,e);if(!k)return y(c,d);if(h===c&&e===d)return b;return i(c,g,f,d)}function
A(a,b){var
d=a,c=b;for(;;){if(!c)return d;var
e=c[3],f=c[2],g=c[1];d=[0,[0,f,e],A(d,c[4])];c=g}}return[0,0,p,,s,o,r,,d,,function(a){return A(0,a)},c,,,,,,function(a,b){var
c=b;for(;;){if(!c)throw h(a5,1);var
e=c[4],f=c[3],g=c[1],d=j(l[1],a,c[2]);if(0===d)return f;c=0<=d?e:g}},function(a,b){var
c=b;for(;;){if(!c)return 0;var
e=c[4],f=c[3],g=c[1],d=j(l[1],a,c[2]);if(0===d)return[0,f];c=0<=d?e:g}},,,,,,v,,,t]}function
cj(a){return[0,0,0]}function
ck(a){a[1]=0;a[2]=0}function
bi(a,b){b[1]=[0,a,b[1]];b[2]=b[2]+1|0;return 0}function
bK(a){var
b=a[1];if(!b)return 0;var
c=b[1];a[1]=b[2];a[2]=a[2]-1|0;return[0,c]}function
bL(a){var
b=a[1];return b?[0,b[1]]:0}var
oK=[c,"Stdlib.Queue.Empty",an(0)],oM="Buffer.add: cannot grow buffer",oN="Buffer.add_substring";function
eS(a){return[0,0,0,0]}function
eT(a){a[1]=0;a[2]=0;a[3]=0}function
eU(a,b){var
c=[0,a,0],d=b[3];return d?(b[1]=b[1]+1|0,d[2]=c,b[3]=c,0):(b[1]=1,b[2]=c,b[3]=c,0)}function
hI(a){var
b=a[2];if(!b)throw h(oK,1);var
c=b[1];if(b[2]){var
d=b[2];a[1]=a[1]-1|0;a[2]=d;return c}eT(a);return c}function
eV(a){return 0===a[1]?1:0}function
a6(a){var
b=1<=a?a:1,c=cg<b?cg:b,d=F(c);return[0,[0,d,c],0,d]}function
cl(a){return c$(a[1][1],0,a[2])}function
hJ(a,b){var
d=a[2],c=[0,a[1][2]];for(;;){if(c[1]>=(d+b|0))break;c[1]=2*c[1]|0}if(cg<c[1])if((d+b|0)<=cg)c[1]=cg;else
ce(oM);var
e=F(c[1]);hz(a[1][1],0,e,0,a[2]);a[1]=[0,e,c[1]]}function
eW(a,b,c,d){var
e=c<0?1:0;if(e)var
f=e;else
var
l=d<0?1:0,f=l||((k(b)-d|0)<c?1:0);if(f)n(oN);var
g=a[2],h=a[1],i=g+d|0,j=h[1];if(h[2]<i){hJ(a,d);aN(b,c,a[1][1],a[2],d)}else
bH(b,c,j,g,d);a[2]=i;return 0}function
cm(a,b){return eW(a,b,0,k(b))}var
dc=[0,0];zz(aI(8,dc));var
ku=[0,0],oc=[0,0],oO=[0,"domain.ml",184,13];function
aU(a,b){var
c=[0,zl(oc,1),b];if(a){var
e=[0,c,a[1]];for(;;){var
d=bc(ku);if(!(1-eo(ku,d,[0,e,d])))break}}return c}function
hK(a){for(;;){var
b=nt(0),d=b.length-1;if(a<d)return b;var
c=d;for(;;){if(a<c){var
e=aI(c,dc);hC(b,0,e,0,d);if(zy(b,e))return e;break}c=2*c|0}}}function
cn(a,b){var
c=a[1];f(hK(c),c)[c+1]=b}function
aO(a){var
b=a[1],k=a[2],c=f(hK(b),b)[b+1];if(c!==dc)return c;var
e=g(k,0),d=nt(0),l=f(d,b)[b+1]===c?(d[b+1]=e,1):0;if(l)return e;var
j=f(d,b)[b+1];if(j!==dc)return j;throw h([0,i,oO],1)}var
eX=aU(0,function(a){return function(a){return 0}});function
hL(c){var
b=aO(eX);return cn(eX,function(a){g(c,0);return g(b,0)})}ho[1]=function(a){return g(aO(eX),0)};var
oQ="@]",oR="@}",oS="@?",oT="@\n",oU="@.",oV="@@",oW="@%",oX="%c",oY="%s",oZ=lQ,o0=kK,o1=m$,o2=kX,o3="%f",o4="%B",o5="%{",o6="%}",o7="%(",o8="%)",o9=gj,o_="%t",o$="%?",pa="%r",pb="%_r",pc=[0,K,850,23],pd=[0,K,837,26],pe=[0,K,847,28],pf=[0,K,815,21],pg=[0,K,819,21],ph=[0,K,823,19],pi=[0,K,827,22],pj=[0,K,832,30],pk=[0,K,851,23],pl=[0,K,836,26],pm=[0,K,846,28],pn=[0,K,814,21],po=[0,K,818,21],pp=[0,K,822,19],pq=[0,K,826,22],pr=[0,K,831,30];function
eY(a){return 5===a[2]?12:-6}function
hM(a){return[0,0,F(a)]}function
hN(a,b){var
c=ah(a[2]),d=a[1]+b|0;if(c<d){var
e=c*2|0,g=d<=e?e:d,f=F(g);hz(a[2],0,f,0,c);a[2]=f}}function
bM(a,b){hN(a,1);aA(a[2],a[1],b);a[1]=a[1]+1|0}function
P(a,b){var
c=k(b);hN(a,c);aN(b,0,a[2],a[1],c);a[1]=a[1]+c|0}function
hO(a){return c$(a[2],0,a[1])}function
hP(a){if(typeof
a==="number")switch(a){case
0:return oQ;case
1:return oR;case
2:return oS;case
3:return oT;case
4:return oU;case
5:return oV;default:return oW}return 2===a[0]?"@"+ch(1,a[1]):a[1]}function
eZ(a,b){var
c=b;for(;;){if(typeof
c==="number")return;switch(c[0]){case
0:var
d=c[1];P(a,oX);c=d;break;case
1:var
e=c[1];P(a,oY);c=e;break;case
2:var
f=c[1];P(a,oZ);c=f;break;case
3:var
g=c[1];P(a,o0);c=g;break;case
4:var
h=c[1];P(a,o1);c=h;break;case
5:var
i=c[1];P(a,o2);c=i;break;case
6:var
j=c[1];P(a,o3);c=j;break;case
7:var
k=c[1];P(a,o4);c=k;break;case
8:var
l=c[2],m=c[1];P(a,o5);eZ(a,m);P(a,o6);c=l;break;case
9:var
n=c[3],o=c[1];P(a,o7);eZ(a,o);P(a,o8);c=n;break;case
10:var
p=c[1];P(a,o9);c=p;break;case
11:var
q=c[1];P(a,o_);c=q;break;case
12:var
r=c[1];P(a,o$);c=r;break;case
13:var
s=c[1];P(a,pa);c=s;break;default:var
t=c[1];P(a,pb);c=t}}}function
G(a){if(typeof
a==="number")return 0;switch(a[0]){case
0:return[0,G(a[1])];case
1:return[1,G(a[1])];case
2:return[2,G(a[1])];case
3:return[3,G(a[1])];case
4:return[4,G(a[1])];case
5:return[5,G(a[1])];case
6:return[6,G(a[1])];case
7:return[7,G(a[1])];case
8:var
b=a[1];return[8,b,G(a[2])];case
9:var
c=a[2],d=a[1];return[9,c,d,G(a[3])];case
10:return[10,G(a[1])];case
11:return[11,G(a[1])];case
12:return[12,G(a[1])];case
13:return[13,G(a[1])];default:return[14,G(a[1])]}}function
Q(a){if(typeof
a==="number")return[0,,function(a){},,function(a){}];switch(a[0]){case
0:var
b=Q(a[1]),r=b[2];return[0,,function(a){r(0)},,b[4]];case
1:var
c=Q(a[1]),s=c[2];return[0,,function(a){s(0)},,c[4]];case
2:var
d=Q(a[1]),t=d[2];return[0,,function(a){t(0)},,d[4]];case
3:var
e=Q(a[1]),u=e[2];return[0,,function(a){u(0)},,e[4]];case
4:var
f=Q(a[1]),v=f[2];return[0,,function(a){v(0)},,f[4]];case
5:var
g=Q(a[1]),w=g[2];return[0,,function(a){w(0)},,g[4]];case
6:var
h=Q(a[1]),x=h[2];return[0,,function(a){x(0)},,h[4]];case
7:var
i=Q(a[1]),y=i[2];return[0,,function(a){y(0)},,i[4]];case
8:var
j=Q(a[2]),z=j[2];return[0,,function(a){z(0)},,j[4]];case
9:var
A=a[2],B=a[1],k=Q(a[3]),C=k[4],D=k[2],l=Q(I(G(B),A)),E=l[4],F=l[2];return[0,,function(a){F(0);D(0)},,function(a){E(0);C(0)}];case
10:var
m=Q(a[1]),H=m[2];return[0,,function(a){H(0)},,m[4]];case
11:var
n=Q(a[1]),J=n[2];return[0,,function(a){J(0)},,n[4]];case
12:var
o=Q(a[1]),K=o[2];return[0,,function(a){K(0)},,o[4]];case
13:var
p=Q(a[1]),L=p[4],M=p[2];return[0,,function(a){M(0)},,function(a){L(0)}];default:var
q=Q(a[1]),N=q[4],O=q[2];return[0,,function(a){O(0)},,function(a){N(0)}]}}function
I(a,b){a:{b:{c:{d:{e:{f:{g:{if(typeof
a!=="number"){switch(a[0]){case
0:var
d=a[1];if(typeof
b!=="number")switch(b[0]){case
0:return[0,I(d,b[1])];case
10:break a;case
11:break b;case
12:break c;case
13:break d;case
14:break e;case
8:break f;case
9:break g}break;case
1:var
e=a[1];if(typeof
b!=="number")switch(b[0]){case
1:return[1,I(e,b[1])];case
10:break a;case
11:break b;case
12:break c;case
13:break d;case
14:break e;case
8:break f;case
9:break g}break;case
2:var
f=a[1];if(typeof
b!=="number")switch(b[0]){case
2:return[2,I(f,b[1])];case
10:break a;case
11:break b;case
12:break c;case
13:break d;case
14:break e;case
8:break f;case
9:break g}break;case
3:var
g=a[1];if(typeof
b!=="number")switch(b[0]){case
3:return[3,I(g,b[1])];case
10:break a;case
11:break b;case
12:break c;case
13:break d;case
14:break e;case
8:break f;case
9:break g}break;case
4:var
j=a[1];if(typeof
b!=="number")switch(b[0]){case
4:return[4,I(j,b[1])];case
10:break a;case
11:break b;case
12:break c;case
13:break d;case
14:break e;case
8:break f;case
9:break g}break;case
5:var
k=a[1];if(typeof
b!=="number")switch(b[0]){case
5:return[5,I(k,b[1])];case
10:break a;case
11:break b;case
12:break c;case
13:break d;case
14:break e;case
8:break f;case
9:break g}break;case
6:var
l=a[1];if(typeof
b!=="number")switch(b[0]){case
6:return[6,I(l,b[1])];case
10:break a;case
11:break b;case
12:break c;case
13:break d;case
14:break e;case
8:break f;case
9:break g}break;case
7:var
m=a[1];if(typeof
b!=="number")switch(b[0]){case
7:return[7,I(m,b[1])];case
10:break a;case
11:break b;case
12:break c;case
13:break d;case
14:break e;case
8:break f;case
9:break g}break;case
8:var
n=a[2],o=a[1];if(typeof
b!=="number")switch(b[0]){case
8:var
p=b[1],q=I(n,b[2]);return[8,I(o,p),q];case
10:break a;case
11:break b;case
12:break c;case
13:break d;case
14:break e}throw h([0,i,pl],1);case
9:var
r=a[3],s=a[2],t=a[1];if(typeof
b!=="number")switch(b[0]){case
9:var
u=b[3],v=b[2],w=b[1],c=Q(I(G(s),w)),x=c[4];c[2].call(null,0);x(0);return[9,t,v,I(r,u)];case
10:break a;case
11:break b;case
12:break c;case
13:break d;case
14:break e;case
8:break f}throw h([0,i,pm],1);case
10:var
y=a[1];if(typeof
b!=="number"&&10===b[0])return[10,I(y,b[1])];throw h([0,i,pn],1);case
11:var
z=a[1];if(typeof
b!=="number")switch(b[0]){case
11:return[11,I(z,b[1])];case
10:break a}throw h([0,i,po],1);case
12:var
A=a[1];if(typeof
b!=="number")switch(b[0]){case
12:return[12,I(A,b[1])];case
10:break a;case
11:break b}throw h([0,i,pp],1);case
13:var
B=a[1];if(typeof
b!=="number")switch(b[0]){case
13:return[13,I(B,b[1])];case
10:break a;case
11:break b;case
12:break c}throw h([0,i,pq],1);default:var
C=a[1];if(typeof
b!=="number")switch(b[0]){case
14:return[14,I(C,b[1])];case
10:break a;case
11:break b;case
12:break c;case
13:break d}throw h([0,i,pr],1)}throw h([0,i,pk],1)}if(typeof
b==="number")return 0;switch(b[0]){case
10:break a;case
11:break b;case
12:break c;case
13:break d;case
14:break e;case
8:break f;case
9:break;default:throw h([0,i,pc],1)}}throw h([0,i,pe],1)}throw h([0,i,pd],1)}throw h([0,i,pj],1)}throw h([0,i,pi],1)}throw h([0,i,ph],1)}throw h([0,i,pg],1)}throw h([0,i,pf],1)}var
L=[c,"CamlinternalFormat.Type_mismatch",an(0)];function
n6(a){return a?n7:n8}var
oi=l2,oj="\\'",ok="\\b",ol=m9,om=l1,on=m0,pu="%+d",pv="% d",px="%+i",py="% i",pz="%x",pA="%#x",pB="%X",pC="%#X",pD="%o",pE="%#o",pH="%+Ld",pI="% Ld",pK="%+Li",pL="% Li",pM="%Lx",pN="%#Lx",pO="%LX",pP="%#LX",pQ="%Lo",pR="%#Lo",pU="%+ld",pV="% ld",pX="%+li",pY="% li",pZ="%lx",p0="%#lx",p1="%lX",p2="%#lX",p3="%lo",p4="%#lo",p7="%+nd",p8="% nd",p_="%+ni",p$="% ni",qa="%nx",qb="%#nx",qc="%nX",qd="%#nX",qe="%no",qf="%#no",qh=[0,gm],qm="neg_infinity",qn=my,qo=gH,qq=[0,K,1558,4],qr="Printf: bad conversion %[",qs=[0,K,1626,39],qt=[0,K,1649,31],qu=[0,K,1650,31],qv="Printf: bad conversion %_",qw=ml,qx=mE,qy=ml,qz=mE;function
dd(a,b){if(typeof
a==="number")return[0,0,b];if(0===a[0])return[0,[0,a[1],a[2]],b];if(typeof
b!=="number"&&2===b[0])return[0,[1,a[1]],b[1]];throw h(L,1)}function
co(a,b,c){var
d=dd(a,c);if(typeof
b!=="number")return[0,d[1],[0,b[1]],d[2]];if(!b)return[0,d[1],0,d[2]];var
e=d[2];if(typeof
e!=="number"&&2===e[0])return[0,d[1],1,e[1]];throw h(L,1)}function
o(a,b){if(typeof
a==="number")return[0,0,b];switch(a[0]){case
0:if(typeof
b!=="number"&&0===b[0]){var
u=o(a[1],b[1]);return[0,[0,u[1]],u[2]]}break;case
1:if(typeof
b!=="number"&&0===b[0]){var
v=o(a[1],b[1]);return[0,[1,v[1]],v[2]]}break;case
2:var
af=a[2],w=dd(a[1],b),e=w[2],ag=w[1];if(typeof
e!=="number"&&1===e[0]){var
x=o(af,e[1]);return[0,[2,ag,x[1]],x[2]]}throw h(L,1);case
3:var
ah=a[2],z=dd(a[1],b),f=z[2],ai=z[1];if(typeof
f!=="number"&&1===f[0]){var
A=o(ah,f[1]);return[0,[3,ai,A[1]],A[2]]}throw h(L,1);case
4:var
aj=a[4],ak=a[1],g=co(a[2],a[3],b),i=g[3],al=g[1];if(typeof
i!=="number"&&2===i[0]){var
am=g[2],B=o(aj,i[1]);return[0,[4,ak,al,am,B[1]],B[2]]}throw h(L,1);case
5:var
an=a[4],ao=a[1],j=co(a[2],a[3],b),k=j[3],ap=j[1];if(typeof
k!=="number"&&3===k[0]){var
aq=j[2],C=o(an,k[1]);return[0,[5,ao,ap,aq,C[1]],C[2]]}throw h(L,1);case
6:var
ar=a[4],as=a[1],l=co(a[2],a[3],b),m=l[3],at=l[1];if(typeof
m!=="number"&&4===m[0]){var
au=l[2],D=o(ar,m[1]);return[0,[6,as,at,au,D[1]],D[2]]}throw h(L,1);case
7:var
av=a[4],aw=a[1],n=co(a[2],a[3],b),p=n[3],ax=n[1];if(typeof
p!=="number"&&5===p[0]){var
ay=n[2],E=o(av,p[1]);return[0,[7,aw,ax,ay,E[1]],E[2]]}throw h(L,1);case
8:var
az=a[4],aA=a[1],q=co(a[2],a[3],b),r=q[3],aB=q[1];if(typeof
r!=="number"&&6===r[0]){var
aC=q[2],F=o(az,r[1]);return[0,[8,aA,aB,aC,F[1]],F[2]]}throw h(L,1);case
9:var
aD=a[2],G=dd(a[1],b),s=G[2],aE=G[1];if(typeof
s!=="number"&&7===s[0]){var
H=o(aD,s[1]);return[0,[9,aE,H[1]],H[2]]}throw h(L,1);case
10:var
I=o(a[1],b);return[0,[10,I[1]],I[2]];case
11:var
aF=a[1],J=o(a[2],b);return[0,[11,aF,J[1]],J[2]];case
12:var
aG=a[1],K=o(a[2],b);return[0,[12,aG,K[1]],K[2]];case
13:if(typeof
b!=="number"&&8===b[0]){var
M=b[1],aH=b[2],aI=a[3],aJ=a[1];if(be([0,a[2]],[0,M]))throw h(L,1);var
N=o(aI,aH);return[0,[13,aJ,M,N[1]],N[2]]}break;case
14:if(typeof
b!=="number"&&9===b[0]){var
O=b[1],aK=b[3],aL=a[3],aM=a[2],aN=a[1],aO=[0,y(O)];if(be([0,y(aM)],aO))throw h(L,1);var
P=o(aL,y(aK));return[0,[14,aN,O,P[1]],P[2]]}break;case
15:if(typeof
b!=="number"&&10===b[0]){var
Q=o(a[1],b[1]);return[0,[15,Q[1]],Q[2]]}break;case
16:if(typeof
b!=="number"&&11===b[0]){var
R=o(a[1],b[1]);return[0,[16,R[1]],R[2]]}break;case
17:var
aP=a[1],S=o(a[2],b);return[0,[17,aP,S[1]],S[2]];case
18:var
T=a[2],t=a[1];if(0===t[0]){var
X=t[1],aT=X[2],Y=o(X[1],b),aU=Y[1],Z=o(T,Y[2]);return[0,[18,[0,[0,aU,aT]],Z[1]],Z[2]]}var
_=t[1],aV=_[2],$=o(_[1],b),aW=$[1],aa=o(T,$[2]);return[0,[18,[1,[0,aW,aV]],aa[1]],aa[2]];case
19:if(typeof
b!=="number"&&13===b[0]){var
U=o(a[1],b[1]);return[0,[19,U[1]],U[2]]}break;case
20:if(typeof
b!=="number"&&1===b[0]){var
aQ=a[2],aR=a[1],V=o(a[3],b[1]);return[0,[20,aR,aQ,V[1]],V[2]]}break;case
21:if(typeof
b!=="number"&&2===b[0]){var
aS=a[1],W=o(a[2],b[1]);return[0,[21,aS,W[1]],W[2]]}break;case
23:var
d=a[2],c=a[1];if(typeof
c!=="number")switch(c[0]){case
8:return e0([8,c[1],c[2]],d,b);case
9:var
aX=c[1],ad=ac(c[2],d,b),ae=ad[2];return[0,[23,[9,aX,ad[1]],ae[1]],ae[2]];default:return e0(c,d,b)}if(2!==c)return e0(c,d,b);if(typeof
b!=="number"&&14===b[0]){var
ab=o(d,b[1]);return[0,[23,2,ab[1]],ab[2]]}throw h(L,1)}throw h(L,1)}function
e0(a,b,c){var
d=o(b,c);return[0,[23,a,d[1]],d[2]]}function
ac(a,b,c){if(typeof
a==="number")return[0,0,o(b,c)];switch(a[0]){case
0:if(typeof
c!=="number"&&0===c[0]){var
f=ac(a[1],b,c[1]);return[0,[0,f[1]],f[2]]}break;case
1:if(typeof
c!=="number"&&1===c[0]){var
g=ac(a[1],b,c[1]);return[0,[1,g[1]],g[2]]}break;case
2:if(typeof
c!=="number"&&2===c[0]){var
i=ac(a[1],b,c[1]);return[0,[2,i[1]],i[2]]}break;case
3:if(typeof
c!=="number"&&3===c[0]){var
j=ac(a[1],b,c[1]);return[0,[3,j[1]],j[2]]}break;case
4:if(typeof
c!=="number"&&4===c[0]){var
k=ac(a[1],b,c[1]);return[0,[4,k[1]],k[2]]}break;case
5:if(typeof
c!=="number"&&5===c[0]){var
l=ac(a[1],b,c[1]);return[0,[5,l[1]],l[2]]}break;case
6:if(typeof
c!=="number"&&6===c[0]){var
m=ac(a[1],b,c[1]);return[0,[6,m[1]],m[2]]}break;case
7:if(typeof
c!=="number"&&7===c[0]){var
n=ac(a[1],b,c[1]);return[0,[7,n[1]],n[2]]}break;case
8:if(typeof
c!=="number"&&8===c[0]){var
p=c[1],x=c[2],z=a[2];if(be([0,a[1]],[0,p]))throw h(L,1);var
q=ac(z,b,x);return[0,[8,p,q[1]],q[2]]}break;case
9:if(typeof
c!=="number"&&9===c[0]){var
d=c[2],e=c[1],A=c[3],B=a[3],C=a[2],D=a[1],E=[0,y(e)];if(be([0,y(D)],E))throw h(L,1);var
F=[0,y(d)];if(be([0,y(C)],F))throw h(L,1);var
r=Q(I(G(e),d)),H=r[4];r[2].call(null,0);H(0);var
s=ac(y(B),b,A),J=s[2];return[0,[9,e,d,G(s[1])],J]}break;case
10:if(typeof
c!=="number"&&10===c[0]){var
t=ac(a[1],b,c[1]);return[0,[10,t[1]],t[2]]}break;case
11:if(typeof
c!=="number"&&11===c[0]){var
u=ac(a[1],b,c[1]);return[0,[11,u[1]],u[2]]}break;case
13:if(typeof
c!=="number"&&13===c[0]){var
v=ac(a[1],b,c[1]);return[0,[13,v[1]],v[2]]}break;case
14:if(typeof
c!=="number"&&14===c[0]){var
w=ac(a[1],b,c[1]);return[0,[14,w[1]],w[2]]}break}throw h(L,1)}function
aj(a,b,c){var
d=k(c),g=0<=b?a:0,f=c_(b);if(f<=d)return c;var
h=2===g?48:32,e=bh(f,h);switch(g){case
0:aN(c,0,e,0,d);break;case
1:aN(c,0,e,f-d|0,d);break;default:a:if(0<d){if(43!==t(c,0)&&45!==t(c,0)&&32!==t(c,0))break a;aA(e,0,t(c,0));aN(c,1,e,(f-d|0)+1|0,d-1|0);break}a:if(1<d&&48===t(c,0)){if(le!==t(c,1)&&88!==t(c,1))break a;aA(e,1,t(c,1));aN(c,2,e,(f-d|0)+2|0,d-2|0);break}aN(c,0,e,f-d|0,d)}return S(e)}function
bN(a,b){var
d=c_(a),c=k(b),e=t(b,0);a:{b:{if(58>e){if(32!==e){if(43>e)break a;switch(e-43|0){case
5:if(c>=(d+2|0))break b;if(1>=c)break b;if(le!==t(b,1)&&88!==t(b,1))break b;var
g=bh(d+2|0,48);aA(g,1,t(b,1));aN(b,2,g,(d-c|0)+4|0,c-2|0);return S(g);case
0:case
2:break;case
1:case
3:case
4:break a;default:break b}}if(c>=(d+1|0))break a;var
f=bh(d+1|0,48);aA(f,0,e);aN(b,1,f,(d-c|0)+2|0,c-1|0);return S(f)}if(71<=e){if(5<e+d2>>>0)break a}else if(65>e)break a}if(c<d){var
h=bh(d,48);aN(b,0,h,d-c|0,c);return S(h)}}return b}function
ps(a){var
e=aJ(a),b=[0,0],m=ah(e)-1|0,r=0;if(m>=0){var
h=r;for(;;){var
f=bd(e,h);a:{b:{c:{if(32<=f){var
j=f-34|0;if(58<j>>>0){if(93<=j)break c}else if(56<j-1>>>0)break b;var
l=1;break a}if(11<=f){if(13===f)break b}else if(8<=f)break b}var
l=4;break a}var
l=2}b[1]=b[1]+l|0;var
u=h+1|0;if(m===h)break;h=u}}if(b[1]===ah(e))var
i=e;else{var
c=F(b[1]);b[1]=0;var
n=ah(e)-1|0,s=0;if(n<0)var
i=c;else{var
g=s;for(;;){var
d=bd(e,g);a:{b:{c:{if(35<=d){if(92!==d){if(b4<=d)break b;break c}}else{if(32>d){if(14<=d)break b;switch(d){case
8:w(c,b[1],92);b[1]++;w(c,b[1],98);break a;case
9:w(c,b[1],92);b[1]++;w(c,b[1],lp);break a;case
10:w(c,b[1],92);b[1]++;w(c,b[1],110);break a;case
13:w(c,b[1],92);b[1]++;w(c,b[1],114);break a;default:break b}}if(34>d)break c}w(c,b[1],92);b[1]++;w(c,b[1],d);break a}w(c,b[1],d);break a}w(c,b[1],92);b[1]++;w(c,b[1],48+(d/cR|0)|0);b[1]++;w(c,b[1],48+((d/10|0)%10|0)|0);b[1]++;w(c,b[1],48+(d%10|0)|0)}b[1]++;var
t=g+1|0;if(n===g){var
i=c;break}g=t}}}var
o=e===i?a:S(i),p=k(o),q=bh(p+2|0,34);bH(o,0,q,1,p);return S(q)}function
hQ(a,b){var
g=c_(b),f=qh[1];switch(a[2]){case
0:var
c=102;break;case
1:var
c=101;break;case
2:var
c=69;break;case
3:var
c=gm;break;case
4:var
c=71;break;case
6:var
c=lF;break;case
7:var
c=72;break;case
8:var
c=70;break;default:var
c=f}var
d=hM(16);bM(d,37);switch(a[1]){case
1:bM(d,43);break;case
2:bM(d,32);break}if(8<=a[2])bM(d,35);bM(d,46);P(d,e+g);bM(d,c);return hO(d)}function
de(a,b){if(13>a)return b;var
h=[0,0],i=k(b)-1|0,o=0;if(i>=0){var
d=o;for(;;){if(9>=av(b,d)+eg>>>0)h[1]++;var
r=d+1|0;if(i===d)break;d=r}}var
j=h[1],l=F(k(b)+((j-1|0)/3|0)|0),m=[0,0];function
e(a){aA(l,m[1],a);m[1]++}var
f=[0,((j-1|0)%3|0)+1|0],n=k(b)-1|0,p=0;if(n>=0){var
c=p;for(;;){var
g=av(b,c);if(9<g+eg>>>0)e(g);else{if(0===f[1]){e(95);f[1]=3}f[1]--;e(g)}var
q=c+1|0;if(n===c)break;c=q}}return S(l)}function
qi(a,b){switch(a){case
1:var
c=pu;break;case
2:var
c=pv;break;case
4:var
c=px;break;case
5:var
c=py;break;case
6:var
c=pz;break;case
7:var
c=pA;break;case
8:var
c=pB;break;case
9:var
c=pC;break;case
10:var
c=pD;break;case
11:var
c=pE;break;case
0:case
13:var
c=pt;break;case
3:case
14:var
c=pw;break;default:var
c=pF}return de(a,ev(c,b))}function
qj(a,b){switch(a){case
1:var
c=pU;break;case
2:var
c=pV;break;case
4:var
c=pX;break;case
5:var
c=pY;break;case
6:var
c=pZ;break;case
7:var
c=p0;break;case
8:var
c=p1;break;case
9:var
c=p2;break;case
10:var
c=p3;break;case
11:var
c=p4;break;case
0:case
13:var
c=pT;break;case
3:case
14:var
c=pW;break;default:var
c=p5}return de(a,ev(c,b))}function
qk(a,b){switch(a){case
1:var
c=p7;break;case
2:var
c=p8;break;case
4:var
c=p_;break;case
5:var
c=p$;break;case
6:var
c=qa;break;case
7:var
c=qb;break;case
8:var
c=qc;break;case
9:var
c=qd;break;case
10:var
c=qe;break;case
11:var
c=qf;break;case
0:case
13:var
c=p6;break;case
3:case
14:var
c=p9;break;default:var
c=qg}return de(a,ev(c,b))}function
ql(a,b){switch(a){case
1:var
c=pH;break;case
2:var
c=pI;break;case
4:var
c=pK;break;case
5:var
c=pL;break;case
6:var
c=pM;break;case
7:var
c=pN;break;case
8:var
c=pO;break;case
9:var
c=pP;break;case
10:var
c=pQ;break;case
11:var
c=pR;break;case
0:case
13:var
c=pG;break;case
3:case
14:var
c=pJ;break;default:var
c=pS}return de(a,nz(c,b))}function
aV(i,b,c){function
j(a){switch(i[1]){case
0:var
d=45;break;case
1:var
d=43;break;default:var
d=32}return zM(c,b,d)}function
p(a){var
b=zv(c);return 3===b?c<0.?qm:qn:4<=b?qo:a}switch(i[2]){case
5:var
e=gN(hQ(i,b),c),d=0,s=k(e);for(;;){a:{if(d!==s){var
l=t(e,d)-46|0;b:{if(23<l>>>0){if(55!==l)break b}else if(21>=l-1>>>0)break b;var
o=1;break a}d=d+1|0;continue}var
o=0}var
u=o?e:e+a1;return p(u)}case
6:return j(0);case
7:var
m=aJ(j(0)),f=ah(m);if(0===f)var
h=m;else{var
g=F(f),n=f-1|0,q=0;if(n<0)var
h=g;else{var
a=q;for(;;){w(g,a,hu(bd(m,a)));var
r=a+1|0;if(n===a){var
h=g;break}a=r}}}return S(h);case
8:return p(j(0));default:return gN(hQ(i,b),c)}}function
cP(a,b,c,d){a:{b:{c:{d:{e:{f:{g:{h:{i:{j:{k:{var
l=b,f=c,e=d;l:for(;;){if(typeof
e==="number")return g(l,f);switch(e[0]){case
0:break a;case
1:break b;case
2:break c;case
3:return e1(l,f,e[2],e[1],ps);case
4:return df(l,f,e[4],e[2],e[3],qi,e[1]);case
5:return df(l,f,e[4],e[2],e[3],qj,e[1]);case
6:return df(l,f,e[4],e[2],e[3],qk,e[1]);case
7:return df(l,f,e[4],e[2],e[3],ql,e[1]);case
8:break d;case
9:return e1(l,f,e[2],e[1],n6);case
10:f=[7,f];e=e[1];break;case
11:f=[2,f,e[1]];e=e[2];break;case
12:f=[3,f,e[1]];e=e[2];break;case
13:break e;case
14:break f;case
15:break g;case
16:break h;case
17:f=[0,f,e[1]];e=e[2];break;case
18:var
v=e[1];if(0===v[0]){let
b=f,c=l,d=e[2];l=function(a){return m(c,[1,b,[0,a]],d)};f=0;e=v[1][1]}else{let
b=f,c=l,d=e[2];l=function(a){return m(c,[1,b,[1,a]],d)};f=0;e=v[1][1]}break;case
19:throw h([0,i,qq],1);case
20:break i;case
21:break j;case
22:break k;case
23:break l;default:var
C=e[3],D=e[1],E=g(e[2],0);return a<50?gf(a+1|0,l,f,C,D,E):bI(gf,[0,l,f,C,D,E])}}var
r=e[2],t=e[1];if(typeof
t==="number"){if(2===t)throw h([0,i,qs],1);return a<50?b2(a+1|0,l,f,r):bI(b2,[0,l,f,r])}if(9!==t[0])return a<50?b2(a+1|0,l,f,r):bI(b2,[0,l,f,r]);var
H=t[2];return a<50?gg(a+1|0,l,f,H,r):bI(gg,[0,l,f,H,r])}var
W=e[1];return function(a){return m(l,[5,f,a],W)}}var
V=e[2];return function(a){return m(l,[4,f,ev(lw,a)],V)}}var
T=e[3],U=[8,f,qr];return function(a){return m(l,U,T)}}var
R=e[1];return function(a){return m(l,[6,f,a],R)}}var
Q=e[1];return function(c,b){return m(l,[6,f,function(a){return j(c,a,b)}],Q)}}var
O=e[3],P=e[2];return function(a){var
c=a[1],b=o(c,y(G(P)));if(typeof
b[2]==="number")return m(l,f,u(b[1],O));throw h(L,1)}}var
M=e[3],N=e[2],B=hM(16);eZ(B,N);var
I=hO(B);return function(a){return m(l,[4,f,I],M)}}var
p=e[4],q=e[3],s=e[2],n=e[1];if(typeof
s==="number"){if(typeof
q==="number")return q?function(a,b){return m(l,[4,f,aV(n,a,b)],p)}:function(a){return m(l,[4,f,aV(n,eY(n),a)],p)};var
X=q[1];return function(a){return m(l,[4,f,aV(n,X,a)],p)}}if(0===s[0]){var
x=s[2],z=s[1];if(typeof
q==="number")return q?function(a,b){return m(l,[4,f,aj(z,x,aV(n,a,b))],p)}:function(a){return m(l,[4,f,aj(z,x,aV(n,eY(n),a))],p)};var
Y=q[1];return function(a){return m(l,[4,f,aj(z,x,aV(n,Y,a))],p)}}var
A=s[1];if(typeof
q==="number")return q?function(a,b,c){return m(l,[4,f,aj(A,a,aV(n,b,c))],p)}:function(a,b){return m(l,[4,f,aj(A,a,aV(n,eY(n),b))],p)};var
Z=q[1];return function(a,b){return m(l,[4,f,aj(A,a,aV(n,Z,b))],p)}}return e1(l,f,e[2],e[1],function(a){return a})}var
K=e[1];return function(a){a:{b:{if(40<=a){if(92===a){var
b=oi;break a}if(b4<=a)break b}else{if(32>a){if(14<=a)break b;switch(a){case
8:var
b=ok;break a;case
9:var
b=ol;break a;case
10:var
b=om;break a;case
13:var
b=on;break a;default:break b}}if(39<=a){var
b=oj;break a}}var
d=F(1);w(d,0,a);var
b=S(d);break a}var
c=F(4);w(c,0,92);w(c,1,48+(a/cR|0)|0);w(c,2,48+((a/10|0)%10|0)|0);w(c,3,48+(a%10|0)|0);var
b=S(c)}var
e=k(b),g=bh(e+2|0,39);bH(b,0,g,1,e);return m(l,[4,f,S(g)],K)}}var
J=e[1];return function(a){return m(l,[5,f,a],J)}}function
m(a,b,c){return g8(cP(0,a,b,c))}function
gg(a,f,c,d,e){if(typeof
d==="number")return a<50?b2(a+1|0,f,c,e):bI(b2,[0,f,c,e]);switch(d[0]){case
0:var
b=d[1];return function(a){return ao(f,c,b,e)};case
1:var
g=d[1];return function(a){return ao(f,c,g,e)};case
2:var
j=d[1];return function(a){return ao(f,c,j,e)};case
3:var
k=d[1];return function(a){return ao(f,c,k,e)};case
4:var
l=d[1];return function(a){return ao(f,c,l,e)};case
5:var
m=d[1];return function(a){return ao(f,c,m,e)};case
6:var
n=d[1];return function(a){return ao(f,c,n,e)};case
7:var
o=d[1];return function(a){return ao(f,c,o,e)};case
8:var
p=d[2];return function(a){return ao(f,c,p,e)};case
9:var
q=d[3],r=d[2],s=I(G(d[1]),r);return function(a){return ao(f,c,Z(s,q),e)};case
10:var
t=d[1];return function(a,b){return ao(f,c,t,e)};case
11:var
u=d[1];return function(a){return ao(f,c,u,e)};case
12:var
v=d[1];return function(a){return ao(f,c,v,e)};case
13:throw h([0,i,qt],1);default:throw h([0,i,qu],1)}}function
ao(a,b,c,d){return g8(gg(0,a,b,c,d))}function
b2(a,b,c,d){var
e=[8,c,qv];return a<50?cP(a+1|0,b,e,d):bI(cP,[0,b,e,d])}function
e1(h,f,c,d,e){if(typeof
d==="number")return function(a){return m(h,[4,f,g(e,a)],c)};if(0===d[0]){var
b=d[2],i=d[1];return function(a){return m(h,[4,f,aj(i,b,g(e,a))],c)}}var
j=d[1];return function(a,b){return m(h,[4,f,aj(j,a,g(e,b))],c)}}function
df(k,i,h,d,e,f,g){if(typeof
d==="number"){if(typeof
e==="number")return e?function(a,b){return m(k,[4,i,bN(a,j(f,g,b))],h)}:function(a){return m(k,[4,i,j(f,g,a)],h)};var
b=e[1];return function(a){return m(k,[4,i,bN(b,j(f,g,a))],h)}}if(0===d[0]){var
c=d[2],l=d[1];if(typeof
e==="number")return e?function(a,b){return m(k,[4,i,aj(l,c,bN(a,j(f,g,b)))],h)}:function(a){return m(k,[4,i,aj(l,c,j(f,g,a))],h)};var
o=e[1];return function(a){return m(k,[4,i,aj(l,c,bN(o,j(f,g,a)))],h)}}var
n=d[1];if(typeof
e==="number")return e?function(a,b,c){return m(k,[4,i,aj(n,a,bN(b,j(f,g,c)))],h)}:function(a,b){return m(k,[4,i,aj(n,a,j(f,g,b))],h)};var
p=e[1];return function(a,b){return m(k,[4,i,aj(n,a,bN(p,j(f,g,b)))],h)}}function
gf(a,b,c,d,e,f){if(e){var
i=e[1];return function(a){return qp(b,c,d,i,g(f,a))}}var
h=[4,c,f];return a<50?cP(a+1|0,b,h,d):bI(cP,[0,b,h,d])}function
qp(a,b,c,d,e){return g8(gf(0,a,b,c,d,e))}function
aW(a,b){var
c=b;for(;;){if(typeof
c==="number")return;switch(c[0]){case
0:var
f=c[1],h=hP(c[2]);aW(a,f);return cf(a,h);case
1:var
d=c[2],e=c[1];if(0===d[0]){var
i=d[1];aW(a,e);cf(a,qw);c=i}else{var
j=d[1];aW(a,e);cf(a,qx);c=j}break;case
6:var
m=c[2];aW(a,c[1]);return g(m,a);case
7:aW(a,c[1]);aL(a);return;case
8:var
o=c[2];aW(a,c[1]);return n(o);case
2:case
4:var
k=c[2];aW(a,c[1]);return cf(a,k);default:var
l=c[2];aW(a,c[1]);nJ(a,l);return}}}function
aX(a,b){var
c=b;for(;;){if(typeof
c==="number")return;switch(c[0]){case
0:var
k=c[1],l=hP(c[2]);aX(a,k);return cm(a,l);case
1:var
e=c[2],h=c[1];if(0===e[0]){var
m=e[1];aX(a,h);cm(a,qy);c=m}else{var
o=e[1];aX(a,h);cm(a,qz);c=o}break;case
6:var
q=c[2];aX(a,c[1]);return cm(a,g(q,0));case
7:c=c[1];break;case
8:var
r=c[2];aX(a,c[1]);return n(r);case
2:case
4:var
p=c[2];aX(a,c[1]);return cm(a,p);default:var
i=c[2];aX(a,c[1]);var
d=a[2],f=a[1],j=f[1];if(f[2]<=d){hJ(a,1);aA(a[1][1],a[2],i)}else
w(j,d,i);a[2]=d+1|0;return}}}function
cp(c,b){return m(function(a){aW(c,a);return 0},0,b[1])}function
v(a){return m(function(a){var
b=a6(64);aX(b,a);return cl(b)},0,a[1])}var
ge=[0,0],qD=[0,[3,0,0],"%S"],qE=l6,qF=[0,[4,0,0,0,0],ea],qG=e,qH=[0,[11,bB,[2,0,[2,0,0]]],", %s%s"],qI=[0,[12,40,[2,0,[2,0,[12,41,0]]]],"(%s%s)"],qJ=e,qK=e,qL=[0,[12,40,[2,0,[12,41,0]]],"(%s)"],qM="Out of memory",qN="Stack overflow",qO="Pattern matching failed",qP="Assertion failed",qQ="Undefined recursive module",qR="Raised at",qS="Re-raised at",qT="Raised by primitive operation at",qU="Called from",qV=[0,[12,32,[4,0,0,0,0]]," %d"],qW=" (inlined)",qX=[0,[2,0,[12,32,[2,0,[11,' in file "',[2,0,[12,34,[2,0,[11,", line",[2,0,[11,gy,za]]]]]]]]]],'%s %s in file "%s"%s, line%s, characters %d-%d'],qY=e,qZ=[0,[11,"s ",[4,0,0,0,[12,45,[4,0,0,0,0]]]],"s %d-%d"],q0=[0,[2,0,[11," unknown location",0]],"%s unknown location"],q1=[0,[2,0,[12,10,0]],"%s\n"];function
e3(a,b){var
c=a[b+1];return eN(c)?Y(c)===cV?g(v(qD),c):Y(c)===253?hj(c):qE:g(v(qF),c)}function
hR(a,b){if(a.length-1<=b)return qG;var
c=hR(a,b+1|0),d=e3(a,b);return j(v(qH),d,c)}function
dg(a){a:{b:{var
b=bc(ge);for(;;){if(!b)break;var
m=b[2],x=b[1];try{var
n=g(x,a)}catch(f){b=m;continue}if(n)break b;b=m}var
k=0;break a}var
k=[0,n[1]]}if(k)return k[1];if(a===eK)return qM;if(a===he)return qN;if(a[1]===hd){var
e=a[2],q=e[3],z=e[2],A=e[1];return d0(v(e2),A,z,q,q+5|0,qO)}if(a[1]===i){var
f=a[2],r=f[3],B=f[2],C=f[1];return d0(v(e2),C,B,r,r+6|0,qP)}if(a[1]===hg){var
h=a[2],s=h[3],D=h[2],E=h[1];return d0(v(e2),E,D,s,s+6|0,qQ)}if(0===Y(a)){var
l=a.length-1,y=a[1][1];if(2<l>>>0)var
t=hR(a,2),u=e3(a,1),c=j(v(qI),u,t);else
switch(l){case
2:var
w=e3(a,1),c=g(v(qL),w);break;case
0:var
c=qJ;break;default:var
c=qK}var
d=[0,y,[0,c]]}else
var
d=[0,a[1],0];var
o=d[2],p=d[1];return o?p+o[1]:p}function
dh(a,b){var
h=zw(b),l=h.length-2|0,x=0;if(l>=0){var
d=x;for(;;){var
c=f(h,d)[d+1];let
b=d;var
i=function(a){return a?0===b?qR:qS:0===b?qT:qU};if(0===c[0]){if(c[3]===c[6])var
m=c[3],k=g(v(qV),m);else
var
t=c[6],u=c[3],k=j(v(qZ),u,t);var
n=c[7],o=c[4],p=c[8]?qW:qY,q=c[2],r=c[9],s=i(c[1]),e=[0,zb(v(qX),s,r,q,p,k,o,n)]}else if(c[1])var
e=0;else
var
w=i(0),e=[0,g(v(q0),w)];if(e){var
y=e[1];g(cp(a,q1),y)}var
z=d+1|0;if(l===d)break;d=z}}return 0}function
hS(a){for(;;){var
c=bc(ge),b=1-eo(ge,c,[0,a,c]);if(!b)return b}}var
q2=Aj([0,e,"(Cannot print locations:\n bytecode executable program file not found)","(Cannot print locations:\n bytecode executable program file appears to be corrupt)","(Cannot print locations:\n bytecode executable program file has wrong magic number)","(Cannot print locations:\n bytecode executable program file cannot be opened;\n -- too many open files. Try running with OCAMLRUNPARAM=b=2)"]),q3=[0,[11,gF,[2,0,[12,10,0]]],mx],q4=[0],q5="Fatal error: out of memory in uncaught exception handler",q6=[0,[11,gF,[2,0,[12,10,0]]],mx],q7=[0,[11,"Fatal error in uncaught exception handler: exception ",[2,0,[12,10,0]]],"Fatal error in uncaught exception handler: exception %s\n"];g6(kw,function(a,b){try{try{var
i=b?q4:gO(0);try{eM(0)}catch(f){}try{var
l=dg(a);g(cp(ai,q3),l);dh(ai,i);var
c=Ab(0);if(c<0){var
d=c_(c);hn(f(q2,d)[d+1])}var
p=aL(ai),j=p}catch(f){var
m=C(f),n=dg(a);g(cp(ai,q6),n);dh(ai,i);var
o=dg(m);g(cp(ai,q7),o);dh(ai,gO(0));var
j=aL(ai)}var
k=j}catch(f){var
e=C(f);if(e!==eK)throw h(e,0);var
k=hn(q5)}return k}catch(f){return 0}});var
q8=[c,"Stdlib.Fun.Finally_raised",an(0)];hS(function(a){return a[1]===q8?[0,"Fun.Finally_raised: "+dg(a[2])]:0});var
q9="Digest.BLAKE2: wrong hash size";function
e4(a){var
b=a[1]<1?1:0,c=b||(64<a[1]?1:0);if(c)n(q9)}e4([0,16]);e4([0,32]);e4([0,64]);var
q_=aB(1,0,0),q$=aB(0,0,0),ra=aB(0,0,0),rb=aB(2,0,0),rc=aB(1,0,0),re=aB(14371852,15349651,22696),rf=aB(12230193,11438743,35013),rg=aB(1424933,15549263,2083),rh=aB(9492471,4696708,43520);function
hT(a){return z_(a,0,ah(a))}function
hU(a){return zm(7,0,[0,4])}function
hV(a,b,c,d,e){c1(a,0,nD(b,q_));c1(a,1,c);var
f=be(d,q$)?d:rc;c1(a,2,f);var
g=be(e,ra)?e:rb;c1(a,3,g)}function
hW(a,b,c,d){var
e=hU(0);hV(e,a,b,c,d);return e}aU([0,function(a){return hW(eB(a),eB(a),eB(a),eB(a))}],function(a){return hW(rh,rg,rf,re)});var
ob=lf,oa=lf,op="List.init",oB="Array.sub",oA="Array.init",oL="Buffer.sub",oP="first domain already spawned",qC=[0,[11,"invalid box description ",[3,0,0]],"invalid box description %S"],qB=[0,0,4],ri=e,rE=[4,0,3],rF=a1,rB=e,rz=e,rx="\n",rs=e,rt=e,ru=e,rv=e,rr=[0,e],rn=e,ro=e,rp=e,rq=e,rl="Stdlib.Format.String_tag",rL="Jsoo_runtime.Error.Exn",rM=gG,rO=[0,a,157,10],rQ=[0,a,179,10],rS=[0,a,191,10],rU=[0,a,218,17],rZ=[0,a,367,16],r0=[0,a,368,18],r1=[0,a,372,15],r2=[0,a,377,15],r3=[0,a,383,15],r4=[0,a,386,10],r5=[0,a,362,16],r6=[0,a,517,12],r7=[0,a,459,14],sc=[0,a,686,27],sb=[0,a,651,27],r_=[0,a,560,16],r8=[0,a,550,23],r9=[0,a,544,14],rX=[0,a,309,9],rW=[0,a,305,9],rV=[0,[11,"Lwd: unsafe mutation (variable invalidated during evaluation) at\n",[15,0]],"Lwd: unsafe mutation (variable invalidated during evaluation) at\n%a"],rT=[0,a,199,14],rR=[0,a,186,14],rP=[0,a,169,14],rN=[0,a,152,14],r$="Lwd.Release_failure",su=[0,$,571,12],si=[0,$,321,37],sj=[0,$,322,37],sl=[0,$,346,10],sm=[0,$,358,8],sk=[0,$,337,37],so=[0,$,375,10],sp=[0,$,384,8],sn=[0,$,338,37],sr=[0,$,425,16],st=[0,$,513,50],ss=[0,$,480,6],sq=[0,$,395,14],sf=[0,$,174,57],sg=[0,$,182,57],sh=[0,$,lK,11],sd=mX,se=mX,sP="warn",sO=l9,sN="log",sz=[0,1],sY=[0,mN,233,16],sX=[0,mN,201,16],sS=[0,0,0],sR=[0,0,0],s0=[1,[0,3854881,"Failed to unmarshal data"]],s1=[1,-358247754],s2="TODO not implemented",s3=e,s5=[0,80,"checkbox"],s4=[0,[2,0,[12,45,[4,3,0,0,[12,45,[4,3,0,0,0]]]]],"%s-%i-%i"],tg="X",te=[0,0],tb=e,tc="allselect-notuniquenamechangeme",td=[0,0],tf=[0,1],s9=[0,80,lX],s6=[0,[2,0,[11,"--id",0]],"%s--id"],tl=m3,tn=k5,to=kI,tp=bC,tq=kF,tr=lr,ts=mm,tt=mk,tu=el,tv=m2,tw=mV,tx=l3,ty=bE,tz=ly,tA=d_,tB=kY,tC=k9,tD=lo,tE=nd,tF=kR,tG=b3,tH=lL,tI=k2,tJ=m6,tK=m4,tL=nc,tM=cQ,tN=gl,tO=k4,tP=kM,tQ=lT,tR=me,tS=mU,tT=kP,tU=ef,tV=lg,tW=kL,tX=ls,tY=mt,tZ=lh,t0=lE,t1=k8,t2=lb,t3=mT,t4=mD,t5=mw,t6=mC,t7=mG,t8=mc,t9=lz,t_=mP,t$=l7,ua=m5,ub=lm,uc=kQ,ud=lH,ue=kB,uf=mB,ug=kx,uh=md,ui=kS,uj=mv,uk=l_,ul=lD,um=lC,un=lU,uo=mO,up=mK,uq=[0,[11,"EUNKNOWNERR ",[4,0,0,0,0]],"EUNKNOWNERR %d"],tm=[0,[11,"Unix.Unix_error(Unix.",[2,0,[11,bB,[3,0,[11,bB,[3,0,[12,41,0]]]]]]],"Unix.Unix_error(Unix.%s, %S, %S)"],th=eh,ti=e,tj=e,tk=eh,ut=[0,lx,71,4],uu=[0,lx,76,4],uz=[0,[8,[0,0,0],[0,2,2],[0,0],0],"%02.0f"],uA=[0,[8,[0,1,0],[0,2,3],[0,0],0],"%0+3.0f"],ux=[0,[4,0,[0,2,2],0,0],"%02d"],uy=[0,[4,0,[0,2,4],0,0],"%04d"],uw=[0,"src/ISO8601.ml",16,32],uE=[0,kJ,51,4],uD=[0,kJ,57,34],uM=[0,"src/calendar_builder.ml",67,4],uW=[0,k1,10,14],uX=[0,k1,10,5],uU=[0,-4713,12,31],uV=[0,kW,1,23],uQ="CalendarLib.Date.Out_of_bounds",uS="CalendarLib.Date.Undefined",u1=[0,0,0],vQ="resources",vR="events",vJ="eventContent",vp="view",vr="date",vt="duration",vv="scrollTime",vx="filterEventsWithResources",vz="filterResourcesWithEvents",vB="nowIndicator",vD="editable",vF="eventStartEditable",vH="eventDurationEditable",vK="headerToolbar",vM="slotMaxTime",vO="slotMinTime",vg=bF,vh=gE,vi="eventBackgroundColor",vj="eventTextColor",vk="children",va=bF,vb=lJ,vc=mq,vd=gE,ve="resourceIds",vf="extendedProps",u6="seconds",u7="minutes",u8="days",u9="months",u_="years",wG=as,wA=lu,wB="bool",wC=mu,wD=l4,wE="array",wF=lv,ws=[0,[11,"line ",[4,0,0,0,0]],"line %d"],wt=[0,[11,"lines ",[4,0,0,0,[12,45,[4,0,0,0,0]]]],"lines %d-%d"],wr=[0,[11,ei,[15,[12,34,0]]],'File "%a"'],wu=[0,[11,ei,[15,[11,mS,[15,0]]]],'File "%a", %a'],wv=[0,[11,ei,[15,[11,mS,[15,[11,gy,[4,0,0,0,[12,45,[4,0,0,0,0]]]]]]]],'File "%a", %a, characters %d-%d'],wl=l2,wn=m9,wo=l1,wp=m0,wk='\\"',wm=[0,[11,"\\u",[4,8,[0,2,4],0,0]],"\\u%04X"],wh=lu,wf=[0,[17,[0,kO,1,0],[18,[1,[0,0,e]],[15,[17,0,0]]]],"@;@[%a@]"],we=[0,[17,[0,kO,1,0],[18,[1,[0,0,e]],[11,"Similar members in object: ",[15,[17,0,0]]]]],"@;@[Similar members in object: %a@]"],wd=l8,wc=[0,[18,[1,[0,0,e]],[15,[17,0,0]]],mI],wa=[0,[11,"Unexpected ",[15,[11,cY,[15,[12,46,0]]]]],"Unexpected %a: %a."],v$=[0,[11,"Must be ",[15,[12,46,0]]],"Must be %a."],v9=[0,[11,"Should it be ",[15,[11," ?",0]]],"Should it be %a ?"],v8="or",v6=[0,[15,[17,[0,gt,1,0],[2,0,[17,[0,gt,1,0],[15,0]]]]],"%a@ %s@ %a"],v5=[0,[15,[12,44,[17,[0,gt,1,0],0]]],"%a,@ "],v7=[0,"src/jsont_base.ml",lK,14],v3="\x1b[1m",v4=[0,[17,[1,k6,0],[2,0,[2,0,[17,[1,k6,0],[2,0,0]]]]],"@<0>%s%s@<0>%s"],vX=[0,0],vW="Id",vU=[1,"Missing final hexadecimal digit"],vV=[0,[4,0,0,0,[11,": byte x",[4,6,0,0,[11," not an ASCII hexadecimal digit",0]]]],"%d: byte x%x not an ASCII hexadecimal digit"],vT="Jsont_base.Illegal_hex",v1="NO_COLOR",yV="TERM",yW=[0,k3],v2="\x1b[0m",wg=[0,[8,[0,0,3],0,[0,17],0],"%.17g"],wq=a0,ww=e,wx=e,xL=e,xM="json",xH="Jsont.Object.keep_unknown already called on object",xG=e,xF=e,xE=e,xD=[0,[11,"No encoder for member ",[15,0]],"No encoder for member %a"],xB=[0,[11,gq,[2,0,[11," defined twice in ",[2,0,0]]]],"member %s defined twice in %s"],xC=[0,[11,gq,[2,0,[11," defined both in ",[2,0,[11," and ",[2,0,0]]]]]],"member %s defined both in %s and %s"],xA=e,xz=e,xu=[0,gA,896,31],xt=[0,gA,895,31],xs=e,xr=e,xn=[0,[8,[0,0,6],0,0,0],"%h"],xm=e,xl="any",xg=e,xf=e,w9=[0,gI,0],w_="array<",w$=e,xa=bB,xe=[0,gA,439,46],xc="<tag>",w8=[0,[15,[11,cY,[2,0,0]]],"%a: %s"],w7=[0,[11,"No encoder for ",[15,0]],"No encoder for %a"],w6=[0,[11,"No decoder for ",[15,0]],"No decoder for %a"],w5=[0,[11,"Integer ",[15,[11,kz,[15,[11,kH,0]]]]],"Integer %a not in %a range"],w4=[0,[11,"String ",[15,[11," does not parse to ",[15,[11," value",0]]]]],"String %a does not parse to %a value"],w2=[0,[15,0],gj],w3=[0,[11,"Number ",[15,[11,kz,[15,[11,kH,0]]]]],"Number %a not in %a range"],w0=[0,[11,gq,[15,[11," value in ",[15,0]]]],"member %a value in %a"],w1=[0,[18,[1,[0,0,e]],[15,[17,0,0]]],mI],wX=[0,[12,32,[18,[1,[0,0,e]],[15,[15,[17,0,0]]]]]," @[%a%a@]"],wZ=[0,[18,[1,[0,[11,az,0],az]],[11,"Unexpected member ",[15,[11," for ",[15,[15,[17,0,0]]]]]]],"@[<v>Unexpected member %a for %a%a@]"],wY=[0,[18,[1,[0,[11,d8,0],d8]],[11,"Unexpected members for ",[15,[12,58,[17,[0,b5,0,0],[15,[17,0,0]]]]]]],"@[<v1>Unexpected members for %a:@,%a@]"],wU=[0,[18,[1,[0,0,e]],[15,[15,[17,0,0]]]],"@[%a%a@]"],wW=[0,[18,[1,[0,[11,az,0],az]],[11,"Missing member ",[15,[11," in ",[15,[15,[17,0,0]]]]]]],"@[<v>Missing member %a in %a%a@]"],wV=[0,[18,[1,[0,[11,d8,0],d8]],[11,"Missing members in ",[15,[12,58,[17,[0,b5,0,0],[15,[17,0,0]]]]]]],"@[<v1>Missing members in %a:@,%a@]"],wT=[0,[11,lN,[15,[11,m7,[15,0]]]],kD],wS=[0,[11,lN,[15,[11,m7,[15,0]]]],kD],wR=[0,[15,0],gj],wP=[0,[17,[0,b5,0,0],[15,[12,58,0]]],"@,%a:"],wQ=[0,[18,[1,[0,[11,az,0],az]],[15,[15,[15,[17,0,0]]]]],"@[<v>%a%a%a@]"],wL=[0,[18,[1,[0,[11,az,0],az]],[15,[11,"in member ",[15,[11,ld,[17,[0,b5,0,0],[15,[15,[17,0,0]]]]]]]]],"@[<v>%ain member %a of@,%a%a@]"],wM=[0,[18,[1,[0,[11,az,0],az]],[15,[11,"at index ",[15,[11,ld,[17,[0,b5,0,0],[15,[15,[17,0,0]]]]]]]]],"@[<v>%aat index %a of@,%a%a@]"],wK=[0,[15,[11,cY,0]],"%a: "],wN=[0,[17,[0,b5,0,0],[18,[1,[0,[11,az,0],az]],[15,[17,0,0]]]],"@,@[<v>%a@]"],wH="Jsont.Error",xh=e,xi=e,xj=e,xo=[0,gz],xp=[0,gh],xv=e,xw=e,xy=[0,0],xI=[0,lP],xJ=lP,xT=[0,0],xU=[0,"src/brr/jsont_brr.ml",133,16],xS=[0,[11,"Not a JSON value: ",[2,0,0]],"Not a JSON value: %s"],xW=[0,"Quest_type"],xX=bF,xY=em,x0=[0,"Place"],x1=bF,x2=em,x4=[0,"Volunteer"],x5=bF,x6="pseudo",x8=[0,"Raw_quest"],x9=bF,x_=em,ya="types",yb="place",yd=lM,ye=lJ,yf=mq,yh=[0,"Results"],yj="quest_types",yl="places",yn=lM,yp="quests",ys=[0,[11,"qt_",[2,0,0]],"qt_%s"],yt=[0,[11,"p_",[2,0,0]],"p_%s"],yu=[0,[11,"v_",[2,0,0]],"v_%s"],yS="Active: ",yF=bB,yG=[0,[4,3,[0,2,2],0,[12,58,[4,3,[0,2,2],0,0]]],ma],yH=[0,[4,3,[0,2,2],0,[12,58,[4,3,[0,2,2],0,0]]],ma],yI=[0,[2,0,[12,45,[2,0,0]]],"%s-%s"],yw=e,yx=e,yz=[0,3],yA="Duration",yB="Date",yC=[0,gw,"Toustes"],yD=[0,0],yE="grp1",yJ=[0,"today prev,next"],yK=[0,"resourceTimelineWeek,resourceTimeGridWeek,listDay,timeGridWeek"],yL=[0,gE],yO=[0,1],yP=[0,1],yQ=[0,1],yR=[0,[0,0,[0,1,[0,3,[0,2,[0,4,0]]]]]],yT=[0,1],yU=[0,1],n5=NaN;function
n_(e){for(;;){var
a=bc(eL);let
c=[0,1],d=a;var
b=1-eo(eL,a,function(a){if(eo(c,1,0))g(e,0);return g(d,0)});if(!b)return b}}var
n$=[0,k3];function
og(a){if(0<=a&&gi>=a)return a;return n(oh)}var
oq=c7;function
or(a,b){return a<=b?a:b}function
os(a){return e+a}function
oz(a,b){var
d=k(a),g=0;if(d<0)return n(oy);try{var
c=g;for(;;){if(d<=c)throw h(a5,1);if(av(a,c)===b){var
f=1;return f}c=c+1|0}}catch(f){var
e=C(f);if(e===a5)return 0;throw h(e,0)}}function
oD(a){return nz(ea,a)}var
y$=[0,0];function
qA(a){var
c=a[1],b=a6(aP);return m(function(a){aX(b,a);return ce(cl(b))},0,c)}function
rd(a){var
j=Av(0),i=hU(0),d=j.length-1,c=F((d*8|0)+1|0),e=d-1|0,k=0;if(e>=0){var
b=k;for(;;){zu(c,b*8|0,c5(f(j,b)[b+1]));var
o=b+1|0;if(e===b)break;b=o}}aA(c,d*8|0,1);var
g=hT(c);aA(c,d*8|0,2);var
h=hT(c),l=da(h,8),m=da(h,0),n=da(g,8);hV(i,da(g,0),n,m,l);return i}try{var
yY=g7(mf),e5=yY}catch(f){var
hX=C(f);if(hX!==a5)throw h(hX,0);try{var
yX=g7("CAMLRUNPARAM"),e5=yX}catch(f){var
hY=C(f);if(hY!==a5)throw h(hY,0);var
e5=ri}}var
y_=[0,oz(e5,82)],rj=aU(0,rd);function
di(a){return a}var
dj=0,hZ=-1,e6=[c,rl,an(0)];function
cq(a,b){a[13]=a[13]+b[3]|0;return eU(b,a[28])}var
h0=1000000010;function
e7(a,b){return _(a[17],b,0,k(b))}function
dk(a){return g(a[19],0)}function
h1(a,b,c){a[9]=a[9]-b|0;e7(a,c);a[11]=0}function
dl(a,b){var
c=b!==e?1:0;return c?h1(a,k(b),b):c}function
bj(a,b,c){var
d=b[3],e=b[2];dl(a,b[1]);dk(a);a[11]=1;a[10]=or(a[8],(a[6]-c|0)+e|0);a[9]=a[6]-a[10]|0;g(a[21],a[10]);return dl(a,d)}function
cr(a,b){var
c=b[2],d=b[3];dl(a,b[1]);a[9]=a[9]-c|0;g(a[20],c);return dl(a,d)}function
rm(a,b,c){if(typeof
c==="number")switch(c){case
0:var
t=bL(a[3]);if(!t)return;var
u=t[1][1],v=function(a,b){if(!b)return[0,a,0];var
c=b[1],d=b[2];return gZ(a,c)?[0,a,b]:[0,c,v(a,d)]};u[1]=v(a[6]-a[9]|0,u[1]);return;case
1:bK(a[2]);return;case
2:bK(a[3]);return;case
3:var
w=bL(a[2]);return w?bj(a,h2,w[1][2]):dk(a);case
4:var
x=a[10]!==(a[6]-a[9]|0)?1:0;if(!x)return x;var
e=a[28],h=e[2];if(h){var
o=h[1];if(h[2]){var
J=h[2];e[1]=e[1]-1|0;e[2]=J;var
i=[0,o]}else{eT(e);var
i=[0,o]}}else
var
i=0;if(!i)return;var
s=i[1],L=s[1];a[12]=a[12]-s[3]|0;a[9]=a[9]+L|0;return;default:var
y=bK(a[5]);if(y)return e7(a,g(a[25],y[1]));return}switch(c[0]){case
0:return h1(a,b,c[1]);case
1:var
M=c[3],N=c[2],O=c[1];a[9]=a[9]-b|0;_(a[17],O,N,M);a[11]=0;return;case
2:var
d=c[2],j=c[1],z=d[1],P=d[2],A=bL(a[2]);if(!A)return;var
B=A[1],f=B[2];switch(B[1]){case
3:return a[9]<(b+k(z)|0)?bj(a,d,f):cr(a,j);case
4:return a[11]?cr(a,j):a[9]<(b+k(z)|0)?bj(a,d,f):((a[6]-f|0)+P|0)<a[10]?bj(a,d,f):cr(a,j);case
0:case
5:return cr(a,j);default:return bj(a,d,f)}case
3:var
n=a[6]-a[9]|0,Q=c[2],R=c[1],C=bL(a[3]);if(!C)return;var
D=C[1][1],E=D[1];if(E){var
l=D[1],S=E[1];for(;;){if(!l){var
m=S;break}var
F=l[1],T=l[2];if(n<=F){var
m=F;break}l=T}}else
var
m=n;var
G=m-n|0;return 0<=G?cr(a,[0,ro,G+R|0,rn]):bj(a,[0,rq,m+Q|0,rp],a[6]);case
4:var
H=c[2],U=c[1];if(a[8]<(a[6]-a[9]|0)){var
p=bL(a[2]);if(p){var
q=p[1],r=q[2],K=q[1];if(a[9]<r&&3>=K-1>>>0)bj(a,h2,r)}else
dk(a)}var
V=a[9]-U|0,W=1===H?1:a[9]<b?H:5;return bi([0,W,V],a[2]);case
5:return bi(c[1],a[3]);default:var
I=c[1];e7(a,g(a[24],I));return bi(I,a[5])}}function
h3(a){for(;;){var
d=a[28][2],e=d?[0,d[1]]:0;if(!e)return 0;var
b=e[1],c=b[1],g=0<=c?1:0,h=b[3],i=b[2],j=a[13]-a[12]|0,f=g||(a[9]<=j?1:0);if(!f)return f;hI(a[28]);var
k=0<=c?c:h0;rm(a,k,i);a[12]=h+a[12]|0}}function
h4(a,b){cq(a,b);return h3(a)}function
h5(a,b,c){return h4(a,[0,b,[0,c],b])}function
e8(a){ck(a);return bi([0,-1,[0,hZ,rr,0]],a)}function
e9(a,b){var
d=bL(a[1]);if(!d)return;var
e=d[1],c=e[2],f=c[1];if(e[1]<a[12])return e8(a[1]);var
g=c[2];if(typeof
g!=="number")switch(g[0]){case
4:if(1-b){c[1]=a[13]+f|0;bK(a[1])}return;case
2:case
3:if(b){c[1]=a[13]+f|0;bK(a[1])}return}}function
h6(a,b,c){cq(a,c);if(b)e9(a,1);return bi([0,a[13],c],a[1])}function
h7(a,b,c){a[14]=a[14]+1|0;if(a[14]<a[15])return h6(a,0,[0,-a[13]|0,[4,b,c],0]);var
d=a[14]===a[15]?1:0;if(!d)return d;var
e=a[16];return h5(a,k(e),e)}function
h8(a,b){var
c=1<a[14]?1:0;if(c){if(a[14]<a[15]){cq(a,[0,dj,1,0]);e9(a,1);e9(a,0)}a[14]=a[14]-1|0;var
d=0}else
var
d=c;return d}function
h9(a,b){if(a[23])cq(a,[0,dj,5,0]);var
c=a[22];if(c){var
d=bK(a[4]);if(d)return g(a[27],d[1]);var
e=0}else
var
e=c;return e}function
e_(a,b){var
c=a[4][1];for(;;){if(!c)break;var
d=c[2];h9(a,0);c=d}for(;;){if(1>=a[14])break;h8(a,0)}a[13]=h0;h3(a);if(b)dk(a);a[12]=1;a[13]=1;eT(a[28]);e8(a[1]);ck(a[2]);ck(a[3]);ck(a[4]);ck(a[5]);a[10]=0;a[14]=0;a[9]=a[6];return h7(a,0,3)}function
dm(a,b,c){var
d=a[14]<a[15]?1:0;return d?h5(a,b,c):d}function
ad(a,b){return dm(a,k(b),b)}function
aD(a,b){return dm(a,1,ch(1,b))}function
bk(a,b){e_(a,0);return g(a[18],0)}function
e$(a,b,c){var
d=[0,rv,b,ru],e=a[14]<a[15]?1:0,i=[0,rt,c,rs],f=d[3],g=d[2],h=d[1];return e?h6(a,1,[0,-a[13]|0,[2,d,i],(k(h)+g|0)+k(f)|0]):e}function
h_(a,b){return e$(a,1,0)}function
fa(a,b){return _(a[17],rx,0,1)}var
h$=ch(80,32);function
bO(a,b){var
c=b;for(;;){var
d=0<c?1:0;if(!d)return d;if(80>=c)return _(a[17],h$,0,c);_(a[17],h$,0,80);c=c-80|0}}function
ry(a){return a[1]===e6?"<"+a[2]+gI:rz}function
rA(a){return a[1]===e6?"<\/"+a[2]+gI:rB}function
rC(a){return 0}function
rD(a){return 0}function
fb(a,b,c,d,e){var
g=eS(0),h=[0,hZ,rE,0];eU(h,g);var
f=cj(0);e8(f);bi([0,1,h],f);var
i=78,j=cj(0),k=cj(0),l=cj(0);return[0,f,cj(0),l,k,j,i,10,68,i,0,1,1,1,1,hi,rF,a,b,c,d,e,0,0,ry,rA,rC,rD,g]}function
ia(a,b){var
c=fb(a,b,function(a){return 0},function(a){return 0},function(a){return 0});c[19]=function(a){return fa(c,a)};c[20]=function(a){return bO(c,a)};c[21]=function(a){return bO(c,a)};return c}function
ib(d){return ia(function(a,b,c){return hm(d,a,b,c)},function(a){return aL(d)})}function
dn(d){return ia(function(a,b,c){return eW(d,a,b,c)},function(a){return 0})}var
cs=gp,kt=a6(cs),rG=ib(hl),rH=ib(ai),bl=dn(kt),fc=aU(0,function(a){return a6(cs)});cn(fc,kt);var
ic=aU(0,function(a){return dn(aO(fc))});cn(ic,bl);function
id(a,b,c,d){return eW(aO(a),b,c,d)}function
ie(a,b,c){var
d=aO(b),e=d[2];hm(a,cl(d),0,e);aL(a);d[2]=0;return 0}var
ig=aU(0,function(a){return a6(cs)}),ih=aU(0,function(a){return a6(cs)}),ii=aU(0,function(a){var
b=fb(function(a,b,c){return id(ig,a,b,c)},function(a){return ie(hl,ig,a)},function(a){return 0},function(a){return 0},function(a){return 0});b[19]=function(a){return fa(b,a)};b[20]=function(a){return bO(b,a)};b[21]=function(a){return bO(b,a)};hL(function(a){return bk(b,a)});return b});cn(ii,rG);var
ij=aU(0,function(a){var
b=fb(function(a,b,c){return id(ih,a,b,c)},function(a){return ie(ai,ih,a)},function(a){return 0},function(a){return 0},function(a){return 0});b[19]=function(a){return fa(b,a)};b[20]=function(a){return bO(b,a)};b[21]=function(a){return bO(b,a)};hL(function(a){return bk(b,a)});return b});cn(ij,rH);function
rw(a,b){return e$(a,0,0)}function
ik(a,b){e_(b,0);var
c=cl(a);a[2]=0;a[1]=[0,a[3],ah(a[3])];return c}function
il(a){var
b=aO(fc);return ik(b,aO(ic))}function
ct(a,b,c,d){var
i=a?a[1]:rw,f=[0,1],e=d;for(;;){if(!e)return 0;var
g=e[2],h=e[1];if(f[1])f[1]=0;else
j(i,c,0);j(b,c,h);e=g}}function
im(a,b){var
c=a6(16),f=dn(c);j(a,f,b);bk(f,0);var
e=c[2];if(2>e)return cl(c);var
d=e-2|0,g=1;if(0<=d&&(c[2]-d|0)>=1)return c$(c[1][1],g,d);return n(oL)}function
ak(a,b){if(typeof
b==="number")return 0;a:{b:{c:{switch(b[0]){case
0:var
l=b[2];ak(a,b[1]);if(typeof
l==="number")switch(l){case
0:return h8(a,0);case
1:return h9(a,0);case
2:return bk(a,0);case
3:var
J=a[14]<a[15]?1:0;return J?h4(a,[0,dj,3,0]):J;case
4:e_(a,1);return g(a[18],0);case
5:return aD(a,64);default:return aD(a,37)}switch(l[0]){case
0:return e$(a,l[2],l[3]);case
1:return 0;default:var
W=l[1];aD(a,64);return aD(a,W)}case
1:var
z=b[2],K=b[1];if(0===z[0]){var
X=z[1];ak(a,K);var
A=[0,e6,im(ak,X)];if(a[22]){bi(A,a[4]);g(a[26],A)}var
I=a[23];return I?cq(a,[0,dj,[6,A],0]):I}var
Y=z[1];ak(a,K);var
c=im(ak,Y);if(c===e)var
B=qB;else{var
r=k(c),u=function(a){return g(qA(qC),c)},v=function(a){var
b=a;for(;;){if(b===r)return b;var
d=t(c,b);if(9!==d&&32!==d)return b;b=b+1|0}},x=v(0),f=x;for(;;){if(f===r)break;if(25<t(c,f)+d2>>>0)break;f=f+1|0}var
i=ci(c,x,f-x|0),s=v(f),d=s;for(;;){if(d===r)break;var
w=t(c,d);if(48<=w){if(58<=w)break}else if(45!==w)break;d=d+1|0}if(s===d)var
y=0;else
try{var
V=aa(ci(c,s,d-s|0)),y=V}catch(f){var
H=C(f);if(H[1]!==bJ)throw h(H,0);var
y=u(0)}if(v(d)!==r)u(0);d:{if(i!==e&&i!==l0){if(i==="h"){var
j=0;break d}if(i==="hov"){var
j=3;break d}if(i==="hv"){var
j=2;break d}if(i!=="v"){var
j=u(0);break d}var
j=1;break d}var
j=4}var
B=[0,y,j]}return h7(a,B[1],B[2]);case
2:var
m=b[1];if(typeof
m!=="number"&&0===m[0]){var
D=m[2];if(typeof
D!=="number"&&1===D[0]){var
P=b[2],O=D[2],N=m[1];break a}}var
M=b[2],L=m;break b;case
3:var
o=b[1];if(typeof
o!=="number"&&0===o[0]){var
E=o[2];if(typeof
E!=="number"&&1===E[0]){var
U=b[2],T=E[2],S=o[1];break c}}var
R=b[2],Q=o;break;case
4:var
p=b[1];if(typeof
p!=="number"&&0===p[0]){var
F=p[2];if(typeof
F!=="number"&&1===F[0]){var
P=b[2],O=F[2],N=p[1];break a}}var
M=b[2],L=p;break b;case
5:var
q=b[1];if(typeof
q!=="number"&&0===q[0]){var
G=q[2];if(typeof
G!=="number"&&1===G[0]){var
U=b[2],T=G[2],S=q[1];break c}}var
R=b[2],Q=q;break;case
6:var
Z=b[2];ak(a,b[1]);return g(Z,a);case
7:ak(a,b[1]);return bk(a,0);default:var
_=b[2];ak(a,b[1]);return n(_)}ak(a,Q);return aD(a,R)}ak(a,S);return dm(a,T,ch(1,U))}ak(a,L);return ad(a,M)}ak(a,N);return dm(a,O,P)}function
rI(d,b,c){return m(function(a){ak(b,a);return g(d,b)},0,c[1])}function
s(c){function
b(a){return 0}return function(a){return rI(b,c,a)}}function
cu(e,b){var
a=b[1],d=a6(cs),c=dn(d);return m(function(a){ak(c,a);return g(e,ik(d,c))},0,a)}n_(function(a){bk(aO(ii),0);return bk(aO(ij),0)});function
rk(a,b){var
d=a?a[1]:bc(y_),c=16;for(;;){if(b>c&&hp>=(c*2|0)){c=c*2|0;continue}if(d)aO(rj);return}}if(bc(y$))throw h([0,eJ,oP],1);function
io(a,b){var
d=Y(b)===c?b:b[1];g6(a,d)}function
iq(a){return a?1:0}function
ir(a,b){return b?b[1]:n(a)}function
is(e,b,c,d){if(c===0)return 0;var
f=c-1|0,g=b+1|0;return[0,t(e,b),function(a){return is(e,g,f,a)}]}var
fd=[c,rL,an(0)];io(rM,[0,fd,[0]]);function
cx(a){return 0===a[0]?[0,a[1]]:0}var
bQ=[0,0];function
dq(a){return[1,0,0,0,a]}function
D(a,b){return 0===a[0]?[0,g(b,a[1])]:dq([0,a,b])}function
dr(a,b,c){if(0===a[0]){var
d=a[1];if(0===b[0])return[0,j(c,d,b[1])]}return dq([1,a,b,c])}function
it(a){return 0===a[0]?a[1]:dq([4,a,0])}function
iu(a,b,c){switch(c[0]){case
0:throw h([0,i,rN],1);case
1:c[3]=[0,b,a,c[3]];return;default:c[2]=[0,b,a,c[2]];return}}function
fe(a,b){if(!b)throw h([0,i,rO],1);if(b[2]===a)return[0,b[1],b[3]];var
c=fe(a,b[3]),d=c[1];b[3]=c[2];return[0,d,b]}function
cy(a,b){switch(b[0]){case
0:throw h([0,i,rP],1);case
1:var
c=fe(a,b[3]),e=c[1];b[3]=c[2];return e;default:var
d=fe(a,b[2]),f=d[1];b[2]=d[2];return f}}function
iv(a,b,c,d){var
e=d;for(;;){if(!e)throw h([0,i,rQ],1);if(e[1]===b&&e[2]===a){e[1]=c;return}e=e[3]}}function
ff(a,b,c,d){switch(d[0]){case
0:throw h([0,i,rR],1);case
1:return iv(a,b,c,d[3]);default:return iv(a,b,c,d[2])}}function
iw(a,b){var
c=b;for(;;){if(!c)throw h([0,i,rS],1);if(c[2]===a)return c[1];c=c[3]}}function
a7(a,b,c){var
k=b,e=c;a:for(;;)switch(e[0]){case
0:throw h([0,i,rU],1);case
1:var
n=e[1];if(typeof
n==="number"&&!n){if(!k)return;if(a[1])return;a[1]=1;return}var
o=e[4];if(7===o[0]){var
q=o[2];if(1===q[0]){var
r=q[1];if(typeof
r==="number"){if(!r&&k){if(a[1])return;a[1]=1;return}}else if(k)return}}var
p=e[1],j=typeof
p==="number"?p?1:k:k;e[1]=0;var
d=e[2];if(typeof
d==="number")return;switch(d[0]){case
0:k=j;e=d[1];break;case
1:var
u=d[2];a7(a,j,d[1]);k=j;e=u;break;case
2:var
v=d[3],w=d[2];a7(a,j,d[1]);a7(a,j,w);k=j;e=v;break;case
3:var
x=d[4],y=d[3],z=d[2];a7(a,j,d[1]);a7(a,j,z);a7(a,j,y);k=j;e=x;break;default:break a}break;default:var
m=e[1];e[1]=0;if(typeof
m==="number"){if(!m)return;a[1]=2;return}var
t=m[1];if(k)a[1]=2;return g(e[3],t)}var
A=d[1];d[1]=0;var
s=A-1|0,B=0;if(s>=0){var
l=B;for(;;){a7(a,j,f(d[3],l)[l+1]);var
C=l+1|0;if(s===l)break;l=C}}}function
ix(a,b){var
c=[0,0];a7(c,a,b);var
d=2<=c[1]?1:0;return d?j(cp(ai,rV),dh,zE(20)):d}function
cz(a){return dq([5,a])}function
ax(a,b){if(1===a[0]){var
c=a[4];if(5===c[0]){c[1]=b;return ix(0,a)}}throw h([0,i,rW],1)}function
ds(a,b,c){var
l=a,g=b,e=c;for(;;)switch(e[0]){case
0:return l;case
1:var
d=e[2];if(typeof
d==="number")throw h([0,i,rZ],1);switch(d[0]){case
0:if(d[1]!==g)throw h([0,i,r0],1);var
k=0;break;case
1:var
B=d[2],D=d[1];if(D===g)var
k=[0,B];else{if(B!==g)throw h([0,i,r1],1);var
k=[0,D]}break;case
2:var
u=d[3],v=d[2],w=d[1];if(w===g)var
k=[1,v,u];else if(v===g)var
k=[1,w,u];else{if(u!==g)throw h([0,i,r2],1);var
k=[1,w,v]}break;case
3:var
q=d[4],r=d[3],s=d[2],t=d[1];if(t===g)var
k=[2,s,r,q];else if(s===g)var
k=[2,t,r,q];else if(r===g)var
k=[2,t,s,q];else{if(q!==g)throw h([0,i,r3],1);var
k=[2,t,s,r]}break;default:var
p=cy(e,g);if(f(d[3],p)[p+1]!==g)throw h([0,i,r4],1);var
m=d[2]-1|0;d[2]=m;if(p<m){var
E=f(d[3],m)[m+1];f(d[3],p)[p+1]=E;f(d[3],m)[m+1]=bQ;ff(e,m,p,E)}else
f(d[3],p)[p+1]=bQ;if(m<d[1])d[1]=m;if(4===m){var
F=f(d[3],0)[1],G=f(d[3],1)[2],H=f(d[3],2)[3],I=f(d[3],3)[4];cy(e,F);cy(e,G);cy(e,H);cy(e,I);var
k=[3,F,G,H,I]}else{var
J=d[3].length-1;if(m<=(J>>>2|0)){var
x=J>>>1|0,K=d[3];a:{if(0<=x&&(K.length-1-x|0)>=0){var
L=zk(K,0,x);break a}var
L=n(oB)}var
k=[4,d[1],d[2],L]}else
var
k=d}}e[2]=k;if(typeof
k!=="number")return l;var
y=e[1];e[1]=1;var
o=e[4];switch(o[0]){case
0:g=e;e=o[1];break;case
4:var
z=o[2],A=ds(l,e,o[1]);if(!z)return A;var
N=z[1];o[2]=0;l=A;g=e;e=N;break;case
5:return l;case
6:if(typeof
y==="number")return l;var
O=y[1];try{j(o[2],e,O);return l}catch(f){var
P=C(f);return[0,[0,P,gO(0)],l]}case
7:var
Q=o[1];l=ds(l,e,o[2]);g=e;e=Q;break;default:var
M=o[2];l=ds(l,e,o[1]);g=e;e=M}break;default:throw h([0,i,r5],1)}}function
cA(a,b){var
e=a,d=b;for(;;)switch(d[0]){case
0:return;case
1:var
n=typeof
d[2]==="number"?1:0,c=d[2];if(typeof
c==="number")var
j=[0,e];else
switch(c[0]){case
0:var
j=[1,e,c[1]];break;case
1:var
j=[2,e,c[1],c[2]];break;case
2:var
j=[3,e,c[1],c[2],c[3]];break;case
3:var
o=[0,c[1],c[2],c[3],c[4],e,bQ,bQ,bQ],l=0;for(;;){iu(d,l,f(o,l)[l+1]);var
t=l+1|0;if(4===l){var
j=[4,5,5,o];break}l=t}break;default:var
g=c[2];if(g<c[3].length-1){c[2]=c[2]+1|0;var
q=c,p=c[3]}else{var
m=aI(g*2|0,bQ);hC(c[3],0,m,0,g);var
q=[4,c[1],g+1|0,m],p=m}f(p,g)[g+1]=e;iu(d,g,e);var
j=q}d[2]=j;if(!n)return n;var
k=d[4];switch(k[0]){case
0:e=d;d=k[1];break;case
4:var
s=k[2];cA(d,k[1]);if(s)throw h([0,i,r6],1);return;case
5:case
6:return;default:var
r=k[2];cA(d,k[1]);e=d;d=r}break;default:throw h([0,i,r7],1)}}function
iz(a,b,c){if(typeof
c!=="number"&&4===c[0]){switch(b[0]){case
0:throw h([0,i,rT],1);case
1:var
e=iw(a,b[3]);break;default:var
e=iw(a,b[2])}var
d=c[1];if(d<=e)c[1]=d+1|0;var
g=d<e?1:0;if(!g)return g;var
j=f(c[3],d)[d+1];f(c[3],e)[e+1]=j;f(c[3],d)[d+1]=b;ff(a,d,e,j);return ff(a,e,d,b)}}function
iA(a){switch(a[0]){case
0:return 0;case
1:var
b=a[1];if(typeof
b!=="number")return 0;if(b)throw h([0,i,r8],1);return 1;default:throw h([0,i,r9],1)}}function
dt(a,b){var
c=a?a[1]:function(a){return 0};return[2,0,0,c,0,b]}var
sa=[c,r$,an(0)];function
du(a,b){if(2!==a[0])throw h([0,i,sc],1);a[3]=b;return 0}function
iB(a,b){var
f=b[1];b[1]=0;var
d=0,c=f;for(;;){if(!c){if(d)throw h([0,sa,a,d],1);return}var
e=ds(d,c[1],c[2]);d=e;c=c[3]}}function
a8(a){var
k=[0,0];try{if(2!==a[0])throw h([0,i,sb],1);var
c=a[1];if(typeof
c==="number"){if(1-a[4]){a[4]=1;cA(a,a[5])}a[1]=1;var
d=function(a,b){switch(b[0]){case
0:return b[1];case
1:var
l=b[1];if(typeof
l!=="number"){var
A=l[1];iz(b,a,b[2]);return A}b[1]=1;var
c=b[4];switch(c[0]){case
0:var
s=c[2],e=g(s,d(b,c[1]));break;case
1:var
t=c[3],u=c[1],v=d(b,c[2]),e=j(t,d(b,u),v);break;case
2:var
w=c[1],x=d(b,c[2]),e=[0,d(b,w),x];break;case
3:var
y=c[1],z=d(b,c[2]),e=g(d(b,y),z);break;case
4:var
f=d(b,c[1]),n=c[2];if(n){var
o=n[1];if(o!==f){k[1]=[0,b,o,k[1]];c[2]=[0,f];cA(b,f)}}else{c[2]=[0,f];cA(b,f)}var
e=d(b,f);break;case
5:var
e=c[1];break;case
6:var
e=g(c[1],b);break;default:var
p=c[2],q=c[1];d(b,p);var
r=d(b,q),e=iA(p)?d(a,b):iA(q)?(ix(1,b),r):r}var
m=b[1];if(typeof
m==="number"&&m)b[1]=[0,e];iz(b,a,b[2]);return e;default:throw h([0,i,r_],1)}},b=d(a,a[5]),e=a[1],f=typeof
e==="number"?e?(a[1]=[0,b],b):b:b}else
var
f=c[1]}catch(f){var
l=C(f);iB([0,l],k);throw h(l,0)}iB(0,k);return f}function
cB(a,b,c){var
m=b[2],i=c,e=0,o=b[1];for(;;){if(!i)break;var
t=i[2],f=0,d=e,k=g(a,i[1]);for(;;){if(d){var
n=d[1],p=d[2],q=n[2];if(f===n[1]){f=f+1|0;d=p;k=j(m,q,k);continue}}i=t;e=[0,[0,f,k],d];break}}if(!e)return o;var
h=e[2],l=e[1][2];for(;;){if(!h)return l;var
s=h[2],r=j(m,h[1][2],l);h=s;l=r}}var
fg=0;function
aY(a){return[0,0,a]}function
iC(a,b){return a<b?b:a}function
dv(a){if(typeof
a==="number")return 0;if(0===a[0]){if(0!==a[1])n(sd);return 0}if(0!==(a[1]&2))n(se);return a[1]>>>2|0}function
iD(a,b){if(typeof
a==="number")var
c=b;else{if(typeof
b!=="number"){var
d=dv(b);return[1,(iC(dv(a),d)+1|0)<<2,a,b]}var
c=a}return c}var
fh=1,fi=2;function
bR(a){return(a&3)===3?1:0}function
iE(a){return(a&3)===1?1:0}function
iF(a){return(a&3)===2?1:0}function
iG(a){return a<<2|2}function
iH(a){return[0,0,0,0]}function
dw(a){a[1]=a[1]+1|0}function
dx(a){a[2]=a[2]+1|0}function
dy(a){a[3]=a[3]+1|0}function
fj(a,b,c){var
d=c;for(;;){if(typeof
d==="number")return;if(0===d[0]){var
e=d[1],g=(e&3)!==3?1:0,l=g?0!==(e&3)?1:0:g;if(l){if(0!==(e&b))throw h([0,i,sf],1);dw(a);dy(a);d[1]=e|3}return}var
f=d[1],j=(f&3)!==3?1:0,k=j?0!==(f&3)?1:0:j;if(!k)return k;if(0!==(f&b))throw h([0,i,sg],1);dw(a);dy(a);d[1]=f|3;fj(a,b,d[2]);d=d[3]}}function
dz(a,b,c,d){if(typeof
d==="number")return;if(0===d[0]){var
e=d[1];if(0===(e&c)){dw(a);if(0===(e&3))d[1]=e|c;else{d[1]=-1;dy(a);dx(a)}}var
g=-1!==e?1:0,h=g?(e&3)===3?1:0:g;return h?(d[1]=-1,dx(a)):h}var
f=d[1];if(0===(f&c)){dw(a);if(0===(f&3)){d[1]=f|c;eU(d,b)}else{d[1]=-1;dy(a);dx(a);fj(a,c,d[2]);fj(a,c,d[3])}}var
i=-1!==f?1:0,j=i?(f&3)===3?1:0:i;return j?(d[1]=-1,dx(a)):j}function
fk(a,b,c){var
d=hI(b);if(typeof
d!=="number"&&0!==d[0]){var
e=(d[1]&3)===c?1:0;return e?(dz(a,b,c,d[2]),dz(a,b,c,d[3])):e}throw h([0,i,sh],1)}function
iI(a,b,c){for(;;){if(eV(b))return;fk(a,b,c)}}function
fl(a){var
b=a[6];a[6]=b+1|0;return b}function
fm(a){var
b=a;for(;;){if(typeof
b==="number")return;if(0===b[0]){var
c=b[1];if(typeof
c!=="number"&&0===c[0]){var
e=c[1],j=-1!==e?1:0,l=j?bR(e):j;if(l)c[1]=e&-4;return}throw h([0,i,si],1)}var
d=b[1];if(typeof
d!=="number"&&0!==d[0]){var
f=d[1],k=-1!==f?1:0,m=b[4],n=b[3],g=k?bR(f):k;if(!g)return g;d[1]=f&-4;fm(n);b=m;continue}throw h([0,i,sj],1)}}function
iJ(a,b){var
c=b;for(;;){if(typeof
c==="number")return;if(0===c[0])break;var
g=c[1];if(typeof
g!=="number"&&0!==g[0]){var
r=c[4],s=c[3],j=g[1],w=c[2];if(-1===j){var
l=fl(a);f(a[4],l)[l+1]=g;f(a[5],l)[l+1]=[0,c,0];g[1]=iG(l);fm(s);return fm(r)}if(!iE(j)){if(iF(j)){var
o=j>>>2|0,x=[0,c,f(a[5],o)[o+1]];f(a[5],o)[o+1]=x;return}var
t=bR(j);if(t)throw h([0,i,sp],1);return t}if(-1<a[3]){var
p=a[3]-1|0;f(a[1],p)[p+1]=w;a[3]=p;if(a[2]>a[3])throw h([0,i,so],1)}g[1]=j&-4;iJ(a,s);c=r;continue}throw h([0,i,sn],1)}var
d=c[1];if(typeof
d!=="number"&&0===d[0]){var
e=d[1],u=c[2];if(!iE(e)){if(-1===e){var
k=fl(a);f(a[4],k)[k+1]=d;f(a[5],k)[k+1]=[0,c,0];d[1]=iG(k);return}if(iF(e)){var
m=e>>>2|0,v=[0,c,f(a[5],m)[m+1]];f(a[5],m)[m+1]=v;return}var
q=bR(e);if(q)throw h([0,i,sm],1);return q}var
n=a[2];if(-1<n){f(a[1],n)[n+1]=u;a[2]=n+1|0;if(a[2]>a[3])throw h([0,i,sl],1)}d[1]=e&-4;return}throw h([0,i,sk],1)}function
cC(a,b){if(typeof
b==="number")return 0;if(0!==b[0]){var
j=b[1];if(-1===j){var
l=fl(a);b[1]=0;f(a[4],l)[l+1]=b;var
p=cC(a,b[2]);return[1,b,0,p,cC(a,b[3])]}if(!bR(j)){b[1]=b[1]&-4;var
r=cC(a,b[2]);return[1,b,0,r,cC(a,b[3])]}var
d=j>>>2|0,k=f(a[5],d)[d+1];if(!k)throw h([0,i,sr],1);var
m=k[2],q=k[1];f(a[5],d)[d+1]=m;if(0===m)b[1]=0;return q}var
e=b[1];if(-1!==e&&bR(e)){var
c=e>>>2|0,g=f(a[5],c)[c+1];if(!g)return[0,b,0];var
n=g[2],o=g[1];f(a[5],c)[c+1]=n;return o}b[1]=0;return[0,b,0]}var
fn=[0,0,[0],0,0];function
iK(a,b,c){if(typeof
b==="number"){if(typeof
c==="number")return[0,fn,0]}else if(b[1]===c)return[0,fn,b];var
I=typeof
b==="number"?fg:b[1],j=iH(0),m=iH(0),q=eS(0),r=eS(0);dz(j,q,fh,I);dz(m,r,fi,c);a:{b:{for(;;){if(eV(q))break b;if(eV(r))break;fk(j,q,fh);fk(m,r,fi)}iI(j,q,fh);break a}iI(m,r,fi)}var
x=j[1]-(j[3]+m[3]|0)|0,y=j[2]+m[2]|0,J=0,K=aI(y,0),L=aI(y,0),M=a?x:-1,N=a?0:-1,O=a?aI(x,0):[0],d=[0,O,N,M,L,K,J];iJ(d,b);if(d[2]!==d[3])throw h([0,i,ss],1);var
w=d[6]-1|0,F=0;if(w>=0){var
e=F;for(;;){var
k=f(d[4],e)[e+1];if(typeof
k!=="number")if(0===k[0])k[1]=k[1]|3;else
k[1]=k[1]|3;var
t=f(d[5],e)[e+1];if(!t)throw h([0,i,sq],1);if(t[2]){var
G=ab(t);f(d[5],e)[e+1]=G}var
H=e+1|0;if(w===e)break;e=H}}var
z=cC(d,c),A=d[6]-1|0;if(A>=0){var
o=A;for(;;){var
l=f(d[4],o)[o+1];if(typeof
l!=="number")if(0===l[0])l[1]=0;else{var
E=dv(l[3]);l[1]=(iC(dv(l[2]),E)+1|0)<<2}var
R=o-1|0;if(0===o)break;o=R}}if(!a)return[0,fn,z];var
u=[0,0],v=[0,0],B=d[6]-1|0,P=0;if(B>=0){var
n=P;a:for(;;){var
g=f(d[5],n)[n+1];for(;;){if(!g){var
Q=n+1|0;if(B===n)break a;n=Q;break}var
p=g[2],s=g[1];if(typeof
s==="number")g=p;else if(0===s[0]){var
C=s[2];if(C){u[1]=[0,C[1],u[1]];g=p}else
g=p}else{var
D=s[2];if(D){v[1]=[0,D[1],v[1]];g=p}else
g=p}}}}return[0,[0,d[2],d[1],u[1],v[1]],z]}function
cD(a,b){return[0,[0,a,b],0]}function
cE(a){var
c=a[2],m=a[1];if(typeof
c==="number")return 0;function
b(a){a:if(typeof
a!=="number"){if(0===a[0]){var
c=a[1];if(typeof
c==="number")break a;if(0!==c[0])break a;var
d=a[2];if(!d){var
f=g(m[1],c[2]);a[2]=[0,f];return f}var
e=d[1]}else{var
k=a[2];if(!k){var
n=b(a[3]),o=b(a[4]),l=j(m[2],n,o);a[2]=[0,l];return l}var
e=k[1]}return e}throw h([0,i,st],1)}return[0,b(c)]}function
iL(a,b){var
c=a[1];return[0,c,iK(0,a[2],b)[2]]}function
fo(a,b){var
d=a[1],c=iK(1,a[2],b);return[0,c[1],[0,d,c[2]]]}function
dA(a,b,c,d){var
e=[0,d];if(b6===a)var
l=c[1],h=0;else if(nb<=a)var
l=c[2].length-1,h=c[1];else
var
l=c[2].length-1,h=0;var
m=l-1|0;if(m>=h){var
g=h;for(;;){var
n=f(c[2],g)[g+1];if(n)e[1]=j(b,n[1],e[1]);var
o=g+1|0;if(m===g)break;g=o}}if(nb>a){var
k=c[3];for(;;){if(!k)break;var
q=k[2];e[1]=j(b,k[1],e[1]);k=q}}if(b6!==a){var
i=c[4];for(;;){if(!i)break;var
p=i[2];e[1]=j(b,i[1],e[1]);i=p}}}function
dB(a,b,c){if(typeof
c==="number")throw h([0,i,su],1);if(0===c[0])return g(a,c[2]);var
d=dB(a,b,c[3]);return j(b,dB(a,b,c[2]),d)}function
dC(a,b,c){var
d=b[2],e=b[1],f=cx(c);if(f){var
g=f[1];return typeof
g==="number"?[0,e]:[0,dB(a,d,g)]}var
h=[0,cD(a,d)];return D(c,function(a){var
b=iL(h[1],a);h[1]=b;var
c=cE(b);return c?c[1]:e})}var
cF=[0,fg,iD];function
dD(a){function
e(a,b){var
c=a,d=b;for(;;){if(typeof
c==="number")return d;if(0===c[0])return[0,c[2],d];var
f=e(c[3],d);c=c[2];d=f}}return e(a,0)}var
iM=[0,[0,0],function(a,b){return dr(a,b,iD)}];function
bS(c,b){return dC(function(a){return aY(g(c,a))},cF,b)}function
iN(c,b){return dC(function(a){var
b=g(c,a);return b?aY(b[1]):fg},cF,b)}function
cG(a){return it(dC(function(a){return D(a,aY)},iM,a))}var
bn=e;function
iO(a,b){var
c=a?a[1]:bn;return g0(b).join(c)}function
dE(a){return 0===a.length?1:0}d.Number;var
aZ=null,iP=undefined;function
bT(a){var
b=a===aZ?1:0;return b?b:a===iP?1:0}var
b=d;function
cH(a){return new
b.Array(a)}function
iQ(o,b){var
k=b.length;function
c(a){return g(o,b[a])}if(0>k)return n(op);var
f=k-1|0,j=0;if(f<0)return 0;if(0===f)return[0,c(j),0];var
l=c(j),h=[0,c(1),ba],e=h,d=1,a=2;for(;;){if(f<a)e[d+1]=0;else{if(a!==f){var
m=c(a),i=[0,c(a+1|0),ba];e[d+1]=[0,m,i];e=i;d=1;a=a+2|0;continue}e[d+1]=[0,c(a),0]}return[0,l,h]}}b.Promise;function
bo(a,b,c){return gX(a,B(b),c)}var
iR=B,fq=r;b.Event;function
fr(a,b,c,d){var
e=a?a[1]:{},f=eA(1,c);d.addEventListener(b,f,e);return function(a){d.removeEventListener(b,f,e);return 0}}function
iS(a){return g(a,0)}var
fs="change",iT="click",iU="focusin";b.ArrayBuffer;b.DataView;b.Blob;b.File;var
iV=b.JSON;b.encodeURI;b.decodeURI;b.encodeURIComponent;b.decodeURIComponent;var
iW=b.URL,iX=b.URLSearchParams;b.RegExp;var
iZ=[0,bn,bn];function
i0(a,b){return a?b:iZ}var
aF=mi,i1="for",i2=bF,i3=em,ft="type",i4=l8,dF=b.document;function
rK(b){var
c=k(b),d=0;return function(a){return is(b,d,c,a)}}var
sv=true,sw="DOMContentLoaded",sx="focusout",sy=lA,sC="href",sD="placeholder",sE=mM,sB=[0,"checked",bn],y9=[0,"selected",bn],sF=bT(dF)?iP:dF.documentElement;function
dG(a,b,c,d){var
n=a?a[1]:dF,o=b?b[1]:0,g=n.createElement(c),i=0,h=0,e=o;for(;;){if(!e)break;var
f=e[2],m=e[1],j=m[2],k=m[1];if(dE(k))e=f;else if(a3(k,sE)){i=[0,j,i];e=f}else if(a3(k,aF))if(dE(j))e=f;else{h=[0,j,h];e=f}else{g.setAttribute(k,j);e=f}}if(0!==i)g.setAttribute(mM,iO([0,";"],ab(i)));var
l=0!==h?(g.setAttribute(mi,iO([0,as],ab(h))),d):d;for(;;){if(!l)return g;var
p=l[2];g.appendChild(l[1]);l=p}}function
a9(a,b){var
c=a?a[1]:dF;return c.createTextNode(r(b))}function
i5(a,b){var
d=a?a[1]:sF,c=d.querySelector(b);return bT(c)?0:[0,c]}function
i6(a,b,c){return dE(a)?0:b?(c.setAttribute(a,b[1]),0):(c.removeAttribute(a),0)}function
i7(a,b,c){return b?(c.classList.add(a),0):(c.classList.remove(a),0)}var
i8="button",bp="div",i9="label";b["Range.END_TO_END"];b["Range.END_TO_START"];b["Range.START_TO_END"];b["Range.START_TO_START"];b.Range;function
fu(a,b,c){gX(a,b,c)}var
fv=b.console;function
fw(a){var
d=cH(0),c=0,b=a;for(;;){if(!b)return z1(d);var
e=b[2];d[c]=b[1];c=c+1|0;b=e}}function
fx(a){return fu(fv,sN,fw(a))}function
i_(a){return new
iW(a.location)}b.console;b.navigator;b.performance;var
bU=b.window;b.isSecureContext;b.ClipboardItem;b.FormData;b.Headers;b.Request;b.Response;b.fetch;b.MediaStream;b.MediaRecorder;b.MessageChannel;b.BroadcastChannel;b.Notification;b.WebSocket;function
ja(a){var
b=a[1];return 82===b?hs(cx(a[2])):83<=b?hs(cx(a[2])):1}function
dH(a){return hr(cx(a))}function
jb(a){if(!a)return sR;var
d=0,c=0,b=a;for(;;){if(!b)break;var
f=b[2],e=b[1];if(ja(e)){d=[0,e,d];b=f}else{c=[0,e,c];b=f}}var
g=ab(c);return[0,bg(aw(function(a){var
b=a[1];return 82===b?[0,dH(a[2]),0]:83<=b?dD(dH(a[2])):[0,a[2],0]},ab(d))),g]}var
jc=kU,fy="before";function
sT(a){return[0,a]}function
sU(a,b){return[1,aZ,a,b]}var
sV="remove",sW="contains";function
jd(a){var
b=a.ownerDocument.activeElement,c=bT(b)?0:[0,b];return c?bo(a,sW,[0,c[1]])|0:0}function
je(d,b){var
c=[0,cD(sT,sU)];return D(b,function(a){var
b=fo(c[1],a),e=b[2],g=b[1];c[1]=e;dA(b6,function(a,b){return 0===a[0]?a[1][d4]=sv:0},g,0);var
h=jd(d),i=cE(e);if(i){var
f=function(a,b){if(0!==b[0]){if(b[1]!==aZ)return b[1];var
m=f(a,b[3]),l=f(m,b[2]);b[1]=l;return l}var
c=b[1];delete
c[d4];if(c.parentNode!==d)if(a===aZ)bo(d,jc,[0,c]);else
bo(a,fy,[0,c]);else{var
i=c.nextSibling!==a?1:0;if(i){if(h){var
j=jd(c);if(j)for(;;){var
g=c.nextSibling;if(g===a){var
e=1;break}if(g===aZ){var
e=0;break}bo(c,fy,[0,g])}else
var
e=j}else
var
e=h;var
k=1-e}else
var
k=i;if(k)if(a===aZ)bo(d,jc,[0,c]);else
bo(a,fy,[0,c])}return c};f(aZ,i[1])}dA(b6,function(a,b){if(0!==a[0])return 0;var
c=a[1],d=1-bT(c[d4]),e=d?(delete
c[d4],bo(c,sV,[0]),0):d;return e},g,0);return d})}var
dZ=[0,0],fz=[0,bn,bn],sI=lA;function
jf(c,b){function
d(a){var
b=a[2],d=a[1];return a3(d,aF)?i7(b,1,c):i6(d,[0,b],c)}function
e(a){var
b=a[1],d=a[2];return a3(b,aF)?i7(d,0,c):i6(b,0,c)}function
f(a){var
b=[0,fz];return function(a){if(b[1]!==fz)e(b[1]);d(a);b[1]=a;return 0}}return cB(function(a){var
b=a[1];if(82===b){var
g=a[2];return D(g,f(0))}if(83>b)throw h([0,i,sX],1);var
j=a[2],c=[0,cD(function(a){d(a);return a},function(a,b){return fz})];return D(j,function(a){var
b=fo(c[1],a),d=b[2],f=b[1];c[1]=d;dA(b6,function(a,b){return e(a)},f,0);cE(d);return 0})},[0,dZ,function(a,b){return dZ}],b)}function
fA(a,b){return fr(b[1],b[2],b[3],a)}function
ae(a,b,c,d,e,f){var
y=b?b[1]:0,z=c?c[1]:0,A=d?d[1]:function(a){},u=jb(y),q=u[2],B=u[1],v=jb(z),w=v[2];a:{var
C=v[1];if(f){var
m=f[1],s=m[1];b:{if(82===s){if(!f[2]){var
l=[0,0,[0,D(m[2],aY)]];break a}var
k=f}else if(83<=s){if(!f[2]){var
l=[0,0,[0,m[2]]];break a}var
k=f}else{if(!f[2]){var
l=[0,[0,m[2],0],0];break a}var
k=f}for(;;){if(!k)break;var
x=k[2],r=ja(k[1]);if(!r){var
t=r;break b}k=x}var
t=1}var
l=t?[0,bg(aw(function(a){var
b=a[1];return 82===b?[0,dH(a[2]),0]:83<=b?dD(dH(a[2])):[0,a[2],0]},f)),0]:[0,0,[0,cB(function(a){var
b=a[1];return 82===b?D(a[2],aY):83<=b?a[2]:[0,aY(a[2])]},iM,f)]]}else
var
l=sS}var
n=l[2],j=dG(a,[0,B],e,l[1]);g(A,j);if(q)if(n)var
E=je(j,n[1]),o=dr(jf(j,q),E,function(a,b){return b});else
var
o=D(jf(j,q),function(a){return j});else
var
o=n?je(j,n[1]):[0,j];var
p=C;for(;;){if(!p)break;var
G=p[2];fA(j,p[1]);p=G}var
F=w?dr(cB(function(a){var
b=a[1];if(82===b){var
c=[0,0];return D(a[2],function(a){var
b=c[1];if(b)iS(b[1]);c[1]=[0,fA(j,a)];return 0})}if(83>b)throw h([0,i,sY],1);var
e=a[2],d=[0,cD(function(a){return fA(j,a)},function(a,b){return a})];return D(e,function(a){var
b=fo(d[1],a),c=b[2],e=b[1];d[1]=c;dA(b6,function(a,b){return iS(a)},e,0);cE(c);return 0})},[0,dZ,function(a,b){return dZ}],w),o,function(a,b){return b}):o;return F}function
jg(a,b,c,d,e){return ae(a,b,c,d,sI,0)}function
fB(a,b,c){var
e=a?a[1]:0,d=dt(0,c);du(d,function(a){bU.queueMicrotask(eA(1,function(a){return g(b,a8(d))}));return 0});var
f=a8(d);return e?g(b,f):e}var
i$=bU.localStorage,sM="span",sZ="pattern";function
jh(a,b){var
d=iV.stringify(b);try{i$.setItem(a,d);return}catch(f){var
c=C(f);if(c[1]===fd)return;throw h(c,0)}}function
ji(a,b){var
i=r(a),k=i$.getItem(i),l=bT(k)?0:[0,k],f=l?[0,l[1]]:s1;if(0===f[0]){a:{var
o=f[1];try{var
p=iV.parse(o)}catch(f){var
e=C(f);if(e[1]!==fd)throw h(e,0);var
c=[1,e[2]];break a}var
c=[0,p]}var
d=0===c[0]?[0,c[1]]:(fu(fv,sO,fw([0,c[1],0])),s0)}else
var
d=[1,f[1]];if(0===d[0])var
j=d[1];else
var
m=d[1],j=typeof
m==="number"?b:(fu(fv,sP,fw([0,m[2],0])),b);jh(i,j);var
n=cz(j),g=dt(0,n);du(g,function(a){jh(i,a8(g));return 0});a8(g);return n}function
bV(d,b,c){var
a=b[1],e=82===a?[0,82,D(b[2],function(a){return[0,d,r(a)]})]:83<=a?ce(s2):[0,80,[0,d,r(b[2])]];return[0,e,c]}function
fC(a,b,c){return b?[0,[0,80,[0,a,r(b[1])]],c]:c}function
fD(a){return 0===a[0]?[0,aF,r(a[1])]:a[1]}function
jj(a,b){var
c=a[1],d=82===c?[0,82,D(a[2],fD)]:83<=c?[0,83,bS(fD,a[2])]:[0,80,fD(a[2])];return[0,d,b]}function
jk(a,b,c,d,e){var
o=b?b[1]:0,p=c?c[1]:function(a){},j=e[5],k=e[4],l=e[3],h=e[2],m=e[1];function
i(a){return a?[0,m]:0}a:if(d)var
f=d[1];else{if(a&&a[1]){var
f=ji(h,i(j));break a}var
f=cz(i(j))}var
t=ae(0,[0,[0,[0,80,[0,i1,r(h)]],0]],0,0,i9,g(k,0)),q=bV(ft,s5,bV(i3,[0,80,l],bV(i2,[0,80,h],0))),n=[0,0],s=ae(0,0,0,0,bp,[0,[0,82,jg(0,[0,[0,[0,82,D(f,function(a){return a?sB:iZ})],q]],[0,[0,[0,80,[0,0,fs,function(a){var
b=i(a.target.checked|0);g(p,b);return ax(f,b)}]],o]],[0,function(a){n[1]=[0,a];return 0}],0)],[0,[0,82,t],0]]);fB(0,function(a){var
b=n[1];if(!b)return 0;var
c=b[1];return c.checked=!!iq(a)},f);return[0,s,[0,[0,m,h,l,k,f]]]}function
jl(a,b){return a?g(v(s6),b):b}var
jo=[c,th,an(0)];io(tk,[0,jo,0,tj,ti]);hS(function(a){if(a[1]!==jo)return 0;var
c=a[2],e=a[4],f=a[3];if(typeof
c==="number"){var
d=c;if(34<=d)switch(d){case
34:var
b=tU;break;case
35:var
b=tV;break;case
36:var
b=tW;break;case
37:var
b=tX;break;case
38:var
b=tY;break;case
39:var
b=tZ;break;case
40:var
b=t0;break;case
41:var
b=t1;break;case
42:var
b=t2;break;case
43:var
b=t3;break;case
44:var
b=t4;break;case
45:var
b=t5;break;case
46:var
b=t6;break;case
47:var
b=t7;break;case
48:var
b=t8;break;case
49:var
b=t9;break;case
50:var
b=t_;break;case
51:var
b=t$;break;case
52:var
b=ua;break;case
53:var
b=ub;break;case
54:var
b=uc;break;case
55:var
b=ud;break;case
56:var
b=ue;break;case
57:var
b=uf;break;case
58:var
b=ug;break;case
59:var
b=uh;break;case
60:var
b=ui;break;case
61:var
b=uj;break;case
62:var
b=uk;break;case
63:var
b=ul;break;case
64:var
b=um;break;case
65:var
b=un;break;case
66:var
b=uo;break;default:var
b=up}else
switch(d){case
0:var
b=tl;break;case
1:var
b=tn;break;case
2:var
b=to;break;case
3:var
b=tp;break;case
4:var
b=tq;break;case
5:var
b=tr;break;case
6:var
b=ts;break;case
7:var
b=tt;break;case
8:var
b=tu;break;case
9:var
b=tv;break;case
10:var
b=tw;break;case
11:var
b=tx;break;case
12:var
b=ty;break;case
13:var
b=tz;break;case
14:var
b=tA;break;case
15:var
b=tB;break;case
16:var
b=tC;break;case
17:var
b=tD;break;case
18:var
b=tE;break;case
19:var
b=tF;break;case
20:var
b=tG;break;case
21:var
b=tH;break;case
22:var
b=tI;break;case
23:var
b=tJ;break;case
24:var
b=tK;break;case
25:var
b=tL;break;case
26:var
b=tM;break;case
27:var
b=tN;break;case
28:var
b=tO;break;case
29:var
b=tP;break;case
30:var
b=tQ;break;case
31:var
b=tR;break;case
32:var
b=tS;break;default:var
b=tT}}else
var
h=c[1],b=g(v(uq),h);return[0,_(v(tm),b,f,e)]});rk(0,7);Ac(0);function
dI(a,b,c){var
d=nV([0,0,0,0,c,b-1|0,a-1900|0,-1,-1,0]),e=d[2],f=d[1],g=nV(g9(0.))[1],h=e[9]?mF:0.;return f-g+h}function
fF(a,b,c){return((a*cW|0)+(b*60|0)|0)+c|0}function
jq(a,b){var
c=aa(b);return fF(aa(a),c,0)}function
jr(a){return fF(aa(a),0,0)}var
ur=0.;function
js(a){return 45===a?function(a){return a0+a}:function(a){return a}}function
fG(a){return a!==e?nv(a1+ci(a,1,k(a)-1|0)):0.}function
us(a){a[10]=aI(25,-1);var
e=a[6];f(a[10],9)[10]=e;var
j=a[6];f(a[10],8)[9]=j;var
k=a[6];f(a[10],7)[8]=k;var
l=a[6];f(a[10],6)[7]=l;var
c=0;for(;;){var
b=hG(dJ,c,a);if(5>=b>>>0)break;g(a[1],a);c=b}switch(b){case
0:return dI(aa(z(a,a[5],a[6])),1,1);case
1:var
m=z(a,a[5],a[5]+4|0),C=aa(z(a,a[5]+5|0,a[5]+7|0));return dI(aa(m),C,1);case
2:var
n=f(a[10],4)[5],o=z(a,f(a[10],5)[6],n),p=f(a[10],2)[3],q=z(a,f(a[10],3)[4],p),r=f(a[10],0)[1],B=aa(z(a,f(a[10],1)[2],r)),A=aa(q);return dI(aa(o),A,B);case
3:var
s=f(a[10],2)[3];z(a,f(a[10],3)[4],s);var
t=f(a[10],0)[1];z(a,f(a[10],1)[2],t);throw h([0,i,ut],1);case
4:var
u=f(a[10],3)[4];z(a,f(a[10],4)[5],u);var
v=f(a[10],1)[2];z(a,f(a[10],2)[3],v);db(a,f(a[10],0)[1]);throw h([0,i,uu],1);default:var
w=f(a[10],2)[3],x=z(a,f(a[10],3)[4],w),y=f(a[10],0)[1],d=aa(z(a,f(a[10],1)[2],y));return dI(aa(x),1,d)}}var
jt=c7,bq=[0,0],jp=Ax(0),uC=g9(jp)[3],ju=nU(jp)[3]-uC|0;function
fH(a){bq[1]=a}function
fI(a,b){function
d(a,b){if(!gZ(a,b))throw h([0,i,uE],1);if(typeof
a==="number")if(a){if(typeof
b!=="number")return b[1]-ju|0}else{if(typeof
b!=="number")return b[1];if(b)return ju}else if(typeof
b!=="number")return b[1]-a[1]|0;throw h([0,i,uD],1)}var
e=a3(a,b)?0:gZ(a,b)?d(a,b):-d(b,a)|0,c=e%24|0;return mn<=c?11<c?c-24|0:c:c+24|0}function
jv(a,b,c){return a+(cW*fI(b,c)|0)|0}function
fJ(a){return jv(a,0,bq[1])}function
fK(a){return jv(a,bq[1],0)}function
uB(a){var
b=nK(a),c=b[2],d=b[1]<mW?0:1;return(c|0)+d|0}function
uG(a){var
b=fJ(a),c=b/mL|0;fK(b%mL|0);return 0<=b?[0,,c]:[0,,c-1|0]}function
uI(a){return fJ(a)/cW|0}function
uJ(a){return(fJ(a)%cW|0)/60|0}function
uK(a){return a*cW|0}function
uL(a,b){return a+b|0}var
uR=[c,uQ,an(0)],uT=[c,uS,an(0)];function
fM(a,b){return-1===c7(a,b)?1:0}function
jC(a,b){var
c=b[3],d=b[2],e=b[1];return 0===a?j(e,d,c):a}function
dK(a,b){var
c=[0,jt,a[3],b[3]];return fM(jC(jC(c7(a[1],b[1]),[0,jt,a[2],b[2]]),c),0)}function
fN(a,b,c){if(fM(b,0))var
g=[0,a,b];else
var
j=b-1|0,g=[0,a+(j/12|0)|0,(j%12|0)+1|0];var
d=g[2],f=g[1],i=dK(uU,[0,f,d,c]),m=i?dK([0,f,d,c],uV):i;if(!m)throw h(uR,1);var
k=(14-d|0)/12|0,e=(f+4800|0)-k|0,l=(d+(12*k|0)|0)-3|0;if(dK(uW,[0,f,d,c]))return(((((c+(((b8*l|0)+2|0)/5|0)|0)+(e*mr|0)|0)+(e/4|0)|0)-(e/cR|0)|0)+(e/400|0)|0)-32045|0;if(dK([0,f,d,c],uX))return(((c+(((b8*l|0)+2|0)/5|0)|0)+(e*mr|0)|0)+(e/4|0)|0)-32083|0;throw h(uT,1)}function
jD(a){return fM(a,2299161)}function
jE(a){if(jD(a))var
b=a+mZ|0;else
var
c=a+lR|0,b=c-(((((4*c|0)+3|0)/d$|0)*d$|0)/4|0)|0;return b-((eb*(((4*b|0)+3|0)/eb|0)|0)/4|0)|0}function
uY(a){var
b=jE(a);return(b-(((b8*(((5*b|0)+2|0)/b8|0)|0)+2|0)/5|0)|0)+1|0}function
uZ(a){var
b=((5*jE(a)|0)+2|0)/b8|0;return(b+3|0)-(12*(b/10|0)|0)|0}function
u0(a){if(jD(a))var
b=a+mZ|0,d=0;else
var
c=a+lR|0,f=((4*c|0)+3|0)/d$|0,b=c-((f*d$|0)/4|0)|0,d=f;var
e=((4*b|0)+3|0)/eb|0;return(((d*cR|0)+e|0)-4800|0)+((((5*(b-((eb*e|0)/4|0)|0)|0)+2|0)/b8|0)/10|0)|0}function
u2(a){return[0,u1[1],a]}function
u3(a){return[0,a[1]/12|0,a[1]%12|0,a[2]]}function
u4(a,b){var
c=u3(b),d=c[3],e=c[2],f=c[1],g=uY(a)+d|0,h=uZ(a)+e|0;return fN(u0(a)+f|0,h,g)}function
jw(a,b,c){return a+fI(b,c)/24.}function
jx(a){return jw(a,0,bq[1])}function
jy(a){var
b=nK(jx(a)+mW)[1]*d6;if(b<d6)return fK(uB(b));throw h([0,i,uM],1)}function
fL(a){return uI(jy(a))}function
jz(a){return uJ(jy(a))}function
uN(a,b){u4(a,u2(uG(b)[2]))}function
uO(a,b,c){var
d=uK(fI(b,c)),e=uL(a[2],d);return uN(a[1],e)}function
uP(a){return uO(a,bq[1],0)}function
jA(a,b){return uP([0,a,b])}var
kp=bq[1];fH(0);var
sG="a",sH="h4",sJ="option",sK=kT,sL="select";function
ta(a,b,c){var
y=a?a[1]:0,z=b?b[1]:0,e=cz(0),s=[0,[0,80,[0,ft,lX]],fC(i4,0,fC(sD,0,0))],I=fC(sZ,0,s),j=cz(s3),u=jg(0,[0,I],[0,[0,[0,80,[0,0,sy,function(a){return ax(j,B(a.target.value))}]],0]],0,0),A=D(j,function(a){var
d=0,c=0,b=k(a);for(;;){if(b===0)break;d=[0,t(a,c),d];c=c+1|0;b=b-1|0}var
f=ab(d);return function(a){var
b=f,c=rK(a[1][3]);for(;;){var
d=c(0);if(!b)return 1;if(!d)return 0;var
e=d[2],g=b[2],h=d[1],i=ht(b[1]);if(0===(ht(h)-i|0)){b=g;c=e}else
c=e}}}),w=0,l=bS(function(a){var
b=a[1],f=zF(10,cR,0,b[1]),e=c[1],d=_(v(s4),e,w,f);return jk([0,y],0,0,0,[0,b[1],d,b[3],b[4],b[5]])},c[2]),d=iN(function(a){return a},cG(bS(function(b){var
c=b[2];return D(A,function(a){return g(a,c)?[0,b]:0})},l))),x=bS(function(a){return a[1]},d),r=iN(function(a){var
b=a[1],c=a[2];return b?[0,[0,b[1],c]]:0},cG(dC(function(a){var
b=a[2];return aY(D(b[1][5],function(a){return[0,a,b]}))},cF,l))),J=ae(0,0,0,0,bp,[0,[0,83,cG(x)],0]);function
E(a,b){var
c=a?b:a;return c}function
m(b){return function(a){return dr(b,a,E)}}function
n(a){return D(a[2][1][5],function(a){return iq(a)})}var
C=D(d,function(f){return[0,0,fs,function(a){var
d=a.target.checked|0?function(a,b){return ax(a,[0,b])}:function(a,b){return ax(a,0)},b=dD(f);for(;;){if(!b)return 0;var
c=b[1][2][1],e=b[2];d(c[5],c[1]);b=e}}]}),f=cx(d);if(f)var
h=f[1],o=typeof
h==="number"?[0,0]:[0,[0,dB(n,m,h)]];else
var
i=[0,cD(n,m)],o=D(d,function(a){var
b=iL(i[1],a);i[1]=b;return cE(b)});var
F=it(D(o,function(a){return a?a[1]:[0,0]})),p=jk(td,[0,[0,[0,82,C],0]],0,0,[0,0,tc,tb,function(a){return 0},0]),q=p[2][1][5],G=p[1];fB(tf,function(a){return a?ax(q,te):ax(q,0)},F);var
H=[0,[0,80,[0,aF,"lwdui-select-multiple-pill"]],0],L=ae(0,[0,[0,[0,80,[0,aF,"lwdui-select-multiple-selected"]],0]],0,0,bp,[0,[0,83,cG(bS(function(a){var
b=a[2][1],c=b[5],d=b[4],e=[0,[0,[0,82,ae(0,0,[0,[0,[0,80,[0,0,iT,function(a){return ax(c,0)}]],[0,[0,80,[0,0,iU,function(a){a.stopImmediatePropagation();return 0}]],0]]],0,i8,[0,[0,80,a9(0,tg)],0])],0],0];return ae(0,[0,H],0,0,sM,bg([0,g(d,0),e]))},r))],0]),K=ae(0,[0,[0,[0,80,[0,aF,"lwdui-select-multiple-search-bar"]],0]],0,0,bp,[0,[0,82,u],[0,[0,82,G],0]]);return[0,ae(0,[0,[0,[0,80,[0,aF,"lwdui-select-multiple"]],z]],[0,[0,[0,80,[0,0,iU,function(a){return ax(e,1)}]],[0,[0,80,[0,0,sx,function(a){return ax(e,0)}]],0]]],0,i8,[0,[0,82,L],[0,[0,82,ae(0,[0,[0,[0,80,[0,aF,"lwdui-select-multiple-choices"]],[0,[0,82,D(e,function(a){return i0(1-a,[0,aF,"display-none"])})],0]]],0,0,bp,[0,[0,82,K],[0,[0,82,J],0]])],0]]),,,r]}function
uv(a,b){var
P=a?a[1]:1,p=us(b);a:{b:{var
o=80;for(;;){var
k=hF(dJ,o,b);if(0===k)break;if(1===k)break b;g(b[1],b);o=k}var
q=[0,db(b,b[5])];break a}var
q=0}if(!q){if(P)throw h([0,i,uw],1);return[0,p]}b[10]=aI(17,-1);var
r=b[6];f(b[10],8)[9]=r;var
l=47;for(;;){var
e=hG(dJ,l,b);if(2>=e>>>0)break;g(b[1],b);l=e}switch(e){case
0:var
s=f(b[10],2)[3],t=z(b,f(b[10],3)[4],s),u=f(b[10],4)[5],v=z(b,f(b[10],5)[6],u),w=f(b[10],6)[7],x=z(b,f(b[10],7)[8],w),y=f(b[10],0)[1],A=fG(z(b,f(b[10],1)[2],y)),R=aa(x),Q=aa(v),d=fF(aa(t),Q,R)+A;break;case
1:var
B=z(b,b[5],b[5]+2|0),C=f(b[10],0)[1]+2|0,D=z(b,f(b[10],0)[1],C),E=b[6],F=fG(z(b,f(b[10],0)[1]+2|0,E))*60.,d=jq(B,D)+F;break;default:var
G=z(b,b[5],b[5]+2|0),H=fG(z(b,b[5]+2|0,b[6]))*mF,d=jr(G)+H}var
m=71;for(;;){var
j=hF(dJ,m,b);if(3>=j>>>0)break;g(b[1],b);m=j}switch(j){case
0:var
c=[0,ur];break;case
1:var
I=db(b,b[5]),J=z(b,b[5]+1|0,b[5]+3|0),K=z(b,b[6]-2|0,b[6]),n=js(I),L=n(K),c=[0,jq(n(J),L)];break;case
2:var
M=db(b,b[5]),N=z(b,b[5]+1|0,b[5]+3|0),c=[0,jr(js(M)(N))];break;default:var
c=0}var
O=c?d-c[1]:d;return[0,p+O]}function
uH(a){return fK(43200)}try{var
jB=uH(0);jA(fN(kW,1,22),jB);jA(fN(-4712,1,1),jB);fH(kp)}catch(f){var
uF=C(f);fH(kp);throw h(uF,0)}var
u5=b.Date;function
fO(a){return new
u5(r(a))}function
dL(a){return z0(hD(eO(function(a){return a},a)))}function
E(c,b){return function(a){return a?[0,[0,c,g(b,a[1])]]:0}}function
dM(a,b,c,d,e,f){function
g(a){return E(a,function(a){return a})}var
h=[0,g(u6)(e),0],i=[0,g(u7)(d),h],j=[0,g(u8)(c),i],k=[0,g(u9)(b),j];return dL([0,g(u_)(a),k])}function
fP(a,b,c,d,e,f){var
g=E(vh,function(a){return a})(b),h=E(vi,fq)(c),i=E(vj,fq)(d);return dL([0,[0,[0,vg,r(a)]],[0,g,[0,h,[0,i,[0,E(vk,g0)(e),0]]]]])}function
fR(a,b,c){if(b){var
k=cH(0),e=c,g=0;for(;;){if(!e){var
j=k,i=vQ;break}var
m=e[2];k[g]=e[1];e=m;g=g+1|0}}else{var
h=cH(0),f=0,d=c;for(;;){if(!d){var
j=h,i=vR;break}var
l=d[2];h[f]=d[1];f=f+1|0;d=l}}a.setOption(r(i),j);return 0}function
fS(a,b,c){var
Q=a?a[1]:2,m=b,i=[0,hi,0];for(;;){if(!m){var
R=i[2];return i[1]<=Q?ab(R):0}var
w=m[2],l=m[1],E=i[2],s=i[1],z=gY(k(c),k(l))?c:l,A=gY(k(c),k(l))?l:c,j=k(z),p=1,q=aI(j+1|0,0),r=j+1|0,I=k(A);if(0===r)var
g=[0],e=q,h=p;else if(0<=r){var
u=aI(r,0),y=r-1|0,F=1;if(y<1)var
g=u,e=q,h=p;else{var
o=F;for(;;){u[o+1]=o;var
G=o+1|0;if(y===o){var
g=u,e=q,h=p;break}o=G}}}else
var
g=n(oA),e=q,h=p;for(;;){if(I<h){var
v=f(g,j)[j+1];if(v===s){m=w;i=[0,s,[0,l,E]];break}if(v<s){m=w;i=[0,v,[0,l,0]];break}m=w;i=[0,s,E];break}f(e,0)[1]=h;var
J=1;if(j>=1){var
d=J;for(;;){var
K=t(A,h-1|0);if(t(z,d-1|0)===K){var
B=d-1|0,L=f(g,B)[B+1];f(e,d)[d+1]=L}else{var
C=d-1|0,N=f(e,C)[C+1]+1|0,D=d-1|0,O=f(g,d)[d+1]+1|0,P=f(g,D)[D+1]+1|0,H=hh(P,hh(O,N));f(e,d)[d+1]=H}var
M=d+1|0;if(j===d)break;d=M}}var
x=x;x=e;e=g;g=x;h=h+1|0}}}function
jG(a){var
b=a&15;return 10<=b?87+b|0:48+b|0}var
fT=[c,vT,an(0)];function
fU(a){return[0,[c,vW,an(0)]]}function
jH(a){var
b=a[1],d=eN(b)?Y(b)!==c?1<=b.length-1?b[1]:b:b:b;a:{if(eN(d)&&Y(d)===c){var
e=d[1];break a}var
e=n(ob)}var
f=Y(e)===cV?d:n(oa);return f[2]}var
jI=hq(v1);a:{var
u$=function(a,b,c,d,e,f,g){var
h=E(va,fq)(a),i=E(vd,function(a){return a})(d),j=E(ve,function(a){var
d=cH(0),b=a,c=0;for(;;){if(!b)return d;var
e=b[2];d[c]=r(b[1]);b=e;c=c+1|0}})(e);return dL([0,h,[0,[0,[0,vb,b]],[0,[0,[0,vc,c]],[0,i,[0,j,[0,E(vf,function(a){return a})(f),0]]]]]])},vl=function(a){switch(a){case
0:return Ay(0);case
1:return Az(0);case
2:return AB(0);case
3:return AA(0);default:return AD(0)}},vm=function(a){switch(a){case
0:return"timeGridWeek";case
1:return"resourceTimelineDay";default:return"resourceTimeGridWeek"}},vS=function(a){var
f=k(a),d=F(2*f|0),c=0,b=0,g=f-1|0;for(;;){if(g<c)return S(d);var
e=t(a,c);aA(d,b,jG(e>>>4|0));aA(d,b+1|0,jG(e));c=c+1|0;b=b+2|0}},vY=function(a,b){return 0},vZ=function(a,b){aD(a,44);return h_(a,0)},v0=function(a,b){return ct(0,ad,a,hA(10,b))};if(jI&&jI[1]!==e){var
dN=1;break a}var
ko=hq(yV);if(ko){if(ko[1]==="dumb"){var
dN=1;break a}}else if(be(n$,yW)){var
dN=1;break a}var
dN=0}var
y8=[0,dN];function
p(a,b){return 1===bc(y8)?ad(a,b):_(s(a)(v4),v3,b,v2)}function
jJ(a,b,c,d){var
k=a?a[1]:vY;if(!d)return j(k,c,0);if(!d[2])return j(b,c,d[1]);var
e=d;for(;;){if(!e)throw h([0,i,v7],1);var
g=e[1],f=e[2];if(f&&!f[2]){var
m=f[1];return d0(s(c)(v6),b,g,v8,b,m)}var
l=e[2];j(s(c)(v5),b,g);e=l}}function
jK(e,b,c){if(!c)return 0;var
d=0;return j(s(b)(v9),function(a,b){return jJ(d,e,a,b)},c)}function
v_(e,b,c){if(!c)return 0;var
d=0;return j(s(b)(v$),function(a,b){return jJ(d,e,a,b)},c)}function
jL(a,b,c,d){return al(s(c)(wa),a,0,b,d)}function
jM(a,b){var
c=fS(0,b[2],b[1]);if(!c)return 0;var
d=[0,vZ];return j(s(a)(we),function(a,b){return ct(d,p,a,b)},c)}function
jN(a,b){var
c=fS(0,b[2],b[1]);return c?j(s(a)(wf),function(a,b){return jK(p,a,b)},c):0}var
fV=-1,jO=[0,-1,fV];function
jP(a,b){if(b[2]<0){var
f=b[1];return j(s(a)(wr),ad,f)}function
c(a,b){if(b[4][1]===b[5][1]){var
c=b[4][1];return g(s(a)(ws),c)}var
d=b[5][1],e=b[4][1];return j(s(a)(wt),e,d)}var
d=b[2]-b[4][2]|0,e=(b[3]-b[5][2]|0)+1|0;if(0===d&&0===e){var
h=b[1];return al(s(a)(wu),ad,h,c,b)}var
i=b[1];return d1(s(a)(wv),ad,i,c,b,d,e)}var
l=[0,[0,wq,fV,fV,jO,jO],wx,ww];function
fW(a){switch(a){case
0:return wA;case
1:return wB;case
2:return wC;case
3:return wD;case
4:return wE;default:return wF}}function
bW(a,b){return a===e?b:eP(wG,[0,a,[0,b,0]])}function
aG(a,b){return bW(a,fW(b))}function
fX(a,b){return p(a,fW(b))}function
jQ(a,b){return p(a,e+b)}var
a$=[c,wH,an(0)];function
wi(a,b){return eQ(b)?g(s(a)(wg),b):ad(a,wh)}function
wj(a,h){var
i=k(h);function
f(a,b,c){var
f=b<i?1:0;if(!f)return f;var
g=c-b|0;if(0===b&&g===k(h))return ad(a,h);var
e=(b+g|0)-1|0;if(e>=b){var
d=b;for(;;){aD(a,t(h,d));var
j=d+1|0;if(e===d)break;d=j}}}aD(a,34);var
c=0,b=0,l=i-1|0;for(;;){if(l<b){f(a,c,b);return aD(a,34)}var
d=b+1|0,e=t(h,b);if(34===e){f(a,c,b);ad(a,wk);c=d;b=d}else{if(14<=e){if(92===e){f(a,c,b);ad(a,wl);c=d;b=d;continue}}else if(9<=e)switch(e-9|0){case
0:f(a,c,b);ad(a,wn);c=d;b=d;continue;case
1:f(a,c,b);ad(a,wo);c=d;b=d;continue;case
4:f(a,c,b);ad(a,wp);c=d;b=d;continue}a:{if(b4!==e&&32<=e){var
j=0;break a}var
j=1}if(j){f(a,c,b);ad(a,g(v(wm),e));c=d;b=d}else
b=d}}}var
wI=0;function
wJ(a,b){function
c(a,b){if(l===b)return 0;var
c=b[1];return j(s(a)(wK),jP,c)}function
d(a,b){var
e=b[2],d=b[1];if(0===e[0]){var
f=e[1],h=f[2],i=f[1],j=d[1],k=d[2];return kv(s(a)(wL),c,h,p,i,c,k,p,j)}var
g=e[1],l=g[2],m=g[1],n=d[1],o=d[2];return kv(s(a)(wM),c,l,jQ,m,c,o,p,n)}if(0===b)return 0;var
f=0,e=ab(b);return j(s(a)(wN),function(a,b){return ct(f,d,a,b)},e)}function
af(c,b){return cu(function(a){throw[0,a$,[0,wI,c,a]]},b)}function
jR(a,b,c){return al(af(a,wT),p,b,fX,c)}function
br(a,b,c){var
d=j(cu(di,w2),wi,c);return al(af(a,w3),p,d,p,b)}function
dO(a,b,c){return al(af(a,w4),wj,c,p,b)}function
dP(a,b,c){return al(af(a,w5),jQ,c,p,b)}function
dQ(a,b){return j(af(a,w6),p,b)}function
cI(a,b){return j(af(a,w7),p,b)}var
J=eR([0,hB]);function
wb(a,b,c,d){var
e=d[2],f=d[1],g=a?a[1]:function(a,b){return ad(a,wd)},h=fS(0,e,f);if(h)var
k=h,i=jK;else
var
k=e,i=v_;return j(s(c)(wc),function(a,b){var
c=b[2],d=b[1];return c?(jL(g,p,a,d),h_(a,0),i(p,a,c)):jL(g,p,a,d)},[0,f,k])}function
cJ(a){return aG(a[1],5)}function
fY(a){var
b=a;a:for(;;)switch(b[0]){case
0:return aG(b[1][1],0);case
1:return aG(b[1][1],1);case
2:return aG(b[1][1],2);case
3:return aG(b[1][1],3);case
4:return jS(b[1]);case
5:return cJ(b[1]);case
6:break a;case
7:var
g=b[1];if(g[1]!==e)return g[1];b=g[3];break;default:var
f=b[1],h=Y(f);if(at===h)b=f[1];else{if(W!==h&&au!==h){b=f;break}b=aM(f)}}var
d=b[1];if(d[1]!==e)return d[1];function
c(a,b,c){if(!c)return a;var
f=c[1],g=d[1]!==e?fY(f):aG(d[1],b);return[0,g,a]}var
i=c(0,5,d[8]),j=c(i,4,d[7]),k=c(j,3,d[6]),l=c(k,2,d[5]),m=c(l,1,d[4]);return"one of "+eP(xa,c(m,0,d[3]))}function
jS(a){return a[1]!==e?aG(a[1],4):eP(w$,[0,w_,[0,fY(a[3]),w9]])}function
jT(a,b,c,d){var
g=cJ(b),e=ab(J[24].call(null,function(a,b,c){return b[1][5]?c:[0,a,c]},c,0));function
h(a,b){return al(s(a)(wU),p,b,jM,[0,b,d])}if(e&&!e[2]){var
f=e[1];return d1(af(a,wW),p,f,p,g,jM,[0,f,d])}var
i=0;return al(af(a,wV),p,g,function(a,b){return ct(i,h,a,b)},e)}var
jU=fU(0),fZ=eR([0,oq]);function
bX(a,b,c){var
d=jH(a);return fZ[2].call(null,d,[0,a,b],c)}function
f0(a,b){if(0===a[0])return a[1];var
e=a[2],m=a[1],j=jH(e),c=fZ[18].call(null,j,b);if(c){var
d=c[1],k=d[2],l=e[1]===d[1][1]?vX:0;if(!l)throw h([0,i,xe],1);var
f=[0,k]}else
var
f=0;var
n=hr(f);return g(f0(m,b),n)}function
jV(a,b,c){if(!a[1])return[0,b,c];var
e=b[1];if(e){var
f=e[1];if(typeof
f!=="number"){var
d=f[1],h=g(d[5],0),i=j(d[7],l,h);return[0,a,bX(d[4],i,c)]}}return[0,a,c]}function
cK(a){return l}function
T(a,b,c,d,e,f){var
g=a?a[1]:xg,j=b?b[1]:xf,k=e?e[1]:cK;if(c)var
h=c[1];else
var
n=bW(g,dR),h=function(a,b){return dQ(a,n)};if(d)var
i=d[1];else
var
m=bW(g,dR),i=function(a){return cI(l,m)};return[0,g,j,h,i,k]}var
f1=[0,xi,xh,function(a,b){return b},function(a){return a},cK],bs=[0,jW,xj,function(a,b){return 0},function(a){return cI(l,bW(jW,dR))},cK];function
cL(a,b,c,d,e,f,g,h,i,j){var
k=a?a[1]:xm;if(!i)bW(k,xl)}function
cM(a,b,c){if(eQ(c))return;return jR(a,aG(b,2),0)}var
f2=[2,f1],xd=fZ[1],jY=[3,T([0,f3],0,[0,function(a,b){var
c=hk(b);return c?c[1]:dO(a,f3,b)}],[0,hj],0,0)];cL([0,f3],0,[0,f2],0,[0,f2],[0,jY],0,0,[0,function(a){return eQ(a)?f2:jY}],0);T([0,j0],0,[0,function(a,b){var
c=hk(b);return c?c[1]:dO(a,j0,b)}],[0,function(a){return g(v(xn),a)}],0,0);T([0,dS],0,[0,function(a,b){cM(a,dS,b);var
c=0.<=b?1:0,d=c?b<=255.?1:0:c;return d?b|0:br(a,dS,b)}],[0,function(a){return 0===(a&-256)?a:dP(l,dS,a)}],0,0);T([0,dT],0,[0,function(a,b){cM(a,dT,b);var
c=0.<=b?1:0,d=c?b<=65535.?1:0:c;return d?b|0:br(a,dT,b)}],[0,function(a){return 0===(a&-65536)?a:dP(l,dT,a)}],0,0);T([0,dU],0,[0,function(a,b){cM(a,dU,b);var
c=-128.<=b?1:0,d=c?b<=127.?1:0:c;return d?b|0:br(a,dU,b)}],[0,function(a){var
b=-128<=a?1:0,c=b?a<=b4?1:0:b;return c?a:dP(l,dU,a)}],0,0);T([0,dV],0,[0,function(a,b){cM(a,dV,b);var
c=-32768.<=b?1:0,d=c?b<=32767.?1:0:c;return d?b|0:br(a,dV,b)}],[0,function(a){var
b=-32768<=a?1:0,c=b?a<=32767?1:0:b;return c?a:dP(l,dV,a)}],0,0);T([0,f4],0,[0,function(a,b){cM(a,f4,b);var
c=la<=b?1:0,d=c?b<=kC?1:0:c;return d?b|0:br(a,f4,b)}],[0,function(a){return a}],0,0);var
ks=[3,T([0,j1],0,[0,function(a,b){try{var
e=[0,gV(b)],c=e}catch(f){var
d=C(f);if(d[1]!==bJ)throw h(d,0);var
c=0}return c?c[1]:dO(a,j1,b)}],[0,oD],0,0)],jX=[2,T([0,j2],0,[0,function(a,b){var
c=-9007199254740992.<=b?1:0,d=c?b<=9007199254740992.?1:0:c;return d?nC(b):br(a,j2,b)}],[0,zV],0,0)],wy=aB(0,0,32),wz=aB(0,0,mg);cL(xo,0,0,0,[0,jX],[0,ks],0,0,[0,function(a){var
b=gR(wz,a)<=0?1:0,c=b?gR(a,wy)<=0?1:0:b;return c?jX:ks}],0);var
kr=[3,T([0,j3],0,[0,function(a,b){try{var
e=[0,aa(b)],c=e}catch(f){var
d=C(f);if(d[1]!==bJ)throw h(d,0);var
c=0}return c?c[1]:dO(a,j3,b)}],[0,os],0,0)],kq=[2,T([0,j4],0,[0,function(a,b){var
c=la<=b?1:0,d=c?b<=kC?1:0:c;return d?b|0:br(a,j4,b)}],[0,function(a){return a}],0,0)];cL(xp,0,0,0,[0,kq],[0,kr],0,0,[0,function(a){var
b=-2147483648<=a?1:0,c=b?a<=lt?1:0:b;return c?kq:kr}],0);var
ap=[3,f1],xk=bW(aG(j5,3),dR);T([0,j5],0,[0,function(a,b){function
l(a,b){var
c=t(a,b);if(65<=c){if(97<=c){if(gm>c)return 10+(c+d2|0)|0}else if(71>c)return 10+(c+li|0)|0}else if(9>=c+eg>>>0)return c+eg|0;throw[0,fT,b]}try{var
f=k(b);if(0!==(f%2|0))throw h([0,fT,f],1);var
m=f/2|0,n=F(m),e=0,d=0,s=m-1|0;for(;;){if(s<e){var
q=[0,S(n)],c=q;break}var
r=l(b,d);aA(n,e,og(r<<4|l(b,d+1|0)));e=e+1|0;d=d+2|0}}catch(f){var
g=C(f);if(g[1]!==fT)throw h(g,0);var
i=g[2];if(i===k(b))var
c=vU;else
var
o=t(b,i),c=[1,j(v(vV),i,o)]}if(0===c[0])return c[1];var
u=c[1];return _(af(a,w8),p,xk,u)}],[0,vS],0,0);function
dW(a){return aG(a,4)}function
xq(a,b){return 0}function
f5(a,b,c,d,e,f,g,h,i){var
j=a?a[1]:xs,k=b?b[1]:xr,m=h?h[1]:cK,n=c?c[1]:function(a){return dQ(l,dW(j))},o=d?d[1]:xq,p=e?e[1]:function(a,b,c){return dQ(l,dW(j))},q=f?f[1]:function(a,b,c){return dQ(l,dW(j))},r=g?g[1][1]:function(a,b,c){return cI(l,dW(j))};return[0,j,k,i,n,o,p,q,r,m]}function
j6(a,b,c){var
f=b,e=0,d=c;for(;;){if(!d)return f;var
g=d[2];f=_(a,f,e,d[1]);e=e+1|0;d=g}}var
xx=aG(j8,4),j7=[4,f5([0,j8],0,[0,function(a){return 0}],[0,function(a,b){return 1}],[0,function(a,b,c){return 0}],[0,function(a,b,c){return 0}],[0,[0,function(a,b,c){return cI(l,xx)}]],0,[7,[0,xw,xv,[0,f1],function(a){throw h([0,i,xu],1)},function(a){throw h([0,i,xt],1)}]])];function
bY(a,b,c){return[4,f5(a,b,[0,function(a){return 0}],0,[0,function(a,b,c){return[0,b,c]}],[0,function(a,b,c){return ab(c)}],[0,[0,j6]],0,c)]}function
j9(a,b,c,d){var
e=a?a[1]:xA,f=b?b[1]:xz,g=c?c[1]:cK;return[0,e,f,d,J[1],0,g,xy]}function
bZ(a,b,c){return j9(a,b,0,[0,c])}function
bt(a){function
k(a,b,c){if(!c)return[0,b];function
f(a){var
c=5;return b!==e?b:fW(c)}var
h=c[1],d=f(b),g=f(h),i=d===g?j(cu(di,xB),a,d):_(cu(di,xC),a,d,g);return n(i)}function
f(a,e){function
g(a,b){var
c=e[1];return J[4].call(null,b,function(a){return k(b,c,a)},a)}var
d=a,b=e[5];for(;;){if(!b)break;var
j=b[2];d=g(d,b[1][1][1]);b=j}var
h=e[7];if(0===h[0])return;var
i=h[2],l=g(d,i[1][1]),c=i[5];for(;;){if(!c)return;var
m=c[2];f(l,c[1][1][2]);c=m}}f(J[1],a);var
b=a[7],c=a[6],d=ab(a[5]);return[5,[0,a[1],a[2],a[3],a[4],d,c,b]]}function
U(a,b,c,d,e,f,g){var
o=a?a[1]:xE,k=fU(0),m=c?c[1]:function(a){return j(af(l,xD),p,e)};if(d)var
i=d[1];else
var
n=0,i=function(a){return n};var
h=[0,e,o,f,k,b,m,i],q=J[2].call(null,e,[0,h],g[4]);return[0,g[1],g[2],[1,g[3],h[4]],q,[0,[0,h],g[5]],g[6],g[7]]}var
j_=bt(bZ(xI,0,0));cL([0,j$],0,[0,[0,bs]],[0,[1,bs]],[0,[2,bs]],[0,[3,bs]],[0,j7],[0,j_],[0,function(a){return cI(l,j$)}],0);var
xK=0,jZ=[0,T(0,0,[0,function(a,b){return xK}],[0,function(a){return 0}],0,0)];cL([0,xJ],0,[0,jZ],[0,[1,bs]],[0,[2,bs]],[0,[3,bs]],[0,j7],[0,j_],[0,function(a){return jZ}],0);function
b0(a){return a[1][2]}function
bu(a,b){switch(b[0]){case
0:var
c=0;break;case
1:var
c=1;break;case
2:var
c=2;break;case
3:var
c=3;break;case
4:var
c=4;break;default:var
c=5}return al(af(b0(b),wS),fX,a,fX,c)}var
ka=[0,T(0,0,[0,function(a,b){return[0,[0,0,a]]}],[0,function(a){return 0===a[0]?0:bu(0,a)}],[0,b0],0)],kb=[1,T(0,0,[0,function(a,b){return[1,[0,b,a]]}],[0,function(a){return 1===a[0]?a[1][1]:bu(1,a)}],[0,b0],0)],kc=[2,T(0,0,[0,function(a,b){return[2,[0,b,a]]}],[0,function(a){return 2===a[0]?a[1][1]:bu(2,a)}],[0,b0],0)],kd=[3,T(0,0,[0,function(a,b){return[3,[0,b,a]]}],[0,function(a){return 3===a[0]?a[1][1]:bu(3,a)}],[0,b0],0)],f6=[],cN=[],bv=[],bw=[],bx=[],dX=[];cc(f6,[8,dX]);cc(cN,[W,function(a){return f5(0,0,[0,function(a){return 0}],0,[0,function(a,b,c){return[0,b,c]}],[0,function(a,b,c){return[4,[0,ab(c),a]]}],[0,[0,function(a,b,c){return 4===c[0]?j6(a,b,c[1][1]):bu(4,c)}]],[0,b0],f6)}]);cc(bv,[W,function(a){var
b=Y(cN);a:if(at===b)var
c=cN[1];else{if(W!==b&&au!==b){var
c=cN;break a}var
c=aM(cN)}return[4,c]}]);cc(bw,[W,function(a){return[0,xG,xF,f6,fU(0),function(a){return 0},function(a,b,c,d){return[0,[0,[0,b,a],c],d]},function(a,b){return ab(b)},function(a,b,c){var
d=b,e=c;for(;;){if(!d)return e;var
g=d[1],f=g[1],h=d[2];d=h;e=al(a,f[2],f[1],g[2],e)}}]}]);cc(bx,[W,function(a){var
b=j9(0,0,[0,function(a){return 5===a[0]?a[1][2]:bu(5,a)}],[1,[0,function(a,b){return[5,[0,b,a]]}],jU]),f=Y(bw);a:{var
k=function(a){return 5===a[0]?a[1][1]:bu(5,a)};if(at===f)var
d=bw[1];else{if(W!==f&&au!==f){var
d=bw;break a}var
d=aM(bw)}}var
i=k,h=[0,d,i],c=b[7];a:{b:{var
j=[1,b[3],d[4]];if(0!==c[0]){var
g=c[1];if(g&&typeof
g[1]!=="number")break b;var
e=[1,[0,h],c[2]];break a}if(typeof
c[1]==="number"){var
e=[0,h];break a}}var
e=n(xH)}return bt([0,b[1],b[2],j,b[4],b[5],b[6],e])}]);cc(dX,[W,function(a){var
d=Y(bv);a:if(at===d)var
b=bv[1];else{if(W!==d&&au!==d){var
b=bv;break a}var
b=aM(bv)}var
e=Y(bx);a:if(at===e)var
c=bx[1];else{if(W!==e&&au!==e){var
c=bx;break a}var
c=aM(bx)}return[6,[0,xM,xL,[0,ka],[0,kb],[0,kc],[0,kd],[0,b],[0,c],function(a){switch(a[0]){case
0:return ka;case
1:return kb;case
2:return kc;case
3:return kd;case
4:return b;default:return c}}]]}]);var
f7=Y(bx);a:{var
wO=function(a,b){var
c=b[3],d=b[2],e=b[1];return d1(s(a)(wQ),v0,c,function(a,b){var
c=1-(l===b?1:0);if(!c)return c;var
d=b[1];return j(s(a)(wP),jP,d)},d,wJ,e)},xb=function(a,b,c,d){var
i=cJ(b),k=eO(function(a){var
b=c[3],d=a[1];return b?[0,g(b[1],d[1])]:0},c[5]),e=c[3],l=e?g(e[1],d):xc,m=c[1][1],f=0,h=[0,function(a,b){return al(s(a)(w0),p,m,p,i)}];return j(af(a,w1),function(a,b){return wb(h,f,a,b)},[0,l,k])};if(at!==f7){if(W!==f7&&au!==f7)break a;aM(bx)}}var
f8=Y(bw);a:if(at!==f8){if(W!==f8&&au!==f8)break a;aM(bw)}var
f9=Y(bv);a:if(at!==f9){if(W!==f9&&au!==f9)break a;aM(bv)}var
f_=Y(dX);a:if(at!==f_){if(W!==f_&&au!==f_)break a;aM(dX)}b.JSON;b.Array;var
xO="boolean",xP=lv,xQ=mu,xR=l4;function
by(a){if(a===aZ)return 0;var
c=typeof
a;return a3(c,xO)?1:a3(c,xQ)?2:a3(c,xR)?3:a3(c,xP)?b.Array.isArray(a)|0?4:5:g(af(l,xS),B(c))}function
ke(a){return b.Object.keys(a)}function
f$(a,b,c){var
d=[0,cJ(a),l];throw[0,a$,[0,[0,[0,d,[0,[0,b,l]]],c[1]],c[2],c[3]]]}function
bz(a,b){return jR(l,fY(a),b)}function
bA(a,b){a:{b:{var
c=a;c:for(;;)switch(c[0]){case
0:var
L=c[1],x=by(b);return x?bz(c,x):j(L[3],l,0);case
1:var
M=c[1],y=by(b);return 1===y?j(M[3],l,b|0):bz(c,y);case
2:var
z=c[1],q=by(b);if(3>q)switch(q){case
0:return j(z[3],l,n5);case
2:return j(z[3],l,b)}return bz(c,q);case
3:var
N=c[1],A=by(b);return 3===A?j(N[3],l,B(b)):bz(c,A);case
4:break a;case
5:break b;case
6:break c;case
7:var
G=c[1],O=bA(G[3],b);return g(G[4],O);default:var
n=c[1],r=Y(n);if(at===r)c=n[1];else{if(W!==r&&au!==r){c=n;break}c=aM(n)}}var
f=c[1],k=function(a,b,c,d){return b?bA(b[1],d):bz(a,c)},e=by(b);switch(e){case
0:return k(c,f[3],e,b);case
1:return k(c,f[4],e,b);case
2:return k(c,f[5],e,b);case
3:return k(c,f[6],e,b);case
4:return k(c,f[7],e,b);default:return k(c,f[8],e,b)}}var
E=c[1],F=by(b);if(5>F)return bz(c,F);var
w=ke(b),m=0,p=J[1],K=w.length-1|0;for(;;){if(K<m){var
U=kf(E,xT,J[1],xd,p,b);return f0(E[3],U)}var
v=w[m];m=m+1|0;p=J[2].call(null,B(v),v,p)}}var
i=c[1],D=by(b);if(4!==D)return bz(c,D);var
u=b.length,o=[0,g(i[4],0)],H=u-1|0,P=0;if(H>=0){var
d=P;for(;;){try{if(!j(i[5],d,o[1])){var
R=o[1],S=b[d],T=bA(i[3],S);o[1]=_(i[6],d,T,R)}}catch(f){var
s=C(f);if(s[1]!==a$)throw h(s,0);var
t=s[2],I=[0,jS(i),l];throw[0,a$,[0,[0,[0,I,[1,[0,d,l]]],t[1]],t[2],t[3]]]}var
Q=d+1|0;if(H===d)break;d=Q}}return _(i[7],l,u,o[1])}function
kf(m,b,c,d,e,f){var
n=J[8].call(null,function(a,b,c){throw h([0,i,xU],1)},c,m[4]),o=m[7];if(0!==o[0]){var
k=o[2],t=jV(b,[0,o[1]],d),y=t[2],z=t[1],u=function(a){var
b=k[5];for(;;){if(b){var
h=b[1],o=b[2];if(0!==j(k[2],h[1][1],a)){b=o;continue}var
c=[0,h]}else
var
c=0;if(!c)return xb(l,m,k,a);var
d=c[1][1],p=J[6].call(null,k[1][1],e),i=kf(d[2],z,n,y,p,f),q=f0(d[2][3],i),r=g(d[3],q);return bX(k[4],r,i)}},v=J[18].call(null,k[1][1],e);if(v){var
A=v[1];try{var
B=f[A],D=u(bA(k[1][3],B));return D}catch(f){var
q=C(f);if(q[1]===a$)return f$(m,k[1][1],q[2]);throw h(q,0)}}var
w=k[1][5];if(w)return u(w[1]);var
E=J[5].call(null,k[1][1],[0,k[1]]);return jT(l,m,E,iQ(iR,ke(f)))}var
r=jV(b,[0,[0,o[1]]],d),p=r[2],s=r[1][1];if(s){var
a=s[1];if(typeof
a!=="number"){var
x=g(a[1][5],0);return ga(m,a,x,n,p,J[10].call(null,e),f)}if(a)return ga(m,a,0,n,p,J[10].call(null,e),f)}return ga(m,0,0,n,p,J[10].call(null,e),f)}function
ga(a,b,c,d,e,f,g){a:{var
q=c,k=d,o=e,i=f;for(;;){if(!i)break;var
n=i[2],D=i[1],E=D[2],m=D[1],F=J[18].call(null,m,k);if(F){var
G=F[1][1];try{var
R=g[E],S=bA(G[3],R),T=bX(G[4],S,o),H=T}catch(f){var
r=C(f);if(r[1]!==a$)throw h(r,0);var
H=f$(a,m,r[2])}k=J[6].call(null,m,k);o=H;i=n}else if(typeof
b==="number"){if(b)break a;i=n}else{var
I=b[1];try{var
U=g[E],V=bA(I[3],U),K=V}catch(f){var
u=C(f);if(u[1]!==a$)throw h(u,0);var
K=f$(a,m,u[2])}q=al(I[6],l,m,K,q);i=n}}var
y=bX(jU,l,o);if(typeof
b==="number")var
z=y;else
var
B=b[1],Q=j(B[7],l,q),z=bX(B[4],Q,y);var
O=function(a,b,c){var
d=b[1],e=d[5];if(e)return bX(d[4],e[1],c);throw h(hc,1)};try{var
P=J[24].call(null,O,k,z);return P}catch(f){var
A=C(f);if(A===hc)return jT(l,a,J[27].call(null,function(a,b){return b[1][5]?0:1},k),0);throw h(A,0)}}var
t=[0,[0,m,l],eO(function(a){var
b=a[1];return J[18].call(null,b,k)?0:[0,[0,b,l]]},n)],w=cJ(a),x=aw(function(a){return a[1][1]},a[5]);function
L(a,b){return al(s(a)(wX),p,b,jN,[0,b,x])}if(t[2]){var
N=0,M=aw(function(a){return a[1]},t);return al(af(l,wY),p,w,function(a,b){return ct(N,L,a,b)},M)}var
v=t[1][1];return d1(af(l,wZ),p,v,p,w,jN,[0,v,x])}var
xZ=bt(U(0,0,[0,function(a){return a[2]}],0,xY,ap,U(0,0,[0,function(a){return a[1]}],0,xX,ap,bZ(xW,0,function(a,b){return[0,a,b]})))),x3=bt(U(0,0,[0,function(a){return a[2]}],0,x2,ap,U(0,0,[0,function(a){return a[1]}],0,x1,ap,bZ(x0,0,function(a,b){return[0,a,b]})))),x7=bt(U(0,0,[0,function(a){return a[2]}],0,x6,ap,U(0,0,[0,function(a){return a[1]}],0,x5,ap,bZ(x4,0,function(a,b){return[0,a,b]})))),x$=U(0,0,[0,function(a){return a[2]}],0,x_,ap,U(0,0,[0,function(a){return a[1]}],0,x9,ap,bZ(x8,0,function(a,b,c,d,e,f,g){return[0,a,b,c,d,e,f,g]}))),yc=U(0,0,[0,function(a){return a[4]}],0,yb,ap,U(0,0,[0,function(a){return a[3]}],0,ya,bY(0,0,ap),x$)),yg=bt(U(0,0,[0,function(a){return a[7]}],0,yf,ap,U(0,0,[0,function(a){return a[6]}],0,ye,ap,U(0,0,[0,function(a){return a[5]}],0,yd,bY(0,0,ap),yc)))),yi=bZ(yh,0,function(a,b,c,d){return[0,a,b,c,d]}),yk=U(0,0,[0,function(a){return a[1]}],0,yj,bY(0,0,xZ),yi),ym=U(0,0,[0,function(a){return a[2]}],0,yl,bY(0,0,x3),yk),yo=U(0,0,[0,function(a){return a[3]}],0,yn,bY(0,0,x7),ym),yq=bt(U(0,0,[0,function(a){return a[4]}],0,yp,bY(0,0,yg),yo)),yr=AC(0);try{var
xV=[0,bA(yq,yr)],dY=xV}catch(f){var
gb=C(f);if(gb[1]!==a$)throw h(gb,0);var
dY=[1,gb[2]]}if(0===dY[0])var
gc=dY;else
var
of=dY[1],xN=r(j(cu(di,wR),wO,of)),gc=[1,new
b.Error(xN)];function
kg(a){var
b=hx(aJ(a)),c=hH,d=hH,e=uv([0,1],[0,function(a){a[9]=1;return 0},b,ah(b),0,0,0,0,0,1,[0],d,c])[1]/d6+mj;return jw(e,bq[1],0)}function
gd(a){var
i=(jx(a)-mj)*d6;il(0);var
d=g9(i-0.),e=s(bl)(ux),c=0,h=s(bl)(uy);for(;;){if(c===17)return il(0);var
f=t(mJ,c);if(37===f){var
b=t(mJ,c+1|0);a:{if(89<=b){if(91>b){if(90<=b){g(s(bl)(uA),0.);break a}g(h,d[6]+ej|0);break a}if(lp<=b){if(mQ===b){g(s(bl)(uz),0.);break a}}else if(lF<=b)switch(b-104|0){case
0:g(e,d[3]);break a;case
5:g(e,d[2]);break a;case
11:g(e,d[1]);break a}}else{if(37===b){aD(bl,37);break a}if(68===b){g(e,d[4]);break a}if(77===b){g(e,d[5]+1|0);break a}}ce("Bad format: %"+ch(1,b))}c=c+2|0}else{aD(bl,f);c=c+1|0}}}var
bP=eR([0,hB]),aE=bP[1],bm=bP[2],cv=bP[17],ip=bP[18],cw=bP[24];function
dp(a){return cw(function(a,b,c){return[0,[0,a,b],c]},a,0)}function
b1(a){switch(a[0]){case
0:var
b=a[1][1];return g(v(ys),b);case
1:var
c=a[1][1];return g(v(yt),c);default:var
d=a[1][1];return g(v(yu),d)}}function
kh(a){var
b=a[2],c=a[1],d=[0,cw(function(a,b,c){var
d=b1([2,b]);return[0,fP(d,[0,r(b[2])],0,0,0,0),c]},a[3],0),0],e=[0,cw(function(a,b,c){var
d=b1([1,b]);return[0,fP(d,[0,r(b[2])],0,0,0,0),c]},b,0),d];return bg([0,cw(function(a,b,c){var
d=b1([0,b]);return[0,fP(d,[0,r(b[2])],0,0,0,0),c]},c,0),e])}function
ki(a,b,c){var
e=a?a[1]:0,d=dt(0,c);du(d,function(a){return g(b,a8(d))});var
f=a8(d);return e?g(b,f):e}var
rJ=bP[11],ay=function(a){if(0!==gc[0])return[0,aE,aE,aE,aE];var
e=gc[1],l=e[1],k=aE,z=e[4],A=e[3],B=e[2];for(;;){if(!l){var
j=B,i=aE;break}var
x=l[1],J=l[2];l=J;k=bm(x[1],x,k)}for(;;){if(!j){var
h=A,g=aE;break}var
w=j[1],I=j[2];j=I;i=bm(w[1],w,i)}for(;;){if(!h){var
f=z,o=aE;break}var
v=h[1],H=h[2];h=H;g=bm(v[1],v,g)}for(;;){if(!f)return[0,k,i,g,o];var
b=f[1],q=b[6],r=b[1],G=f[2],C=b[2],D=kg(b[7]),E=kg(q),m=0,c=b[5];for(;;){if(!c)break;var
p=c[2],s=ip(c[1],g);if(s){m=[0,s[1],m];c=p}else
c=p}var
y=ab(m),F=cv(b[4],i),d=b[3],n=0;for(;;){if(!d){f=G;o=bm(q+r,[0,r,C,ab(n),F,y,E,D],o);break}var
u=d[2],t=ip(d[1],k);if(t){d=u;n=[0,t[1],n]}else
d=u}}}(0),y0=ir(yw,i5(0,"#filters")),y1=ir(yx,i5(0,"#calendar")),kj=rJ(ay[4])[2],yy=dM(0,0,0,[0,fL(kj[6])*60|0],0,0),kk=fO(gd(kj[6])),kl=dM(0,0,yz,0,0,0);fx([0,yB,[0,kk,[0,yA,[0,kl,0]]]]);var
y7=[0,cB(aY,cF,[0,yC,aw(function(a){return[0,a[1],a[2][2]]},dp(ay[3]))])];function
jn(a){return function(a){}}var
s7=yD[1],fE=jl(1,cO[1]);function
yv(a){var
b=a[5],c=a[3],d=[0,[0,b1([1,a[4]]),0],0],e=[0,aw(function(a){return b1([2,a])},b),d];return bg([0,aw(function(a){return b1([0,a])},c),e])}var
s$=0,s_=0,s8=jl(0,cO[1]),a_=s7?ji(fE,cO[2]):cz(cO[2]);if(1===a_[0]){var
iy=a_[4];if(5===iy[0]){var
rY=iy[1];jn(1)(rY);ae(0,[0,[0,[0,80,[0,i1,r(fE)]],0]],0,0,i9,cO[3]);var
jm=[0,0],yZ=bV(ft,s9,bV(i3,[0,80,s8],bV(i2,[0,80,fE],s$))),y5=ae(0,[0,yZ],[0,[0,[0,80,[0,0,fs,function(a){var
b=B(a.target.value);jn(0)(b);return ax(a_,b)}]],s_]],[0,function(a){jm[1]=[0,a];return 0}],sL,[0,[0,83,cG(bS(function(a){var
b=a[1],e=a[2],c=jj([0,80,[1,[0,i4,r(b)]]],0),d=jj([0,82,D(a_,function(a){return[1,i0(a===b?1:0,y9)]})],c);return ae(0,[0,d],0,0,sJ,[0,[0,80,a9(0,e)],0])},y7))],0]);fB(0,function(a){var
b=jm[1];return b?b[1].value=r(a):0},a_);var
y2=aw(function(a){var
b=a[2][2];return[0,[0,[0,kV,a[1]],b,b,function(a){return[0,[0,80,a9(0,b)],0]},1]]},dp(ay[1])),y3=aw(function(a){var
b=a[2][2];return[0,[0,[0,-675584857,a[1]],b,b,function(a){return[0,[0,80,a9(0,b)],0]},0]]},dp(ay[2])),km=ta(0,[0,[0,[0,80,[0,aF,"categories_select"]],0]],[0,yE,[0,cB(aY,cF,bg([0,y2,[0,y3,[0,aw(function(a){var
b=a[2][2];return[0,[0,[0,lI,a[1]],b,b,function(a){return[0,[0,80,a9(0,b)],0]},0]]},dp(ay[3])),0]]]))]]),y4=ae(0,0,0,0,bp,[0,[0,82,y5],[0,[0,82,km[1]],0]]),vn={start:r(yL[1]),center:r(yK[1]),end:r(yJ[1])},yM=dM(0,0,0,[0,300],0,0),yN=[0,dM(0,0,0,[0,1740],0,0)],vo=yR[1],vq=E(vp,vm)(0),vs=E(vr,function(a){return a})([0,kk]),vu=E(vt,function(a){return a})([0,kl]),vw=E(vv,function(a){return a})([0,yy]),vy=E(vx,b$)(yQ),vA=E(vz,b$)(yP),vC=E(vB,b$)(yO),vE=E(vD,b$)(0),vG=E(vF,b$)(0),vI=E(vH,b$)(0),vL=E(vK,function(a){return a})([0,vn]),vN=E(vM,function(a){return a})(yN),vP=dL([0,vq,[0,vs,[0,vu,[0,vw,[0,vy,[0,vA,[0,vC,[0,vE,[0,vG,[0,vI,[0,[0,[0,vJ,eA(1,function(a){var
h=a.event,G=B(h.id);iQ(iR,h.resourceIds);h.extendedProps;var
b=cv(G,ay[4]),d=b[5],c=0;for(;;){if(!d)break;var
o=d[2],p=d[1],k=dG(0,[0,[0,[0,sC,e],0]],sG,[0,a9(0,p[2]),0]);let
b=p;fr(0,iT,function(a){a.preventDefault();return ax(a_,b[1])},k);var
q=c?0:1;if(q){d=o;c=[0,k,0]}else{d=o;c=hw([0,a9(0,yF),[0,k,0]],c)}}var
r=fL(b[6]),s=jz(b[6]),t=j(v(yG),r,s),u=fL(b[7]),x=jz(b[7]),y=j(v(yH),u,x),z=j(v(yI),t,y);a.timeText;var
A=hv(hA(32,hv(b[3])[2])),C=[0,dG(0,0,sK,c),0],g=aJ(b[2]),D=0;if(0===ah(g))var
m=g;else{var
l=hx(g);w(l,0,hu(bd(g,0)));var
m=l}var
E=[0,dG(0,0,sH,[0,a9(0,z+as+A+as+S(m)),D]),C],n=cH(0),f=E,i=0;for(;;){if(!f)return{domNodes:n};var
F=f[2];n[i]=f[1];f=F;i=i+1|0}})]],[0,vL,[0,vN,[0,E(vO,function(a){return a})([0,yM]),0]]]]]]]]]]]]]]),jF={target:y1,props:{plugins:g0(aw(vl,vo)),options:vP}};fx([0,nW(0),[0,jF,0]]);var
fQ=new(nW(0))(jF);fR(fQ,1,kh(ay));var
sQ=bU.history,fp=i_(bU).hash,sA=dE(fp)?fp:fp.slice(sz[1]),iY=new
iX(sA).get(k$),kn=bT(iY)?0:[0,iY];if(kn)ax(a_,B(kn[1]));ki(yT,function(c){fx([0,yS,[0,c,0]]);var
f=c!==gw?[0,function(a){var
b=a[5];for(;;){if(!b)return 0;var
d=b[1][1]===c?1:0,e=b[2];if(d)return d;b=e}}]:0,i=i_(bU),b=new
iX(e),a=[0,[0,k$,r(c)],0];for(;;){if(!a)break;var
g=a[1],j=a[2];b.append(g[1],g[2]);a=j}var
d=new
iW(i);d.hash=b.toString();sQ.replaceState(aZ,e,d);var
h=f?f[1]:function(a){return 1};return fR(fQ,0,cw(function(a,b,c){var
d=b[7],e=b[6];if(!h(b))return c;var
f=fO(gd(e)),g=fO(gd(d));return[0,u$([0,a],f,g,0,[0,yv(b)],[0,r(a)],0),c]},ay[4],0))},a_);ki(yU,function(a){var
c=aw(function(a){return a[1]},dD(a)),b=[0,aE,aE,aE];for(;;){if(!c)return fR(fQ,1,kh([0,b[1],b[2],b[3],ay[4]]));var
h=c[2],d=c[1],i=d[1],e=b[3],f=b[2],g=b[1];if(kV===i){var
j=d[2];c=h;b=[0,bm(j,cv(j,ay[1]),g),f,e]}else if(lI<=i){var
k=d[2];c=h;b=[0,g,f,bm(k,cv(k,ay[3]),e)]}else{var
l=d[2];c=h;b=[0,g,bm(l,cv(l,ay[2]),f),e]}}},km[4]);var
y6=ae(0,0,0,0,bp,[0,[0,82,y4],0]);fr(0,sw,function(a){var
c=dt(0,y6);gX(y0,kU,hD([0,a8(c),0]));return du(c,function(a){b.requestAnimationFrame(eA(1,function(a){a8(c);return 0}));return 0})},bU);eM(0);return}}throw h([0,i,rX],1)}(globalThis));
